<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="31"></ucMenu>
          <div class="right_con">
            <div class="rc_main">
              <p class="fb">云商品库</p>
              <el-tabs v-model="activeTab" @tab-click="handleTabChange">
                <!-- Tab 1: 商品导入 -->
                <el-tab-pane label="商品导入" name="import">
                  <div class="op_box import-op-box">
                    <div class="op-left-actions">
                      <el-button type="primary" @click="handleAdd" size="small">新增商品</el-button>
<!--                      <el-button type="primary" plain class="doudian-sync-entry" @click="handleDoudianSyncOpen" size="small">-->
<!--                        <i class="el-icon-refresh"></i>同步抖店商品-->
<!--                      </el-button>-->
                    </div>
                    <el-button @click="handleRefresh" size="small"><i class="el-icon-refresh-right el-icon--right"></i>刷新列表</el-button>
                  </div>
                  <div class="table-container">
                    <el-table
                      v-loading="loading"
                      :data="tableData"
                      :header-cell-style="importHeaderCellStyle"
                      :cell-style="importCellStyle"
                      class="rc_table import_table"
                      highlight-current-row
                      row-key="id"
                      table-layout="fixed"
                    >
                      <el-table-column label="批次号" prop="batch_no" align="center" min-width="120">
                        <template #default="{ row }">
                          <div class="text-ellipsis" :title="row.batch_no">{{row.batch_no}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="文件名" prop="file_name" align="center" min-width="200">
                        <template #default="{ row }">
                          <div class="text-ellipsis" :title="row.file_name">{{row.file_name}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="数量" header-align="center" align="center" width="120">
                        <template #default="{ row }">
                          <div class="quantity-info">
                            <div>导入：{{row.total_count}}</div>
                            <div>成功：{{row.success_count}}</div>
                            <div>失败：{{row.fail_count}}</div>
                            <div>重复：{{row.duplicate_count}}</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="商品来源" prop="source_web" align="center" min-width="100">
                        <template #default="{ row }">
                          <div>{{row.source_web ? sourceList.find(i => i.value == row.source_web)?.label : ''}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="进度" prop="progress_percent" align="center" ></el-table-column>
                      <el-table-column label="状态" align="center" width="80">
                        <template #default="{ row }">
                          <el-tag :type="statusTag[row.status]" size="small">{{row.status_text}}</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="时间" prop="created_at" align="center" min-width="100">
                        <template #default="{ row }">
                          <div class="text-ellipsis" :title="row.created_at">{{row.created_at}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" align="center" width="80">
                        <template #default="{ row }">
                          <el-button type="primary" @click="handleView(row)" size="mini">查看</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getDataList" v-if="page_data.total > 0" layout="total, sizes, prev, pager, next, jumper" />
                </el-tab-pane>

                <!-- Tab 2: 云商品列表 -->
                <el-tab-pane label="云商品列表" name="list">
                  <div class="filter-box cloud-filter-box">
                    <div class="search-row">
                      <el-form inline size="small">
                        <el-form-item label="批次号">
                          <el-input v-model="cloudSearchParams.batch_no" placeholder="请输入批次号" clearable style="width: 150px;"></el-input>
                        </el-form-item>
                        <el-form-item label="关键词">
                          <el-input v-model="cloudSearchParams.keyword" placeholder="请输入商品标题" clearable style="width: 150px;"></el-input>
                        </el-form-item>
                        <el-form-item label="来源ID">
                          <el-input v-model="cloudSearchParams.source_product_id" placeholder="请输入来源ID" clearable style="width: 150px;"></el-input>
                        </el-form-item>
                        <el-form-item label="铺货平台ID">
                          <el-input v-model="cloudSearchParams.platform_product_id" placeholder="请输入铺货平台ID" clearable style="width: 150px;"></el-input>
                        </el-form-item>
                        <el-form-item label="sku替换状态">
                          <el-select v-model="cloudSearchParams.sku_status" placeholder="全部" clearable @change="handleFilterChange" size="small">
                            <el-option v-for="item in Object.keys(skuStatus)" :key="item" :label="skuStatus[item].label" :value="skuStatus[item].value"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="商品标记状态">
                          <el-select v-model="cloudSearchParams.sku_mark_status" placeholder="全部" clearable @change="handleFilterChange" size="small">
                            <el-option v-for="item in Object.keys(skuMarkStatus)" :key="item" :label="skuMarkStatus[item].label" :value="skuMarkStatus[item].value"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="标题替换状态">
                          <el-select v-model="cloudSearchParams.ai_title_status" placeholder="全部" clearable @change="handleFilterChange" size="small">
                            <el-option v-for="item in Object.keys(aiTitleStatus)" :key="item" :label="aiTitleStatus[item].label" :value="aiTitleStatus[item].value"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="数据源">
                          <el-select v-model="cloudSearchParams.source_web" placeholder="全部" clearable @change="handleFilterChange" size="small" style="width: 120px;">
                            <el-option label="1688" :value="2"></el-option>
                            <el-option label="TB" :value="3"></el-option>
                            <el-option label="PDD" :value="4"></el-option>
                            <el-option label="DY（调研中）" :value="5"></el-option>
                            <el-option label="WX" :value="6"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="是否包邮">
                          <el-select v-model="cloudSearchParams.distribution_free_postage" placeholder="全部" clearable @change="handleFilterChange" size="small" style="width: 120px;">
                            <el-option label="包邮" value="1"></el-option>
                            <el-option label="不包邮" value="0"></el-option>
                            <el-option label="未知" value="unknown"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="运费显示省份">
                          <el-select v-model="cloudSearchParams.freight_province_code" placeholder="选择后新增运费显示" clearable @change="handleFilterChange" size="small" style="width: 160px;">
                            <el-option v-for="province in provinceOptions" :key="province.value" :label="province.label" :value="province.value"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="价格区间">
                          <el-input v-model="cloudSearchParams.min_price" inputmode="decimal" placeholder="最低价" clearable style="width: 100px;"></el-input>
                          <span class="price-range-separator">-</span>
                          <el-input v-model="cloudSearchParams.max_price" inputmode="decimal" placeholder="最高价" clearable style="width: 100px;"></el-input>
                        </el-form-item>
                        <el-form-item label="排除已铺货">
                          <el-select v-model="cloudSearchParams.exclude_distributed" placeholder="不排除" multiple collapse-tags clearable @change="handleExcludeFilterChange" size="small" style="width: 200px;">
                            <el-option label="排除全部已铺货" value="all"></el-option>
                            <el-option v-for="shop in excludeShopList" :key="shop.shop_id" :label="shop.shop_name" :value="String(shop.shop_id)" :disabled="cloudSearchParams.exclude_distributed.includes('all')"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="铺货状态" v-if="cloudSearchParams.exclude_distributed && cloudSearchParams.exclude_distributed.length > 0">
                          <el-select v-model="cloudSearchParams.distribute_status" placeholder="全部" clearable @change="handleFilterChange" size="small" style="width: 120px;">
                            <el-option label="待铺货" :value="1"></el-option>
                            <el-option label="铺货中" :value="2"></el-option>
                            <el-option label="铺货失败" :value="3"></el-option>
                            <el-option label="铺货成功" :value="4"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="分组">
                          <el-select v-model="cloudSearchParams.group_id" placeholder="全部分组" filterable clearable @change="handleGroupFilterChange" size="small" style="width: 150px;">
                            <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="子分组">
                          <el-select v-model="cloudSearchParams.child_group_id" placeholder="全部分组" filterable clearable @change="handleFilterChange" size="small" style="width: 150px;">
                            <el-option v-for="group in child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="缺少sku图">
                          <el-select v-model="cloudSearchParams.is_sku_miss" placeholder="全部" clearable @change="handleFilterChange" size="small" style="width: 120px;">
                            <el-option label="否" :value="1"></el-option>
                            <el-option label="是" :value="2"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="触发铺货成功">
                          <el-select v-model="cloudSearchParams.has_distribute_success" placeholder="全部" clearable @change="handleFilterChange" size="small" style="width: 120px;">
                            <el-option label="是" :value="1"></el-option>
<!--                            <el-option label="否" :value="0"></el-option>-->
                          </el-select>
                        </el-form-item>
                        <el-form-item label="触发铺货失败">
                          <el-select v-model="cloudSearchParams.has_distribute_fail" placeholder="全部" clearable @change="handleFilterChange" size="small" style="width: 120px;">
                            <el-option label="是" :value="1"></el-option>
<!--                            <el-option label="否" :value="0"></el-option>-->
                          </el-select>
                        </el-form-item>
                        <el-form-item label="触发商品封禁">
                          <el-select v-model="cloudSearchParams.has_distribute_ban" placeholder="全部" clearable @change="handleFilterChange" size="small" style="width: 120px;">
                            <el-option label="是" :value="1"></el-option>
<!--                            <el-option label="否" :value="0"></el-option>-->
                          </el-select>
                        </el-form-item>
                        <el-form-item label="触发商品驳回">
                          <el-select v-model="cloudSearchParams.has_distribute_review_fail" placeholder="全部" clearable @change="handleFilterChange" size="small" style="width: 120px;">
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" @click="handleFilterChange" size="small">查询</el-button>
                          <el-button @click="handleCloudRefresh" size="small"><i class="el-icon-refresh-right"></i>刷新</el-button>
                          <el-button @click="handleCloudReset" size="small">重置</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="action-row">
                      <el-button type="success" @click="handleCloudDistribute" size="small" :disabled="cloudSelectedList.length === 0">
                        <i class="el-icon-s-goods"></i>铺货({{cloudSelectedList.length}})
                      </el-button>
                      <el-button type="danger" @click="handleCloudBatchDelete" size="small" :disabled="cloudSelectedList.length === 0">
                        <i class="el-icon-delete"></i>批量删除
                      </el-button>
                      <el-button type="info" @click="handleCloudBatchEdit" size="small">
                        <i class="el-icon-edit"></i>批量编辑
                      </el-button>
                      <el-button type="success" plain @click="handleCloudBatchRecover" size="small" :disabled="cloudSelectedList.length === 0" v-if="cloudSearchParams.status==4">
                        <i class="el-icon-circle-check"></i>一键恢复
                      </el-button>
<!--                      :disabled="cloudSelectedList.length === 0"-->
                      <el-button type="warning" @click="handleCloudBatchImageSearch" size="small" >
                        <i class="el-icon-refresh"></i>批量SKU替换
                      </el-button>
                      <el-button type="warning" plain @click="handleCloudBatchLinkReplace" size="small" >
                        <i class="el-icon-link"></i>批量替换指定链接SKU
                      </el-button>
                      <el-button type="success" plain @click="handleAICloudBatchProductMark" size="small" >
                        <i class="el-icon-price-tag"></i>AI批量找货源标记
                      </el-button>
                      <el-button type="success"  @click="handleAICloudBatchImageSearch" size="small" >
                        <i class="el-icon-cloudy"></i>AI批量SKU替换
                      </el-button>
                      <el-button type="primary" plain @click="handleBatchSetGroup" size="small" :disabled="cloudSelectedList.length === 0">
                        <i class="el-icon-folder-add"></i>设置分组
                      </el-button>
                    </div>
                  </div>

                  <!-- 状态切换栏 -->
                  <div class="status-tabs-container">
                    <div
                        v-for="item in cloudStatusTabs"
                        :key="item.value"
                        class="status-tab-item"
                        :class="{ active: cloudSearchParams.status === item.value }"
                        @click="handleCloudStatusTabClick(item.value)"
                    >
                        {{ item.label }}
                        <span v-if="cloudStats" class="status-count">({{ item.count||0 }})</span>
                    </div>
                  </div>

                  <div class="table-container">
                    <el-table
                      v-loading="cloudLoading"
                      :data="cloudTableData"
                      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                      class="rc_table"
                      row-key="id"
                      @selection-change="handleCloudSelectionChange"
                      @sort-change="handleSortChange"
                      table-layout="fixed"
                    >
                    <el-table-column type="selection" width="50" align="center"></el-table-column>
                    <el-table-column label="商品信息"  min-width="140">
                      <template #default="{ row }">
                        <div class="goods-box">
                          <img :src="row.main_image" class="goods-img">
                          <div class="goods-info">
                            <el-tooltip class="item" effect="dark" :content="row.title" placement="top" :open-delay="300">
                                <div class="goods-title">{{row.title}}</div>
                            </el-tooltip>
                            <div>价格：{{row.price}}</div>
                            <div>来源ID：{{row.source_product_id}}</div>
                            <div :class="skuStatus[row.sku_status].type">SKU：{{skuStatus[row.sku_status].label}}</div>
                            <div :class="skuMarkStatus[row.sku_mark_status || 1].type">标记：{{skuMarkStatus[row.sku_mark_status || 1].label}}</div>
                            <div :class="(aiTitleStatus[row.ai_title_status] ? aiTitleStatus[row.ai_title_status].type : aiTitleStatus[1].type)"
                                >
                                标题：{{
                                    aiTitleStatus[row.ai_title_status]
                                    ? aiTitleStatus[row.ai_title_status].label
                                    : aiTitleStatus[1].label
                                }}
                                </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="运费" align="center" width="170">
                      <template #default="{ row }">
                        <div>是否包邮：{{ row.distribution_free_postage === true ? '是' : (row.distribution_free_postage === false ? '否' : '未知') }}</div>
                        <div v-if="cloudSearchParams.freight_province_code">发往{{ provinceName(cloudSearchParams.freight_province_code) }}：{{ row.destination_freight_status === 'unknown' ? '未知' : row.destination_freight + ' 元' }}</div>
                        <el-button v-if="row.distribution_free_postage === false" type="text" size="mini" @click="handleViewFreight(row)">查看运费</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="分组|子分组" prop="group_name" align="center" width="100">
                      <template #default="{ row }">
                        <el-tooltip v-if="row.group_name" :content="formatGroupName(row)" placement="top" :open-delay="300">
                          <span class="group-name-cell">{{ formatGroupName(row) }}</span>
                        </el-tooltip>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="缺少sku图" align="center" width="90">
                      <template #default="{ row }">
                        <el-tag :type="row.is_sku_miss==2?'warning':'info'">{{row.is_sku_miss==2?'是':'否'}}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="铺货信息统计" align="center" width="130">
                      <template #default="{ row }">
                        <div>铺货成功：{{ row.distribute_success_count || 0 }}</div>
                        <div>铺货失败：{{ row.distribute_fail_count || 0 }}</div>
                        <div>商品封禁：{{ row.distribute_ban_count || 0 }}</div>
                        <div>商品驳回：{{ row.distribute_review_fail_count || 0 }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column label="状态" align="center" width="120">
                      <template #default="{ row }">
                        <div class="status-container">
                          <div class="status-tag">
                            <el-tag :type="itemStatusTag[row.status]" size="small">{{row.status_text}}</el-tag>
                          </div>
                          <div v-if="row.status === 2 || row.status === 3" class="error-message-under-status" :title="row.error_msg">
                            {{ row.error_msg || '' }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column sortable="custom" label="时间" prop="updated_at" align="center" width="170">
                      <template #default="{ row }">
                        <div class="time-column">
                          <div>创建: {{row.created_at_text}}</div>
                          <div>更新: {{row.updated_at_text}}</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" >
                      <template #default="{ row }">
                        <el-button type="info" @click="handleCloudEdit(row)" size="mini" class="mini-btn" v-if="row.status === 1">编辑</el-button>
                        <el-button type="warning" @click="handleCloudImageSearch(row)" size="mini" class="mini-btn" v-if="row.status === 1" >SKU替换</el-button>
                        <el-button type="warning" @click="handleLinkReplace(row)" size="mini" class="mini-btn" v-if="row.status === 1">替换指定链接sku</el-button>
                        <el-button type="primary" plain @click="handleViewDistributeRecords(row)" size="mini" class="mini-btn">铺货日志</el-button>
                        <el-button type="warning" plain @click="handleViewReplaceLogs(row)"  size="mini" class="mini-btn" >SKU替换记录</el-button>
                        <el-button type="warning" plain @click="handleViewProductMarks(row)" size="mini" class="mini-btn">查看标记货源</el-button>
                        <el-button type="warning" v-if="row.ai_title_status === 2" plain @click="handleViewReplaceTitleLogs(row)"  size="mini" class="mini-btn" >标题替换记录</el-button>
                        <el-button type="primary" @click="handleCloudDelete(row)" size="mini" class="mini-btn" >删除</el-button>
                        <el-button type="success" @click="handleCloudRecover(row)" size="mini" class="mini-btn" v-if="cloudSearchParams.status==4">恢复</el-button>
                      </template>
                    </el-table-column>
                    </el-table>
                  </div>
                  <Pagination
                    :total="cloudPageData.total"
                    :page.sync="cloudPageData.page"
                    :limit.sync="cloudPageData.limit"
                    :pageSizes= "pageSizes"
                    @pagination="getCloudDataList"
                    v-if="cloudPageData.total > 0"
                    layout="total, sizes, prev, pager, next, jumper"
                  />
                </el-tab-pane>

                <el-tab-pane label="共享商品库" name="share" v-if="userinfo&&userinfo.view_share==2">
                  <share-goods ref="shareGoods"></share-goods>
                </el-tab-pane>

                <!-- Tab 3: 铺货列表 -->
                <el-tab-pane label="铺货列表" name="distribute">
                  <el-alert
                    title="系统后台自动铺货中。已铺货商品请至【我的商品】查看；若长时间显示【待铺货】，请检查店铺点数、授权状态及是否达到发布上限。"
                    type="warning"
                    show-icon
                    :closable="false"
                    style="margin-bottom: 15px;">
                  </el-alert>
                  <div class="filter-box">
                    <el-form inline size="small">
                      <el-form-item label="平台">
                        <el-select v-model="distributeSearchParams.shop_type" clearable placeholder="全部平台" filterable style="width: 150px;" @change="handleDistributeSearch">
                          <el-option v-for="item in shopTypeList" :label="item.name" :value="item.shop_type" :key="item.shop_type"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="店铺">
                        <el-select v-model="distributeSearchParams.shop_id" clearable placeholder="全部店铺" filterable style="width: 150px;" @change="handleDistributeSearch">
                          <el-option v-for="item in filterShopList" :label="item.shop_name" :value="item.shop_id" :key="item.shop_id" v-if="!distributeSearchParams.shop_type || item.shop_type == distributeSearchParams.shop_type"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="关键词">
                        <el-input v-model="distributeSearchParams.keyword" placeholder="商品标题" clearable @clear="handleDistributeSearch" @keyup.enter.native="handleDistributeSearch" style="width: 150px;"></el-input>
                      </el-form-item>
                      <el-form-item label="创建时间">
                         <el-date-picker
                          v-model="distributeSearchParams.dateRange"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          @change="handleDistributeSearch"
                          style="width: 240px;">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="handleDistributeSearch" size="small">查询</el-button>
                        <el-button @click="handleDistributeReset" size="small">重置</el-button>
                      </el-form-item>
                    </el-form>
                  </div>

                  <!-- 状态切换栏 -->
                  <div class="status-tabs-container">
                    <div
                        v-for="item in distributeStatusTabs"
                        :key="item.value"
                        class="status-tab-item"
                        :class="{ active: distributeSearchParams.status === item.value }"
                        @click="handleStatusTabClick(item.value)"
                    >
                        {{ item.label }}
                        <span v-if="distributeStats" class="status-count">({{ item.count }})</span>
                    </div>
                  </div>

                  <div class="table-container">
                    <el-table
                      v-loading="distributeLoading"
                      :data="distributeTableData"
                      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                      class="rc_table"
                      row-key="id"
                      table-layout="fixed"
                    >
                        <el-table-column label="商品信息"  min-width="250">
                            <template #default="{ row }">
                            <div class="goods-box">
                                <img :src="row.product_image" class="goods-img">
                                <div class="goods-info">
                                  <el-tooltip class="item" effect="dark" :content="row.product_title" placement="top" :open-delay="300">
                                      <div class="goods-title">{{row.product_title}}</div>
                                  </el-tooltip>
                                  <div>价格：{{row.product_price}}</div>
                                  <div>来源商品ID：{{row.source_product_id}} <span type="text" @click="handleViewGoods(row)" style="cursor: pointer;color: #489ff3">查看</span></div>
                                </div>
                            </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="店铺" prop="shop_name" align="center" min-width="150"></el-table-column>
                        <el-table-column label="状态" align="center" min-width="120">
                            <template #default="{ row }">
                                <div class="status-container">
                                    <div class="status-tag">
                                         <el-tag :type="distributeStatusTag[row.status]" size="small">{{row.status_text}}</el-tag>
                                    </div>
                                    <div v-if="row.status === 3" class="error-message-under-status" :title="row.err_msg">
                                        {{ row.err_msg || '' }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" prop="created_at_text" align="center" width="160"></el-table-column>
                    </el-table>
                  </div>
                  <Pagination
                    :total="distributePageData.total"
                    :page.sync="distributePageData.page"
                    :limit.sync="distributePageData.limit"
                    @pagination="getDistributeDataList"
                    v-if="distributePageData.total > 0"
                    layout="total, sizes, prev, pager, next, jumper"
                  />
                </el-tab-pane>
                <!-- <el-tab-pane label="AI标题" name="aiTitle" v-if="ismanager">
                  <ai-title-replace-task :groupList="groupList" ref="AiTitleReplaceTask" :is-manager.sync="ismanager"></ai-title-replace-task>
                </el-tab-pane> -->
                <!-- Tab 4: 分组管理 -->
                <el-tab-pane label="分组管理" name="group">
                  <div>
                    <el-form inline size="small">
                      <el-form-item label="主分组名称">
                        <el-input v-model="groupSearchParams.main_name" placeholder="主分组名称模糊搜索" size="small" clearable class="w_140" @keyup.enter.native="handleGroupSearch"></el-input>
                      </el-form-item>
                      <el-form-item label="子分组名称">
                        <el-input v-model="groupSearchParams.child_name" placeholder="子分组名称模糊搜索" size="small" clearable class="w_140" @keyup.enter.native="handleGroupSearch"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="handleGroupSearch" size="small">查询</el-button>
                        <el-button @click="refreshGroupList" size="small"><i class="el-icon-refresh-right"></i>重置</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class="">
                    <el-button type="primary" @click="handleAddGroup" size="small"><i class="el-icon-plus"></i>新增主分组</el-button>
                  </div>
                  <div class="table-container">
                    <el-table
                        :data="groupTableData"
                        v-loading="groupLoading"
                        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                        class="rc_table"
                        row-key="id"
                        :expand-row-keys="groupExpandedKeys"
                        @expand-change="handleGroupParentExpand"
                    >
                        <el-table-column type="expand" width="48">
                          <template #default="{ row }">
                            <div class="group-child-panel" v-loading="groupChildrenLoading">
                              <el-table :data="groupChildrenData" size="small" :header-cell-style="{ background: '#f7f9fc', color: '#606266' }">
                                <el-table-column prop="name" label="子分组名称" min-width="220">
                                  <template #default="{ row: child }">
                                    <span>{{ child.name }}</span>
                                    <el-tag v-if="child.is_shared" type="info" size="mini" effect="plain" class="group-shared-tag">共享</el-tag>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="product_count" label="商品数量" width="120" align="center"></el-table-column>
                                <el-table-column prop="sort" label="排序" width="90" align="center"></el-table-column>
                                <el-table-column prop="updated_at" label="更新时间" width="180" align="center"></el-table-column>
                                <el-table-column label="操作" width="140" align="center">
                                  <template #default="{ row: child }">
                                    <template v-if="child.editable">
                                      <el-button type="text" @click="handleEditGroup(child)">编辑</el-button>
                                      <el-button type="text" style="color: #F56C6C" @click="handleDeleteGroup(child)">删除</el-button>
                                    </template>
                                    <span v-else>-</span>
                                  </template>
                                </el-table-column>
                              </el-table>
                              <div v-if="groupChildrenData.length === 0 && !groupChildrenLoading" class="group-child-empty">暂无匹配的子分组</div>
                              <div v-if="groupChildrenData.length < groupChildrenPageData.total" class="group-child-more">
                                <el-button type="text" :loading="groupChildrenLoading" @click="loadMoreGroupChildren(row.id)">加载更多（{{ groupChildrenData.length }}/{{ groupChildrenPageData.total }}）</el-button>
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="name" label="主分组名称" min-width="240">
                          <template #default="{ row }">
                            <span>{{ row.name }}</span>
                            <el-tag v-if="row.is_shared" type="info" size="mini" effect="plain" class="group-shared-tag">共享</el-tag>
                          </template>
                        </el-table-column>
                        <el-table-column prop="child_count" label="子分组数" width="110" align="center"></el-table-column>
                        <el-table-column prop="product_count" label="商品总数" width="120" align="center"></el-table-column>
                        <el-table-column prop="sort" label="排序" width="90" align="center"></el-table-column>
                        <el-table-column prop="updated_at" label="更新时间" width="180" align="center"></el-table-column>
                        <el-table-column label="操作" width="190" align="center">
                          <template #default="{ row }">
                            <template v-if="row.editable">
                              <el-button type="text" @click="handleAddChildGroup(row)">新增子分组</el-button>
                              <el-button type="text" @click="handleEditGroup(row)">编辑</el-button>
                              <el-button type="text" style="color: #F56C6C" @click="handleDeleteGroup(row)">删除</el-button>
                            </template>
                            <span v-else>-</span>
                          </template>
                        </el-table-column>
                    </el-table>

                  </div>
                  <Pagination
                      :total="groupPageData.total"
                      :page.sync="groupPageData.page"
                      :limit.sync="groupPageData.limit"
                      :pageSizes= "[10,20,50,100]"
                      @pagination="getGroupDataList"
                      v-if="groupPageData.total > 0"
                      layout="total, sizes, prev, pager, next, jumper"
                  />
                  <el-empty v-if="groupTableData.length === 0 && !groupLoading" description="暂无分组，请点击上方按钮新增" :image-size="100"></el-empty>
                </el-tab-pane>

              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>

    <!-- 导入商品弹窗 -->
    <el-dialog title="导入商品" :visible.sync="importShow">
      <div element-loading-text="文件解析中" element-loading-spinner="el-icon-loading" v-loading="imLoading">
        <el-form label-width="100px" ref="importForm" :model="importInfo">
          <el-form-item label="商品来源：" prop="source_web" :rules="[{ required: true, message: '请选择商品来源', trigger: 'change' }]">
            <el-radio-group v-model="importInfo.source_web" @change="changeSourceWeb">
              <template v-for="item in sourceList">
                        <el-radio :label="item.value" :key="item.value" v-if="[2,3,4,5,6].includes(item.value)">{{ item.label }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <!-- 商品解析 -->
        <el-form-item v-if="[3,4,5,6].includes(importInfo.source_web)" label="商品解析：" prop="source_method" :rules="[{ required: true, message: '请选择商品解析：', trigger: 'change' }]">
            <!-- <el-radio-group v-model="importInfo.source_method" @change="changeSourceMethod">
                <el-radio
                v-for="item in collectList"
                :key="item.value"
                :label="item.value"
                >
                {{ item.label }}
                </el-radio>
            </el-radio-group> -->
            <el-select v-model="importInfo.source_method" placeholder="请选择解析方式" clearable style="width: 200px;" @change="changeSourceMethod">
              <el-option v-for="item in (importInfo.source_web === 5 ?dy_collectList:importInfo.source_web === 6 ? wx_collectList : importInfo.source_web === 3 ? collectList : pdd_collectList)" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </el-form-item>
          <el-form-item label="加入分组：">
            <el-select v-model="importInfo.group_id" placeholder="不加入分组" clearable filterable style="width: 200px;" @change="changeGroupId">
              <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加入子分组：">
            <el-select v-model="importInfo.child_group_id" :placeholder="importInfo.group_id ? '请选择子分组' : '不加入分组'" clearable filterable style="width: 200px;" :key="childSelectKey" :disabled="!importInfo.group_id">
              <el-option v-for="group in child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品：" prop="products" :rules="[{ required: true, message: '请上传压缩包', trigger: 'change', type: 'array' }]" v-if="[3,4,5,6].includes(importInfo.source_web)">
            <el-button type="primary" @click="handleUpload" size="small" :loading="imLoading">上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <input ref="zipInput" type="file" accept=".zip" @change="handleZipChange" style="display: none" />
            <div v-if="zipFileName && !imLoading">
              从【{{zipFileName}}】中获取到
              <span style="color: red;font-weight: bold;">{{importInfo.products.length || 0}}</span>
              个商品，将分为<span style="color: red;font-weight: bold;">{{batchNum}}</span>个批次进行导入，单个批次最多{{importSize}}条。</div>
            <div v-if="zipFileName && !imLoading"> 优先文件<span style="color: red;font-weight: bold;">1.5M</span>大小一个批次，可能超过<span style="color: red;font-weight: bold;">{{batchNum}}</span>个批次上传。 </div>
            <div v-if="upLoading"> 当前进度：{{ importInfo.page }}/{{ batchNum }}。</div>
          </el-form-item>
          <el-form-item label="商品：" prop="produceLinks" :rules="[{ required: true, message: '请输入1688商品链接', trigger: 'change' }]" v-if="importInfo.source_web===2">
            <el-input type="textarea" v-model="importInfo.produceLinks" :rows="10" placeholder="请输入1688商品链接，每个商品需换行"></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-top: 20px;display: flex;justify-content: flex-end">
          <el-button @click="importShow = false">取消</el-button>
          <el-button type="primary" @click="handleImport" :loading="upLoading">{{upErr ? '继续导入' : '确定导入'}}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 抖店商品同步弹窗：属于云商品库的商品导入流程 -->
    <el-dialog title="同步抖店商品到云商品库" :visible.sync="doudianSyncShow" width="980px" :close-on-click-modal="false" @open="loadDoudianSyncData">
      <div class="doudian-sync-panel">
        <el-form inline size="small" :model="doudianSyncFilterForm" class="doudian-sync-form">
          <el-form-item label="抖店店铺">
            <el-select v-model="doudianSyncFilterForm.shop_id" placeholder="全部店铺" filterable clearable style="width: 200px;">
              <el-option
                v-for="shop in doudianShopList"
                :key="shop.dd_shop_id || shop.shop_id"
                :label="shop.shop_name"
                :value="String(shop.dd_shop_id || shop.shop_id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="doudianSyncFilterForm.status" placeholder="全部状态" clearable style="width: 130px;">
              <el-option label="待推送" :value="0"></el-option>
              <el-option label="同步中" :value="1"></el-option>
              <el-option label="导入中" :value="2"></el-option>
              <el-option label="成功" :value="3"></el-option>
              <el-option label="失败" :value="4"></el-option>
              <el-option label="已取消" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="同步时间">
            <el-date-picker
              v-model="doudianSyncFilterForm.dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 360px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="doudian-sync-actions">
            <el-button type="primary" @click="searchDoudianSyncTasks">筛选</el-button>
            <el-button @click="resetDoudianSyncFilters">重置</el-button>
            <el-button type="primary" plain @click="openDoudianSyncCreateDialog">新增任务</el-button>
            <el-button :loading="doudianSyncLoading" @click="getDoudianSyncTaskList">刷新</el-button>
          </el-form-item>
        </el-form>

        <el-table
          v-loading="doudianSyncLoading"
          :data="doudianSyncTasks"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          class="rc_table doudian-sync-table"
          table-layout="fixed"
        >
          <el-table-column label="店铺" prop="shop_name" min-width="120" align="center"></el-table-column>
          <el-table-column label="同步范围" prop="time_range_text" min-width="220" align="center"></el-table-column>
          <el-table-column label="状态" align="center" width="110">
            <template #default="{ row }">
              <el-tag :type="doudianSyncStatusTag(row.status)" size="small">{{ row.status_text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center" width="160">
            <template #default="{ row }">
              <div>总数：{{ row.total_count || 0 }}</div>
              <div>成功：{{ row.success_count || 0 }} / 跳过：{{ row.skip_count || 0 }}</div>
              <div>失败：{{ row.fail_count || 0 }}</div>
            </template>
          </el-table-column>
          <el-table-column label="错误信息" min-width="180" align="center">
            <template #default="{ row }">
              <div class="text-ellipsis" :title="row.last_error">{{ row.last_error || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="时间" width="170" align="center">
            <template #default="{ row }">
              <div>创建：{{ row.created_at_text || '-' }}</div>
              <div>完成：{{ row.finished_at_text || '-' }}</div>
            </template>
          </el-table-column>
        </el-table>

        <Pagination
          :total="doudianSyncPage.total"
          :page.sync="doudianSyncPage.page"
          :limit.sync="doudianSyncPage.limit"
          @pagination="getDoudianSyncTaskList"
          v-if="doudianSyncPage.total > 0"
          layout="total, prev, pager, next"
        />
      </div>
    </el-dialog>

    <el-dialog title="新增抖店同步任务" :visible.sync="doudianSyncCreateShow" width="620px" :close-on-click-modal="false">
      <el-form size="small" :model="doudianSyncCreateForm" label-width="96px" class="doudian-sync-create-form">
        <el-form-item label="抖店店铺">
          <el-select v-model="doudianSyncCreateForm.shop_id" placeholder="请选择店铺" filterable clearable style="width: 360px;">
            <el-option
              v-for="shop in doudianShopList"
              :key="shop.dd_shop_id || shop.shop_id"
              :label="shop.shop_name"
              :value="String(shop.dd_shop_id || shop.shop_id)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快捷时间">
          <el-radio-group v-model="doudianSyncCreateForm.quickRange" size="small" @change="changeDoudianSyncQuickRange">
            <el-radio-button label="30d">最近30天</el-radio-button>
            <el-radio-button label="3m">最近三个月</el-radio-button>
            <el-radio-button label="6m">最近半年</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="更新时间">
          <el-date-picker
            v-model="doudianSyncCreateForm.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 360px;"
            @change="clearDoudianSyncQuickRange"
          ></el-date-picker>
          <div class="sync-sub-text">单个子任务最多31天，超过31天会自动拆分；单次最多选择半年。</div>
        </el-form-item>
        <el-form-item label="分组">
          <el-select v-model="doudianSyncCreateForm.group_id" placeholder="不加入分组" clearable style="width: 220px;" @change="changeDoudianSyncGroupId">
            <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子分组">
          <el-select v-model="doudianSyncCreateForm.child_group_id" :placeholder="doudianSyncCreateForm.group_id ? '请选择子分组' : '不加入分组'" clearable style="width: 220px;" :disabled="!doudianSyncCreateForm.group_id">
            <el-option v-for="group in doudianChildGroupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="doudianSyncCreateShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="doudianSyncCreateLoading" @click="submitDoudianSyncTask">创建任务</el-button>
      </div>
    </el-dialog>

    <!-- 云商品铺货弹窗 -->
    <el-dialog title="铺货到店铺(只显示授权正常的店铺)" :visible.sync="cloudDistributeShow" width="600px">
      <div v-loading="cloudShopLoading" class="shop-distribute-container">
        <el-tabs v-model="cloudShopTab">
          <!-- 抖店Tab -->
          <el-tab-pane :label="'抖店 (' + cloudShopListByType.douyin.length + ')'" name="douyin">
            <div class="shop-tab-header" v-if="cloudShopListByType.douyin.length > 0">
                <el-checkbox v-model="cloudDouyinCheckAll" :indeterminate="cloudDouyinIndeterminate"
                    @change="handleDouyinCheckAllChange">全选</el-checkbox>
                <el-select v-model="cloudSelectedShopIds" multiple collapse-tags filterable clearable
                    placeholder="请选择店铺" size="mini" style="width: 280px; margin-left: 10px;"
                    @change="handleShopSelectionChange">
                    <el-option v-for="shop in cloudShopListByType.douyin" :key="shop.shop_id"
                        :label="shop.shop_name" :value="shop.shop_id"></el-option>
                </el-select>
            </div>
            <div class="shop-tab-content" v-if="cloudShopListByType.douyin.length > 0">
              <el-checkbox-group v-model="cloudSelectedShopIds" @change="handleShopSelectionChange">
                <div class="shop-item" v-for="shop in cloudShopListByType.douyin" :key="shop.shop_id">
                  <el-checkbox :label="shop.shop_id">
                    <span class="shop-name">{{shop.shop_name}}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <el-empty v-else description="暂无抖店" :image-size="80"></el-empty>
          </el-tab-pane>
          <!-- 微信小店Tab -->
          <el-tab-pane :label="'微信小店 (' + cloudShopListByType.wechat.length + ')'" name="wechat">
            <div class="shop-tab-header" v-if="cloudShopListByType.wechat.length > 0">
              <el-checkbox
                v-model="cloudWechatCheckAll"
                :indeterminate="cloudWechatIndeterminate"
                @change="handleWechatCheckAllChange"
              >全选</el-checkbox>
              <el-select v-model="cloudSelectedShopIds" multiple collapse-tags filterable clearable
                    placeholder="请选择店铺" size="mini" style="width: 280px; margin-left: 10px;"
                    @change="handleShopSelectionChange">
                    <el-option v-for="shop in cloudShopListByType.wechat" :key="shop.shop_id"
                        :label="shop.shop_name" :value="shop.shop_id"></el-option>
                </el-select>
            </div>
            <div class="shop-tab-content" v-if="cloudShopListByType.wechat.length > 0">
              <el-checkbox-group v-model="cloudSelectedShopIds" @change="handleShopSelectionChange">
                <div class="shop-item" v-for="shop in cloudShopListByType.wechat" :key="shop.shop_id">
                  <el-checkbox :label="shop.shop_id">
                    <span class="shop-name">{{shop.shop_name}}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <el-empty v-else description="暂无微信小店" :image-size="80"></el-empty>
          </el-tab-pane>
        </el-tabs>
        <el-empty v-if="cloudShopList.length === 0 && !cloudShopLoading" description="暂无可用店铺"></el-empty>
      </div>
      <template #footer>
        <span class="selected-count">已选择 {{cloudSelectedShopIds.length}} 个店铺</span>
        <el-button @click="cloudDistributeShow = false">取消</el-button>
        <el-button @click="submitCloudDistribute" type="primary" :loading="cloudDistributeLoading">确定铺货</el-button>
      </template>
    </el-dialog>

    <el-dialog title="查看标记货源" :visible.sync="productMarkViewShow" width="1100px" append-to-body>
      <el-empty v-if="!productMarkViewItems.length" description="无标记数据"></el-empty>
      <el-table v-else v-loading="productMarkViewLoading" :data="productMarkViewItems" border max-height="520">
        <el-table-column label="图片" width="90" align="center"><template #default="{ row }"><el-image v-if="row.image" :src="row.image" fit="cover" style="width:65px;height:65px" :preview-src-list="[row.image]"></el-image><span v-else>-</span></template></el-table-column>
        <el-table-column label="标题" min-width="220" prop="title" show-overflow-tooltip></el-table-column>
        <el-table-column label="商品ID" width="145"><template #default="{ row }">{{ row.offer_id || '-' }}</template></el-table-column>
        <el-table-column label="价格" width="90"><template #default="{ row }">{{ row.price || '-' }}</template></el-table-column>
        <el-table-column label="商家名称" width="130" prop="shop_name" show-overflow-tooltip></el-table-column>
        <el-table-column label="标记时间" width="170" align="center">
          <template #default="{ row }">
            {{ row.mark_at_text || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template #default="{ row }">
            <el-button v-if="getProductMarkLink(row)" type="primary" size="mini" plain @click="handleViewProductMarkLink(row)">查看商品</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- SKU替换弹窗 -->
    <el-dialog :id="aiReplace ? 'aiReplace_dialog' : (aiMarkMode ? 'aiMark_dialog' : undefined)"  :close-on-click-modal="false" :visible.sync="imageSearchShow" :title="replace_title" top="5vh" width="80%"
               @close="handleCancelImageSearch">
      <div class="sku-box">
        <div  class="filter-panel">
          <!-- 二级选择器 -->
          <div class="cascade-selects">
            <!-- 第一级：选择分类 -->
            <!--                <el-select
                              v-model="selectedCategory"
                              placeholder="选择过滤分类"
                              size="mini"
                              @change="handleCategoryChange"
                              class="category-select"
                              clearable
                            >
                              <el-option
                                v-for="group in filterOptions"
                                :key="group.key"
                                :label="group.title"
                                :value="group.key"
                              ></el-option>
                            </el-select>-->

            <!-- 第二级：选择具体条件 -->
            <!--                <el-select
                              v-model="selectedOption"
                              placeholder="选择具体条件"
                              size="mini"
                              @change="handleOptionChange"
                              class="option-select"
                              :disabled="!selectedCategory"
                              clearable
                            >
                              <el-option
                                v-for="option in getCurrentCategoryOptions()"
                                :key="option.value"
                                :label="option.label"
                                :value="option.value"
                              ></el-option>
                            </el-select>-->

            <!-- 添加按钮 -->
            <!--                <el-button
                              size="mini"
                              type="primary"
                              @click="handleAddFilter"
                              :disabled="!selectedCategory || !selectedOption"
                              plain
                            >
                              添加
                            </el-button>-->
            <div class="strategy-tabs">
              <div class="strategy-item" :class="{'active':strategyType===1}" @click="changeStrategy(1)">优先策略</div>
              <div class="strategy-item" :class="{'active':strategyType===2}" @click="changeStrategy(2)">默认策略</div>
            </div>
            <div style="display: flex;align-items: center;justify-content: space-between">
              <div style="font-weight: 600"> 过滤条件</div>
              <el-button size="small" type="text" @click="filterVisible = !filterVisible">
                {{filterVisible?'收起':'展开'}}
                <i :class="filterVisible?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
              </el-button>
            </div>
            <div class="filter-box" v-if="filterVisible" >
              <div v-for="(item,index) in filterOptions" :key="index" class="filter-item">
                <div class="filter-label">{{ item.title }}：</div>
                <div class="filter-value">
                  <div v-for="(sitem,sindex) in item.options" :key="index+'_'+sindex"
                       :class="{'active':pendingFilters.findIndex(i=>i.value==sitem.value)>-1}" class="filter-tag"
                       @click="changeFilter(sitem)">
                    {{ sitem.label }}
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- 待确认的过滤条件列表 -->
          <!--              <div v-if="pendingFilters.length > 0" class="pending-filters">
                          <div class="pending-title">待应用的过滤条件：</div>
                          <div class="pending-tags">
                            <el-tag
                                v-for="(filter, index) in pendingFilters"
                                :key="filter.value"
                                closable
                                size="mini"
                                type="warning"
                                @close="handleRemovePendingFilter(index)"
                            >
                              {{ filter.label }}
                            </el-tag>
                          </div>
                        </div>-->

          <!-- 已应用的过滤条件列表 -->
          <!--              <div v-if="getSelectedFilterLabels().length > 0" class="applied-filters">
                          <div class="applied-title">已应用的过滤条件：</div>
                          <div class="applied-tags">
                            <el-tag
                                v-for="tag in getSelectedFilterLabels()"
                                :key="tag.value"
                                closable
                                size="mini"
                                type="success"
                                @close="handleRemoveAppliedFilter(tag.value)"
                            >
                              {{ tag.label }}
                            </el-tag>
                          </div>
                        </div>-->

          <!-- 操作按钮 -->
          <div class="filter-actions" v-if="filterVisible">
            <el-button plain size="mini" @click="handleClearAllFilters">全部清空</el-button>
            <el-button size="mini" type="primary" @click="handleApplyFilters">应用</el-button>
          </div>
        </div>

      <div class="image-search-container-new">
        <!-- 左侧：待搜商品列表 -->
        <div class="search-left-panel">
          <div class="panel-header" style="display: flex;align-items: flex-start;gap: 10px;">
            <div style="width: fit-content;line-height: 32px;">筛选</div>
<!--            <span>({{ imageSearchList.length }})</span>
            <span v-if="getReplacedCount() > 0" class="replaced-count">已提交: {{ getReplacedCount() }}</span>-->
            <div style="flex: 1;display: flex;flex-wrap: wrap;gap: 4px;">
              <el-select v-model="skuGroupId" placeholder="全部分组" filterable clearable @change="searchSkuGroupReplaceList" size="small" style="width: 140px;">
                <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
              </el-select>
              <el-select v-model="skuStatusValue" placeholder="全部状态" clearable @change="searchSkuReplaceList" size="small" style="width: 140px">
                <el-option v-for="item in Object.keys(skuStatus)" :key="item" :label="skuStatus[item].label" :value="skuStatus[item].value"></el-option>
              </el-select>
              <el-select v-model="skuChildGroupId" placeholder="全部子分组" filterable clearable @change="searchSkuReplaceList" size="small" style="width: 140px;">
                <el-option v-for="group in sku_child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
              </el-select>
              <el-select v-model="appraisalStatusValue" placeholder="全部检测" clearable @change="searchSkuReplaceList" size="small" style="width: 140px">
                <el-option v-for="item in Object.keys(appraisal_status)" :key="item" :label="appraisal_status[item].label" :value="appraisal_status[item].value"></el-option>
              </el-select>
              <el-select v-model="skuIsSkuMiss" placeholder="是否缺少sku图" clearable @change="searchSkuReplaceList" size="small" style="width: 140px;">
                <el-option label="不缺sku图" :value="1"></el-option>
                <el-option label="缺少sku图" :value="2"></el-option>
              </el-select>
              <el-select v-model="skuMarkStatusValue" placeholder="标记状态" clearable @change="searchSkuReplaceList" size="small" style="width: 140px">
                <el-option v-for="item in Object.keys(skuMarkStatus)" :key="item" :label="skuMarkStatus[item].label" :value="skuMarkStatus[item].value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="product-list" ref="productList" v-loading="skuLoading">
            <div
                v-for="(item,index) in imageSearchList"
                :key="item.id"
                :class="{ active: currentSearchProduct && currentSearchProduct.id === item.id, selected: selectedReplaceMap[item.id], replaced: replacedProductIds.includes(item.id) }"
                class="product-item"
                @click="handleSelectSearchProduct(item)"
            >
              <el-popover
                  placement="top"
                  :fallback-placements="[ 'top', 'right', 'left','bottom']"
                  width="350"
                  trigger="hover">
                <div class="popover-content">
                  <el-image  :src="item.main_image" fit="contain" style="width:100%;height: auto"></el-image>
                </div>
                <el-image slot="reference"  :src="item.main_image" class="thumb"></el-image>
              </el-popover>
              <div class="info">
                <div :title="item.title" class="title">{{ item.title }}</div>
                <div style="display: flex;align-items: flex-end;justify-content: space-between">
                  <div>
                    <div class="price">¥{{ item.price }}</div>
                    <div v-if="item.updated_at_text" class="update-time">{{ item.updated_at_text }}</div>
<!--                    <div v-if="replacedProductIds.includes(item.id)" class="replaced-tag">已提交</div>-->
<!--                    <div v-else-if="selectedReplaceMap[item.id]" class="selected-tag">已选</div>-->
                    <div :class="(aiMarkMode ? skuMarkStatus[item.sku_mark_status || 1] : skuStatus[item.sku_status]).type">{{(aiMarkMode ? skuMarkStatus[item.sku_mark_status || 1] : skuStatus[item.sku_status]).label}}</div>
                  </div>
                  <el-button size="mini" v-if="(aiMarkMode ? item.sku_mark_status || 1 : item.sku_status) == 1" @click.stop="aiMarkMode ? handleProductMarkNotFound(item,index) : handleMarkNotFound(item,index)">找不到关联商品</el-button>
                  <el-button size="mini" v-if="(aiMarkMode ? item.sku_mark_status || 1 : item.sku_status) == 3" @click.stop="aiMarkMode ? handleProductMarkNotFoundCancel(item,index) : handleCancelNotFound(item,index)">{{ aiMarkMode ? '设为未标记' : '设为待替换' }}</el-button>
                </div>


              </div>
            </div>
          </div>
          <div class="panel-pagination">
          <el-pagination small :current-page.sync="skuPageData.page" :page-size.sync="skuPageData.limit" :pager-count="5"
                         :page-sizes="[20,50,100]" :total="skuPageData.total"
                         @size-change="handleSizeChangeSku" @current-change="handleCurrentChangeSku" v-if="skuPageData.total>1"/>
          </div>
        </div>

        <!-- 右侧：商品详情 + 搜索结果 -->
        <div class="search-right-area">
          <!-- 右上：当前商品SKU信息 -->
          <div v-if="currentSearchProduct" class="product-detail-panel">
            <div class="panel-header">
             <div style="flex: 1"> 当前商品SKU</div>
              <div v-if="currentSearchProduct" class="sub-header">
                {{ currentSearchProduct.title }}
              </div>
              <el-button size="small" type="text" @click="skuVisible = !skuVisible" style="margin-left: 15px">
                {{skuVisible?'收起':'展开'}}
                <i :class="skuVisible?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
              </el-button>
            </div>
            <div class="product-detail-content" v-if="skuVisible">
              <!-- SKU信息 -->
              <div v-if="currentProductDetail && currentProductDetail.skus && currentProductDetail.skus.length > 0"
                   class="sku-info-section">
                <div class="sku-list">
                  <div v-for="(sku, index) in currentProductDetail.skus" :key="sku.sku_id" class="sku-item">
                    <div class="sku-spec">{{ sku.attributes_text || '默认规格' }}</div>
                    <div class="sku-details">
                      <span class="sku-price">¥{{ sku.price }}</span>
                      <!--                      <span class="sku-stock">库存:{{sku.stock}}</span>-->
                      <!--                      <span class="sku-code">{{sku.sku_code}}</span>-->
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="currentSearchProduct" class="sku-info-section">
                <div class="no-sku-info">暂无SKU详细信息</div>
              </div>
            </div>
          </div>
          <div v-loading="imageSearchLoading" class="search-result-panel">
            <div class="panel-header">
              <div class="header-left">
                1688相似商品
                <span v-if="imageSearchResult.length > 0"
                      class="result-count">(共 {{ imageSearchResult.length }} 条)</span>
              </div>
              <div class="header-right">
<!--                <el-button size="small" type="text" @click="filterVisible = !filterVisible">
                  <i class="el-icon-s-operation"></i>
                  过滤条件
                  <span v-if="searchFilters.length > 0" class="filter-count">({{ searchFilters.length }})</span>
                </el-button>-->
                <el-select v-model="priceSort" placeholder="选择排序" clearable @change="changePriceSort" size="small">
                  <el-option label="价格从高到低" value="price_desc"></el-option>
                  <el-option label="价格从低到高" value="price_asc"></el-option>
                </el-select>
              </div>
            </div>

            <!-- 过滤条件面板 -->

            <div class="search-result-grid" ref="searchResultGrid" v-if="imageSearchResult.length > 0">
              <div v-for="(result, index) in imageSearchResult" :key="index" class="result-item" :class="{ 'is-selected': currentSearchProduct && selectedReplaceMap[currentSearchProduct.id] && selectedReplaceMap[currentSearchProduct.id].offer_id === result.offer_id, 'is-replaced': currentSearchProduct && replacedTargetMap[currentSearchProduct.id] === result.offer_id }">
                <div class="img-wrapper" style="width:100%;aspect-ratio:1/1;position:relative;overflow:hidden;flex-shrink:0;">

                  <el-popover
                      placement="left"
                      width="350"
                      trigger="hover">
                    <div class="popover-content">
                      <el-image  :src="result.image" fit="contain" style="width:100%;height: auto"></el-image>
                    </div>
                    <img slot="reference"  :src="result.image" class="result-img" style="width:100%;height:100%;object-fit:cover;">
                  </el-popover>
                  <div v-if="currentSearchProduct && replacedTargetMap[currentSearchProduct.id] === result.offer_id" class="replaced-badge">已替换</div>
                </div>
                <div class="result-info">
                  <div class="result-title" :title="result.title">{{result.title}}</div>
                  <div class="result-price-row">
                    <span class="price">¥{{result.price}}</span>
                    <span v-if="result.consign_price && result.consign_price !== result.price" class="consign-price">代发:{{result.consign_price}}</span>
                  </div>
                  <div class="result-tags" v-if="result.tags && result.tags.length > 0">
                    <span v-for="(tag, tagIndex) in result.tags" :key="tagIndex" class="mini-tag" v-if="tag.enable">{{tag.text}}</span>
                  </div>
                </div>
                <div class="result-action" style="display:flex;border-top:1px solid #ebeef5;flex-shrink:0;">
                  <div
                    class="action-btn replace-btn"
                    style="flex:1;height:36px;line-height:36px;text-align:center;cursor:pointer;"
                    @click.stop="handleUseResult(result)"
                  >
                    {{ aiMarkMode ? '标记' : '替换' }}
                  </div>
                  <div :data-offer-id="result.offer_id||''" class="action-btn view-btn" style="flex:1;height:36px;line-height:36px;text-align:center;cursor:pointer;border-left:1px solid #ebeef5;" @click.stop="handleViewProduct(result)">查看</div>
                </div>
              </div>
            </div>
            <div v-else-if="!imageSearchLoading && currentSearchProduct" class="empty-result">
              <i class="el-icon-search"></i>
              <p>未找到相似商品</p>
            </div>
            <div v-else-if="!currentSearchProduct" class="empty-result">
              <p>请选择左侧商品进行搜款</p>
            </div>
          </div>
        </div>
      </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <span class="selected-info">
            {{ aiMarkMode ? '已标记' : '已替换' }}: {{getReplacedCount()}} / {{imageSearchList.length}}
          </span>
          <el-link v-if="aiReplace || aiMarkMode" type="primary">使用AI{{ aiMarkMode ? '标记' : '替换' }}一次5-10算力！&nbsp;&nbsp;</el-link>
          <el-link v-if="aiReplace || aiMarkMode" type="success" >算力:<span id="ai_balance">{{ formatPrice(power_num,0) }}.{{formatPrice(power_num,1) }}</span>&nbsp;&nbsp;</el-link>
          <el-button v-if="aiReplace || aiMarkMode" id="aiReplace_refresh_btn" @click="searchSkuReplaceList"><i class="el-icon-refresh-right el-icon--right"></i>刷新</el-button>
          <el-button @click="handleCancelImageSearch">关闭</el-button>
          <!-- <el-button v-if="aiReplace" class="ai_button">AI</el-button> -->
        </div>
      </template>
    </el-dialog>

    <!-- 批量加入分组弹窗 -->
    <el-dialog title="设置分组" :visible.sync="batchGroupShow" width="400px">
      <el-form label-width="85px">
        <el-form-item label="主分组">
          <el-select v-model="batchGroupId" placeholder="请选择主分组" style="width: 100%;" filterable clearable @change="changeSetGroupId">
            <el-option label="不加入分组" :value="0"></el-option>
            <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子分组">
          <el-select
            v-model="batchChildGroupId"
            :placeholder="batchGroupId && batchGroupId !== 0 ? '请选择子分组' : '请先选择主分组'"
            :disabled="!batchGroupId || batchGroupId === 0"
            style="width: 100%;"
            filterable
            clearable
          >
            <el-option v-for="group in set_child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
          </el-select>
          <div style="color: #999; font-size: 12px; margin-top: 5px;">选择主分组后仅可选择其下的子分组；选择“不加入分组”将移出当前分组</div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="batchGroupShow = false">取消</el-button>
        <el-button type="primary" @click="submitBatchSetGroup" :loading="batchGroupLoading">确定</el-button>
      </template>
    </el-dialog>

    <!-- 分组表单弹窗 -->
    <el-dialog :title="groupFormEdit ? '编辑分组' : '新增分组'" :visible.sync="groupFormShow" width="400px">
        <el-form label-width="80px" :model="groupForm">
            <el-form-item label="分组等级" required v-if="!groupFormEdit">
                <el-select v-model="groupForm.grade" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in group_grade_options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="主分组" required v-if="!groupFormEdit && groupForm.grade === 2">
                <el-select v-model="groupForm.parent_id" filterable placeholder="请选择主分组" style="width: 100%;">
                    <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

        <el-form-item label="分组名称" required>
          <el-input v-model="groupForm.name" placeholder="请输入分组名称" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="首个子分组" required v-if="!groupFormEdit && groupForm.grade === 1">
          <el-input v-model="groupForm.child_name" placeholder="请输入首个子分组名称" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="groupForm.sort" :min="0" :max="9999" style="width: 100%;"></el-input-number>
          <div style="color: #999; font-size: 12px; margin-top: 5px;">按升序排列，数值越小排序越前</div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="groupFormShow = false">取消</el-button>
        <el-button type="primary" @click="submitGroupForm" :loading="groupFormLoading">确定</el-button>
      </template>
    </el-dialog>

    <!-- 替换日志弹窗 -->
    <el-dialog title="SKU替换记录" :visible.sync="replaceLogShow" width="600px">
      <div v-loading="replaceLogLoading">
        <div class="replace-log-tip">点击链接可查看详情</div>
        <el-table :data="replaceLogList" :header-cell-style="{ background: '#eef1f6', color: '#606266' }" max-height="400">
          <el-table-column label="时间" prop="created_at_text" width="180" align="center"></el-table-column>
          <el-table-column label="链接" align="center">
            <template #default="{ row }">
              <a :href="row.url" target="_blank" class="replace-log-link">{{ row.url }}</a>
            </template>
          </el-table-column>
        </el-table>
        <el-empty v-if="replaceLogList.length === 0 && !replaceLogLoading" description="暂无替换记录" :image-size="80"></el-empty>
        <Pagination
          v-if="replaceLogPageData.total > 0"
          :total="replaceLogPageData.total"
          :page.sync="replaceLogPageData.page"
          :limit.sync="replaceLogPageData.limit"
          @pagination="getReplaceLogData"
          layout="total, prev, pager, next"
        />
      </div>
    </el-dialog>

    <!-- 云商品编辑弹窗 -->
    <el-dialog
      :title="cloudEditMode === 'batch' ? '批量编辑云商品' : '编辑云商品'"
      :visible.sync="cloudEditShow"
      :close-on-click-modal="false"
      top="5vh"
      :width="cloudEditMode === 'batch' ? '86%' : '70%'"
      @close="handleCloudEditClose"
    >
      <div class="cloud-edit-container" :class="{ 'single-mode': cloudEditMode === 'single' }">
        <div class="cloud-edit-left" v-if="cloudEditMode === 'batch'">
          <div class="panel-header cloud-edit-filter">
            <span>筛选</span>
            <el-select
              v-model="cloudEditGroupId"
              placeholder="全部分组"
              clearable
              filterable
              size="small"
              :loading="groupLoading"
              style="width: 120px;"
              @change="handleCloudEditFilterGroupChange"
            >
              <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
            <el-select
              v-model="cloudEditChildGroupId"
              placeholder="全部子分组"
              clearable
              filterable
              size="small"
              :loading="groupLoading"
              style="width: 120px;"
              @change="handleCloudEditFilterChange"
            >
              <el-option v-for="group in cloudEditChildGroupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
            <el-select
              v-model="cloudEditSkuStatus"
              placeholder="全部状态"
              clearable
              size="small"
              style="width: 118px;"
              @change="handleCloudEditFilterChange"
            >
              <el-option v-for="item in Object.keys(skuStatus)" :key="item" :label="skuStatus[item].label" :value="skuStatus[item].value"></el-option>
            </el-select>
            <el-select
              v-model="cloudEditAppraisalStatus"
              placeholder="全部检测"
              clearable
              size="small"
              style="width: 118px;"
              @change="handleCloudEditFilterChange"
            >
              <el-option v-for="item in Object.keys(appraisal_status)" :key="item" :label="appraisal_status[item].label" :value="appraisal_status[item].value"></el-option>
            </el-select>
          </div>
          <div class="cloud-edit-count">编辑商品 {{ cloudEditList.length }}/{{ cloudEditUseRemoteList ? cloudEditPageData.total : cloudEditSourceList.length }}</div>
          <div class="edit-product-list" v-loading="cloudEditListLoading">
            <div
              v-for="item in cloudEditList"
              :key="item.id"
              class="edit-product-item"
              :class="{ active: cloudEditCurrent && cloudEditCurrent.id === item.id }"
              @click="handleCloudEditSelect(item)"
            >
              <el-image :src="item.main_image" class="edit-product-thumb" fit="cover"></el-image>
              <div class="edit-product-info">
                <div class="edit-product-title" :title="item.title">{{ item.title }}</div>
                <div class="edit-product-meta">¥{{ item.price }}</div>
                <div class="edit-product-meta">{{ item.updated_at_text }}</div>
              </div>
            </div>
            <el-empty v-if="cloudEditList.length === 0" description="暂无商品" :image-size="80"></el-empty>
          </div>
          <div
            v-if="cloudEditUseRemoteList && cloudEditPageData.total > 0"
            class="panel-pagination cloud-edit-pagination"
          >
            <el-pagination
              small
              :current-page.sync="cloudEditPageData.page"
              :page-size.sync="cloudEditPageData.limit"
              :pager-count="5"
              :page-sizes="[10, 20, 50]"
              :total="cloudEditPageData.total"
              @size-change="handleCloudEditRemoteSizeChange"
              @current-change="handleCloudEditRemoteCurrentChange"
            />
          </div>
        </div>

        <div class="cloud-edit-right" v-loading="cloudEditLoading">
          <el-form label-width="90px" size="small" v-if="cloudEditForm.id">
            <el-form-item label="商品标题" required>
<!--              <el-input v-model="cloudEditForm.title" maxlength="120" show-word-limit @input="markCloudEditDirty"></el-input>-->
              <el-popover
                  v-model="showError"
                  placement="top-start"
                  trigger="manual"
                  popper-class="custom-error-popover"
              >
                <div class="popover-content">
                  <i class="el-icon-warning warning-icon"></i>
                  <span>{{ errorMessage }}</span>
                </div>

                <div slot="reference" class="input-wrapper" :class="{ 'has-error': showError }" >
                  <el-input
                      v-model="cloudEditForm.title"
                      placeholder="请输入商品标题"
                      @input="handleRealtimeValidate"
                      @blur="handleBlurValidate"
                      maxlength="120" show-word-limit
                  />
                </div>
              </el-popover>
              <div style="color: red;line-height: 18px;margin-top: 2px;">
                <p>1. 真实准确：标题应围绕商品本身填写，准确描述商品核心信息。</p>
                <p>2. 信息相关：标题中只保留与当前商品直接相关的内容，不添加无关词、误导词、蹭热词。</p>
                <p>3. 表达规范：避免异常符号、乱码、重复堆砌、刻意装饰等影响阅读的写法。</p>
                <p>4. 资质一致：涉及品牌、特殊身份或特殊经营属性时，标题内容应与商家实际资质、商品属性保持一致。</p>
              </div>
            </el-form-item>

            <el-form-item label="商品图片" required>
              <div class="edit-image-actions">
                <el-button size="mini" type="primary" @click="openImageSourceDialog('main')">添加图片</el-button>
                <span class="edit-image-limit" :class="{ invalid: cloudEditForm.main_images.length < 3 }">
                  至少3张，当前 {{ cloudEditForm.main_images.length }} 张，不能上传一样的图片。（第一张为主图）
                </span>
              </div>
              <div class="edit-image-list">
                <div v-for="(url, index) in cloudEditForm.main_images" :key="url + index" class="edit-image-item">
                  <el-image :src="url" fit="cover" :preview-src-list="cloudEditForm.main_images"></el-image>
                  <div class="edit-image-toolbar">
                    <i class="el-icon-arrow-left" @click="moveCloudEditImage('main', index, -1)"></i>
                    <i class="el-icon-arrow-right" @click="moveCloudEditImage('main', index, 1)"></i>
                    <i class="el-icon-delete" @click="removeCloudEditImage('main', index)"></i>
                  </div>
                </div>
              </div>
            </el-form-item>
<!--            <el-form-item label="商品类目" required>
              <el-select v-model="cateRecommend" @focus="getCategoryRecommend" clearable style="width: 100%">
                <div style="display: flex;justify-content: space-between;align-items: center;padding: 0 20px;">
                  <div style="color: orange;font-size: 14px;">根据抖店官方要求，类目匹配只能选择以下官方推荐类目</div>
                  <el-button type="text" class="el-icon-refresh" @click="getCategoryRecommend(1000)">重新匹配</el-button>
                </div>
                <div v-loading="crLoading">
                <el-option v-for="(item,index) in cateRecommendList" :key="index" :value="item.id" :label="item.name">
                  <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div>{{item.name}}</div>
                    <div style="color: #606266;" v-if="item.qualification_status!=0">类目未开通，<a href="https://fxg.jinritemai.com/ffa/grs-new/qualification/list" target="_blank" rel="noopener noreferrer" style="color:#1966ff;">去开通</a></div>
                  </div>
                </el-option>
                </div>
              </el-select>
            </el-form-item>-->

            <el-form-item label="详情图片" required>
              <div class="edit-image-actions">
                <el-button size="mini" type="primary" @click="openImageSourceDialog('detail')">添加图片</el-button>
                <span class="edit-image-limit" :class="{ invalid: cloudEditForm.detail_images.length < 2 }">
                  至少2张，当前 {{ cloudEditForm.detail_images.length }} 张，不能上传一样的图片
                </span>
              </div>
              <div class="edit-image-list">
                <div v-for="(url, index) in cloudEditForm.detail_images" :key="url + index" class="edit-image-item">
                  <el-image :src="url" fit="cover" :preview-src-list="cloudEditForm.detail_images"></el-image>
                  <div class="edit-image-toolbar">
                    <i class="el-icon-arrow-left" @click="moveCloudEditImage('detail', index, -1)"></i>
                    <i class="el-icon-arrow-right" @click="moveCloudEditImage('detail', index, 1)"></i>
                    <i class="el-icon-delete" @click="removeCloudEditImage('detail', index)"></i>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="SKU" required>
              <div class="sku-spec-editor readonly">
                <div class="sku-spec-row" v-for="(spec, specIndex) in cloudEditForm.skuSpecs" :key="specIndex">
                  <div class="sku-spec-name">{{ spec.name }}</div>
                  <div class="sku-spec-values">
                    <el-tag
                      v-for="(value, valueIndex) in spec.values"
                      :key="valueIndex"
                      closable
                      size="small"
                      @close="removeSkuSpecValue(specIndex, valueIndex)"
                    >{{ value }}</el-tag>
                  </div>
                </div>
              </div>
              <div class="sku-value-image-editor" v-if="cloudEditForm.skuSpecs.length && cloudEditForm.skuSpecs[0].name && cloudEditForm.skuSpecs[0].values.length">
                <div class="sku-value-image-title">{{ cloudEditForm.skuSpecs[0].name }} 图片</div>
                <div class="sku-value-image-list">
                  <div class="sku-value-image-item" v-for="value in cloudEditForm.skuSpecs[0].values" :key="value">
                    <div class="sku-value-name" :title="value">{{ value }}</div>
                    <el-image
                      v-if="cloudEditForm.skuValueImages[value]"
                      :src="cloudEditForm.skuValueImages[value]"
                      :preview-src-list="[cloudEditForm.skuValueImages[value]]"
                      class="sku-value-thumb"
                      fit="cover"
                    ></el-image>
                    <span v-else class="sku-image-empty">未设置</span>
                    <el-button size="mini" @click="openImageSourceDialog('skuValue', value)">
                      {{ cloudEditForm.skuValueImages[value] ? '更换' : '选择' }}
                    </el-button>
                    <el-button v-if="cloudEditForm.skuValueImages[value]" size="mini" type="text" @click="clearSkuValueImage(value)">删除</el-button>
                  </div>
                </div>
              </div>
              <el-table :data="cloudEditForm.skus" border size="mini" class="edit-sku-table">
                <el-table-column label="状态" width="90" align="center">
                  <template #default="{ row }">
                    <el-tag :type="row.enabled ? 'success' : 'info'" size="mini">
                      {{ row.enabled ? '保留' : '已移除' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="规格" min-width="220">
                  <template #default="{ row }">
                    <span :class="{ 'sku-disabled-text': !row.enabled }">{{ formatSkuAttributes(row.attributes) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="价格" width="110">
                  <template #default="{ row }">
                    <el-input-number v-model="row.price" :disabled="!row.enabled" :min="0" :precision="2" :controls="false" @change="markCloudEditDirty"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="库存" width="100">
                  <template #default="{ row }">
                    <el-input-number v-model="row.stock" :disabled="!row.enabled" :min="0" :precision="0" :controls="false" @change="markCloudEditDirty"></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>
          <el-empty v-else description="请选择左侧商品" :image-size="100"></el-empty>
        </div>
      </div>
      <template #footer>
        <span class="selected-info" v-if="cloudEditDirty">有未保存修改</span>
        <el-button @click="cloudEditShow = false">关闭</el-button>
        <el-button type="primary" :loading="cloudEditSaving" @click="submitCloudEdit">保存</el-button>
      </template>
    </el-dialog>
    <image-source-dialog
      :visible.sync="imageSourceDialog.visible"
      :title="imageSourceDialog.title"
      :headers="uploadHeaders"
      :multiple="imageSourceDialog.multiple"
      :existing-urls="imageSourceDialog.existingUrls"
      :direct-upload="true"
      @select="handleImageSourceSelect"
    />

    <!-- 替换日志弹窗 -->
    <el-dialog title="标题替换记录" :visible.sync="replaceTitleLogShow" width="800px">
      <div v-loading="replaceTitleLogLoading">
        <!-- <div class="replace-log-tip">点击链接可查看详情</div> -->
        <el-table :data="replaceTitleLogList" :header-cell-style="{ background: '#eef1f6', color: '#606266' }" max-height="400">
          <el-table-column label="时间" prop="updated_at" width="180" align="center"></el-table-column>
          <!-- 关键：加宽 + 自动换行 -->
            <el-table-column
                label="标题"
                align="center"
                min-width="550"
            >
                <template #default="{ row }">
                <div class="log-title-group">
                    <div class="log-title-item">
                    原：{{ row.title }}
                    </div>
                    <div class="log-title-item">
                    AI：{{ row.new_title }}
                    </div>
                    <div class="log-title-item" v-if="row.update_title">
                    改：{{ row.update_title }}
                    </div>
                </div>
                </template>
            </el-table-column>
        </el-table>
        <el-empty v-if="replaceTitleLogList.length === 0 && !replaceLogLoading" description="暂无替换记录" :image-size="80"></el-empty>
      </div>
    </el-dialog>

    <!-- 指定商品sku替换弹窗 -->
    <el-dialog title="替换商品" :visible.sync="linkReplaceVisible">
      <template #title>
        替换商品SKU：{{linkReplaceForm.title}}
      </template>
      <div >
        <el-form label-width="150px" ref="linkReplaceFormRef" :model="linkReplaceForm" >
          <el-form-item label="商品来源：" prop="source_web" >1688</el-form-item>
          <el-form-item label="AI替换备选链接：" prop="source_web" >
            <div v-for="(item,index) in linkReplaceForm.replaceable" :key="index" style="display: flex;align-items: center;gap: 6px;">
              <el-button size="small" :disabled="item.is_current" @click="linkReplaceForm.produceLink=item.backup_url">{{item.backup_url}}</el-button>
              <a :href="item.backup_url" target="_blank" rel="noopener noreferrer" style="color:#1966ff;">查看</a>
            </div>
          </el-form-item>
          <el-form-item label="商品链接：" prop="produceLink" :rules="[{ required: true, message: '请输入1688商品链接', trigger: 'change' }]" >
            <el-input v-model="linkReplaceForm.produceLink" placeholder="请输入1688商品链接" clearable></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-top: 20px;display: flex;justify-content: flex-end">
          <el-button @click="linkReplaceVisible = false">取消</el-button>
          <el-button type="primary" @click="submitLinkReplace" :loading="lrLoading">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 批量替换指定链接SKU -->
    <el-dialog :close-on-click-modal="false" :visible.sync="batchLinkVisible" title="批量替换指定链接SKU" top="5vh" width="80%"
               @close="handleCancelImageSearch">
      <div class="sku-box">
        <div class="image-search-container-new">
          <!-- 左侧：待搜商品列表 -->
          <div class="search-left-panel">
            <div class="panel-header" style="display: flex;align-items: flex-start;gap: 10px;">
              <div style="width: fit-content;line-height: 32px;">筛选</div>
              <div style="flex: 1;display: flex;flex-wrap: wrap;gap: 4px;">
                <el-select v-model="skuGroupId" placeholder="全部分组" clearable @change="searchSkuGroupReplaceList" size="small" style="width: 140px;">
                  <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
                <el-select v-model="skuStatusValue" placeholder="全部状态" clearable @change="searchSkuReplaceList" size="small" style="width: 140px">
                  <el-option v-for="item in Object.keys(skuStatus)" :key="item" :label="skuStatus[item].label" :value="skuStatus[item].value"></el-option>
                </el-select>
                <el-select v-model="skuChildGroupId" placeholder="全部子分组" clearable @change="searchSkuReplaceList" size="small" style="width: 140px;">
                  <el-option v-for="group in sku_child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
                <el-select v-model="appraisalStatusValue" placeholder="全部检测" clearable @change="searchSkuReplaceList" size="small" style="width: 140px">
                  <el-option v-for="item in Object.keys(appraisal_status)" :key="item" :label="appraisal_status[item].label" :value="appraisal_status[item].value"></el-option>
                </el-select>
                <el-select v-model="skuIsSkuMiss" placeholder="是否缺少sku图" clearable @change="searchSkuReplaceList" size="small" style="width: 140px;">
                  <el-option label="不缺sku图" :value="1"></el-option>
                  <el-option label="缺少sku图" :value="2"></el-option>
                </el-select>
              </div>
            </div>
            <div class="product-list" ref="productList" v-loading="skuLoading">
              <div
                  v-for="(item,index) in imageSearchList"
                  :key="item.id"
                  :class="{ active: currentSearchProduct && currentSearchProduct.id === item.id, selected: selectedReplaceMap[item.id], replaced: replacedProductIds.includes(item.id) }"
                  class="product-item"
                  @click="handleSelectLinkProduct(item,index)"
              >
                <el-popover
                    placement="top"
                    :fallback-placements="[ 'top', 'right', 'left','bottom']"
                    width="350"
                    trigger="hover">
                  <div class="popover-content">
                    <el-image  :src="item.main_image" fit="contain" style="width:100%;height: auto"></el-image>
                  </div>
                  <el-image slot="reference"  :src="item.main_image" class="thumb"></el-image>
                </el-popover>
                <div class="info">
                  <div :title="item.title" class="title">{{ item.title }}</div>
                  <div class="price">¥{{ item.price }}</div>
                  <div v-if="item.updated_at_text" class="update-time">{{ item.updated_at_text }}</div>
                  <div :class="skuStatus[item.sku_status].type">{{skuStatus[item.sku_status].label}}</div>
                </div>
              </div>
            </div>
            <div class="panel-pagination">
              <el-pagination small :current-page.sync="skuPageData.page" :page-size.sync="skuPageData.limit" :pager-count="5"
                             :page-sizes="[20,50,100]" :total="skuPageData.total"
                             @size-change="handleSizeChangeSku" @current-change="handleCurrentChangeSku" v-if="skuPageData.total>1"/>
            </div>
          </div>

          <!-- 右侧：商品详情 + 搜索结果 -->
          <div class="search-right-area">
            <!-- 右上：当前商品SKU信息 -->
            <div v-if="currentSearchProduct" class="product-detail-panel">
              <div class="panel-header">
                <div style="flex: 1"> 当前商品SKU</div>
                <div v-if="currentSearchProduct" class="sub-header">
                  {{ currentSearchProduct.title }}
                </div>
                <el-button size="small" type="text" @click="skuVisible = !skuVisible" style="margin-left: 15px">
                  {{skuVisible?'收起':'展开'}}
                  <i :class="skuVisible?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                </el-button>
              </div>
              <div class="product-detail-content" v-if="skuVisible">
                <!-- SKU信息 -->
                <div v-if="currentProductDetail && currentProductDetail.skus && currentProductDetail.skus.length > 0"
                     class="sku-info-section">
                  <div class="sku-list">
                    <div v-for="sku in currentProductDetail.skus" :key="sku.sku_id" class="sku-item">
                      <div class="sku-spec">{{ sku.attributes_text || '默认规格' }}</div>
                      <div class="sku-details">
                        <span class="sku-price">¥{{ sku.price }}</span>
                        <!--                      <span class="sku-stock">库存:{{sku.stock}}</span>-->
                        <!--                      <span class="sku-code">{{sku.sku_code}}</span>-->
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="currentSearchProduct" class="sku-info-section">
                  <div class="no-sku-info">暂无SKU详细信息</div>
                </div>
              </div>
            </div>
            <div v-loading="imageSearchLoading" class="search-result-panel">
              <div class="panel-header">
                <div class="header-left">
                  AI替换备选链接
                </div>
                <div class="header-right"></div>
              </div>

              <div class="search-result-link" ref="searchResultGrid" >
                <div class="replace-box">
                  <div class="label">商品链接：</div>
                  <el-input v-model="replaceLink" placeholder="请输入1688商品链接" clearable style="flex: 1;"></el-input>
                  <el-button type="primary" @click="submitBatchLinkReplace" :loading="lrLoading">替换</el-button>
                </div>
                <div v-for="(item,index) in alternativeLinks" :key="index" class="link-item" >
                  <el-button size="small" :disabled="item.is_current" @click="replaceLink=item.backup_url">{{item.backup_url}}</el-button>
                  <a :href="item.backup_url" target="_blank" rel="noopener noreferrer" style="color:#1966ff;">查看</a>
                </div>
              </div>
              <div class="empty-result" v-if="!alternativeLinks.length">
                <i class="el-icon-search"></i>
                <p>暂无备选链接</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleCancelImageSearch">关闭</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="各省首件运费" :visible.sync="freightDetailVisible" width="500px" append-to-body>
      <el-table v-loading="freightDetailLoading" :data="freightDetails" max-height="420" size="small">
        <el-table-column prop="province_name" label="发往省份" align="center"></el-table-column>
        <el-table-column label="首件运费" align="center">
          <template #default="{ row }">
            {{ row.destination_freight_status === 'calculated' ? row.destination_freight + ' 元' : '未知' }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="getDistributeRecordDialogTitle()" :visible.sync="distributeRecordShow" width="1100px" append-to-body>
      <div v-loading="distributeRecordLoading" class="distribute-record-list">
        <el-empty v-if="distributeRecordList.length === 0 && !distributeRecordLoading" description="暂无铺货日志" :image-size="80"></el-empty>
        <div v-for="record in distributeRecordList" :key="record.id" class="distribute-record-item" :class="{ 'is-error': isDistributeRecordError(record) }">
          <div class="distribute-record-header">
            <span>铺货记录 #{{ record.id }}</span>
            <div class="distribute-record-tags">
              <el-tag :type="getDistributeStatusTag(record.distribute_status)" size="mini">铺货：{{ record.distribute_status_text || '未知' }}</el-tag>
              <el-tag :type="getPlatformStatusTag(record.platform_status)" size="mini">平台：{{ record.platform_status_text || '未知' }}</el-tag>
              <el-tag v-if="record.platform_delete_status_text" :type="Number(record.platform_delete_status) === 0 ? 'info' : 'danger'" size="mini">删除：{{ record.platform_delete_status_text }}</el-tag>
              <el-tag v-if="isDistributeRecordFlagEnabled(record.platform_ban_status)" type="danger" size="mini">已封禁</el-tag>
              <el-tag v-if="isDistributeRecordFlagEnabled(record.platform_stock_status)" type="warning" size="mini">售罄</el-tag>
            </div>
          </div>
          <div class="distribute-record-grid">
            <div><span>店铺</span>{{ record.shop_name || record.mer_shop_id || '-' }}</div>
            <div><span>店铺平台</span>{{ record.shop_type_text || '-' }}</div>
            <div><span>平台商品 ID</span>{{ record.platform_product_id || '-' }}</div>
            <div><span>消耗算力</span>{{ record.use_quota_num === undefined || record.use_quota_num === null ? '-' : record.use_quota_num }}</div>
            <div><span>创建时间</span>{{ record.created_at_text || '-' }}</div>
            <div><span>最后更新时间</span>{{ record.updated_at_text || '-' }}</div>
          </div>
          <div v-if="record.error_msg" class="distribute-record-error">错误原因：{{ record.error_msg }}</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { mapActions } from "vuex";
import JSZip from "jszip";
import md5 from "js-md5";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import Pagination from "@/components/pagination/pagination.vue";
// import AiTitleReplaceTask from "./aiTitleReplace/aiTitleReplaceTask.vue";
import common from '@/assets/js/utils/common.js';
import ShareGoods from "./shareGoods.vue";
import ImageSourceDialog from "./components/ImageSourceDialog.vue";
import config from "@/assets/js/conf/config";
import areaData from '@/assets/js/data/area.js';

const MAINLAND_PROVINCE_CODES = ['110000', '120000', '130000', '140000', '150000', '210000', '220000', '230000', '310000', '320000', '330000', '340000', '350000', '360000', '370000', '410000', '420000', '430000', '440000', '450000', '460000', '500000', '510000', '520000', '530000', '540000', '610000', '620000', '630000', '640000', '650000', '710000', '810000', '820000'];

export default {
  name: 'ucenterProduct',
  components: {
    Pagination,
    ucMenu,
    myHead,
    myFoot,
    ShareGoods,
    ImageSourceDialog,
  },
  data() {
    return {
      // Tab 控制
      ismanager: true,
      activeTab: 'import',
      pageSizes: [10, 20, 50, 100, 200, 1000, 2000],
      // === 导入模块数据 ===
      loading: false,
      tableData: [],
      page_data: {
        limit: 10,
        page: 1,
        total: 0,
      },
      txtContents: [],
      imLoading: false,
      upLoading: false,
      upErr: false,
      importSize: 100,
      importShow: false,
      importInfo: { products: [], source_method: '', source_web: 3, page: 1, group_id: '', child_group_id: '',produceLinks:'', startIndex: 0},
      zipFileName: "",
      batchNum:0 ,//导入的批次数量
      statusTag: ['warning', 'info', 'success', 'danger'], // 0待处理 1处理中 2已完成 3已取消
      itemStatusTag: ['primary', 'success', 'danger', 'info'], // 0待处理 1成功 2失败 3重复跳过
      sourceList: [{ value: 9, label: '星好货' }, { value: 3, label: 'TB' }, { value: 4, label: 'PDD' }, { value: 2, label: '1688' }, { value: 5, label: 'DY' }, { value: 6, label: 'WX' }],
      wx_collectList: [{ value: 12, label: '小店助手' }],
      collectList: [
          // { value: 1, label: '壹方' },
        { value: 2, label: '万象' },
        { value: 3, label: '老虎' },
        { value: 6, label: '萤火虫' },
        { value: 8, label: '大王' }],
      pdd_collectList: [{ value: 4, label: '极速' }, { value: 5, label: '晨飞' }, { value: 7, label: '星云' }, { value: 9, label: '大王' }, { value: 10, label: '兵哥哥' }, { value: 13, label: '豪哥' }],
      dy_collectList: [{ value: 11, label: '万象(json)' }],
      shopTypeList:[{name: '抖店', shop_type: 1},{name: '微信', shop_type: 7}],
      // 抖店同步任务：从三方同步系统拉商品后导入云商品库
      doudianSyncShow: false,
      doudianSyncCreateShow: false,
      doudianSyncLoading: false,
      doudianSyncCreateLoading: false,
      doudianShopList: [],
      doudianSyncTasks: [],
      doudianSyncPage: {
        page: 1,
        limit: 10,
        total: 0,
      },
      doudianSyncFilterForm: {
        shop_id: '',
        status: '',
        dateRange: [],
      },
      doudianSyncCreateForm: {
        shop_id: '',
        dateRange: [],
        group_id: '',
        child_group_id: '',
        quickRange: '30d',
      },

      // 删除批次铺货相关变量，现在不在导入模块中铺货

      // === 云商品列表模块数据 ===
      cloudLoading: false,
      cloudTableData: [],
      productMarkViewShow: false,
      productMarkViewLoading: false,
      productMarkViewItems: [],
      distributeRecordShow: false,
      distributeRecordLoading: false,
      distributeRecordList: [],
      distributeRecordProductTitle: '',
      distributeRecordSourceProductId: '',
      freightDetailVisible: false,
      freightDetailLoading: false,
      freightDetails: [],
      cloudPageData: {
        limit: 20,
        page: 1,
        total: 0,
      },
      cloudSearchParams: {
        status: '',
        keyword: '',
        batch_no: '',
        source_product_id: '',
        platform_product_id: '',
        source_web: '',
        distribution_free_postage: '',
        freight_province_code: '',
        min_price: '',
        max_price: '',
        sku_status: '',
        sku_mark_status: '',
        exclude_distributed: [],
        distribute_status: '',
        group_id: '',
        child_group_id: '',
        ai_title_status:'',
        sortField: '',   // 排序字段：created_at / updated_at
        sortOrder: '',    // 排序顺序：asc / desc
        is_sku_miss: '',
        has_distribute_success: '',
        has_distribute_fail: '',
        has_distribute_ban: '',
        has_distribute_review_fail: ''
      },
      provinceOptions: MAINLAND_PROVINCE_CODES.map(value => ({ value, label: areaData.province_list[value] })),
      excludeShopList: [], // 排除已铺货店铺列表
      // 分组相关
      groupList: [], // 分组列表
      child_groupList: [], // 子分组列表
      doudianChildGroupList: [],
      sku_child_groupList: [], // 子分组列表
      groupLoading: false,
      groupFormShow: false, // 分组表单弹窗
      groupForm: { name: '', child_name: '', sort: 0, grade: 1, parent_id: '' },
      groupFormEdit: false, // 是否是编辑模式
      groupFormLoading: false,
      group_grade_options: [{
          value: 1,
          label: '主分组'
        },
        {
          value: 2,
          label: '子分组'
        }],
      batchGroupShow: false, // 批量加入分组弹窗
      batchGroupId: '', // 批量加入的分组ID
      batchChildGroupId: '', // 批量加入的分组ID
      set_child_groupList: [], // 子分组列表
      batchGroupLoading: false,
      // 替换日志相关
      replaceLogShow: false,
      replaceLogLoading: false,
      replaceTitleLogShow: false,
      replaceTitleLogLoading: false,
      replaceLogList: [],
      replaceTitleLogList: [],
      replaceLogPageData: {
        limit: 10,
        page: 1,
        total: 0,
      },
      currentReplaceLogItemId: null, // 当前查看日志的商品ID
      cloudStatusList: [
        { label: '待处理', value: 0 },
        { label: '成功', value: 1 },
        { label: '失败', value: 2 },
        { label: '重复跳过', value: 3 },
      ],
      cloudSelectedList: [],
      cloudStats: { total: 0, pending_count: 0, success_count: 0, fail_count: 0, duplicate_count: 0,offline_count:0 },
      //指定替换相关
      linkReplaceVisible:false,
      linkReplaceForm:{produceLink:''},
      lrLoading:false,
      //批量指定链接替换
      batchLinkVisible:false,
      alternativeLinks:[],
      replaceLink:'',
      showError: false,
      errorMessage: '',
      cateRecommend:'',
      cateRecommendList:[],
      crLoading:false,

      // 云商品铺货弹窗
      cloudDistributeShow: false,
      cloudShopList: [],
      cloudShopLoading: false,
      cloudCheckAll: false,
      cloudIsIndeterminate: false,
      cloudTableKey: Math.random(),
      cloudDistributeLoading: false,
      cloudSelectedShopIds: [], // 选中的店铺ID列表
      cloudShopTab: 'douyin', // 店铺Tab切换，默认抖店

      // 以图搜款
      imageSearchShow: false,
      isDebounce: false, //防抖
      imageSearchLoading: false,
      imageSearchList: [], // 左侧待搜商品列表
      currentSearchProduct: null, // 当前选中的待搜商品
      currentSearchProductIndex: -1,//当前选中的待搜商品索引
      currentProductDetail: null, // 当前商品的详细信息（包含SKU）
      imageSearchResult: [], // 右侧搜索结果
      imageSearchResultCopy: [], // 右侧搜索结果
      imageSearchCache: {}, // 缓存已搜索过的结果 {productId-filter: results[]}
      selectedReplaceMap: {}, // 记录用户选择的替换关系 {productId: newProductId}
      replaceLoading: false, // 替换提交loading
      replacedProductIds: [], // 已提交替换的商品ID列表
      replacedTargetMap: {}, // 记录每个商品替换成了哪个1688商品 {productId: offer_id}
      skuPageData: {
        limit: 20,
        page: 1,
        total: 0,
      },// 左侧待搜商品列表分页
      skuLoading:false,
      skuStatusValue:'',
      skuMarkStatusValue:'',
      appraisalStatusValue:'',
      skuGroupId:'',
      skuChildGroupId:'',
      skuIsSkuMiss:'',
      appraisal_status:{
        // 1:{label:'未检测',value:1,type:'selected-tag'},
        // 2:{label:'待检测',value:4,type:'selected-tag'},
        3:{label:'有违规',value:2,type:'replaced-tag'},
        4:{label:'无违规',value:3,type:'notFond-tag'}
      },
      skuStatus:{
        1:{label:'待替换',value:1,type:'selected-tag'},
        2:{label:'已替换',value:2,type:'replaced-tag'},
        3:{label:'找不到',value:3,type:'notFond-tag'}
      },
      skuMarkStatus:{
        1:{label:'未标记',value:1,type:'selected-tag'},
        2:{label:'已标记',value:2,type:'replaced-tag'},
        3:{label:'找不到',value:3,type:'notFond-tag'}
      },
      aiTitleStatus:{
        1:{label:'待替换',value:1,type:'selected-tag'},
        2:{label:'已替换',value:2,type:'replaced-tag'},
        9:{label:'异常',value:3,type:'notFond-tag'}
      },
      skuVisible:false,//sku板可见
      priceSort:'',//价格排序

      // 过滤条件
      searchFilters: [], // 当前选中的过滤条件
      filterVisible: false, // 过滤面板是否可见
      // 二级select相关状态
      selectedCategory: '', // 当前选中的分类
      selectedOption: '', // 当前选中的具体选项
      pendingFilters: [], // 待确认的过滤条件
      filterOptions: [
        {
          title: '发货时效',
          key: 'shipping',
          options: [
            { label: '当天发货', value: 'shipInToday' },
            { label: '24小时发货', value: 'shipIn24Hours' },
            { label: '48小时发货', value: 'shipIn48Hours' }
          ]
        },
        {
          title: '揽收率',
          key: 'getRate',
          options: [
            { label: '24小时揽收率 <95%', value: 'getRate24HLv1' },
            { label: '24小时揽收率 ≥95%', value: 'getRate24HLv2' },
            { label: '24小时揽收率 ≥99%', value: 'getRate24HLv3' },
            { label: '48小时揽收率 <95%', value: 'getRate48HLv1' },
            { label: '48小时揽收率 ≥95%', value: 'getRate48HLv2' },
            { label: '48小时揽收率 ≥99%', value: 'getRate48HLv3' }
          ]
        },
        {
          title: '退款率',
          key: 'refundRate',
          options: [
            { label: '品质退款率 ≤0.005%', value: 'rfdQualityRateLv1' },
            { label: '品质退款率 ≤0.15%', value: 'rfdQualityRateLv2' },
            { label: '品质退款率 ≤0.30%', value: 'rfdQualityRateLv3' },
            { label: '品质退款率 >0.3%', value: 'rfdQualityRateLv4' },
            { label: '总退款率 ≤1%', value: 'rfdRateLv1' },
            { label: '总退款率 ≤3%', value: 'rfdRateLv2' },
            { label: '总退款率 ≤5%', value: 'rfdRateLv3' },
            { label: '总退款率 >5%', value: 'rfdRateLv4' }
          ]
        },
        {
          title: '服务保障',
          key: 'service',
          options: [
            { label: '7天无理由退换货', value: 'noReason7DReturn' },
            { label: '实力商家', value: 'powerMerchant' },
            { label: '认证工厂', value: 'certifiedFactory' }
          ]
        },
        {
          title: '履约质量',
          key: 'quality',
          options: [
            { label: '综合体验分 5星', value: 'totalEpScoreLv1' },
            { label: '综合体验分 4.5-5.0星', value: 'totalEpScoreLv2' },
            { label: '综合体验分 4-4.5星', value: 'totalEpScoreLv3' },
            { label: '综合体验分 4星以下', value: 'totalEpScoreLv4' }
          ]
        },
        {
          title: '增值服务',
          key: 'addedService',
          options: [
            { label: '免费贊账', value: 'freeCredit' },
            { label: '支持一件代发', value: 'isOnePsale' },
            { label: '一件代发包邮', value: 'isOnePsaleFreePost' },
            { label: '支持抖音密文打单', value: 'dyCiphertext' },
            { label: '支持快手密文打单', value: 'ksCiphertext' },
            {label: '支持微信小店密文下单', value: 'wxCiphertext'},
            {label: '支持淘宝密文下单', value: 'tbCiphertext'},
            {label: '支持拼多多密文下单', value: 'pddCiphertext'},
            {label: '支持小红书密文下单', value: 'xhsCiphertext'},
            {label: '支持京东密文下单', value: 'jdCiphertext'},


          ]
        }
      ],
      strategyType:'',//策略类型 1-优先策略 2-默认策略
      strategyCache:{},//策略缓存

      // === 铺货列表模块数据 ===
      distributeLoading: false,
      distributeTableData: [],
      distributePageData: {
        limit: 20,
        page: 1,
        total: 0,
      },
      distributeSearchParams: {
        status: '',
        shop_id: '',
        keyword: '',
        shop_type: '',
        dateRange: [],
      },
      distributeStatusList: [
        { label: '待铺货', value: 1 },
        { label: '铺货中', value: 2 },
        { label: '铺货失败', value: 3 },
        { label: '铺货成功', value: 4 },
      ],
      distributeStatusTag: {
        1: 'warning',
        2: 'success',
        3: 'danger',
        4: 'success'
      },
      filterShopList: [], // 铺货列表的店铺筛选
      distributeStats: { total: 0, distributed_count: 0, pending_count: 0, fail_count: 0 }, // 铺货统计数据
      userinfo:{},
      aiReplace: false,
      aiMarkMode: false,
      replace_title: 'SKU替换',
      power_num:0,
      cloudEditShow: false,
      cloudEditLoading: false,
      cloudEditSaving: false,
      cloudEditList: [],
      cloudEditSourceList: [],
      cloudEditGroupId: '',
      cloudEditChildGroupId: '',
      cloudEditChildGroupList: '',
      cloudEditAppliedGroupId: '',
      cloudEditSkuStatus: '',
      cloudEditAppliedSkuStatus: '',
      cloudEditAppraisalStatus: '',
      cloudEditAppliedAppraisalStatus: '',
      cloudEditUseRemoteList: false,
      cloudEditListLoading: false,
      cloudEditRemoteSearchParams: {},
      cloudEditRemoteParams: {},
      cloudEditPageData: {
        page: 1,
        limit: 10,
        total: 0,
      },
      cloudEditAppliedPageData: {
        page: 1,
        limit: 10,
      },
      cloudEditCurrent: null,
      cloudEditMode: 'single',
      cloudEditDirty: false,
      cloudEditForm: {
        id: '',
        product_id: '',
        title: '',
        price: '',
        main_images: [],
        detail_images: [],
        skuSpecs: [],
        skus: [],
        skuValueImages: {},
      },
      imageSourceDialog: {
        visible: false,
        target: '',
        skuIndex: -1,
        title: '添加图片',
        multiple: true,
        existingUrls: [],
      },
      childSelectKey: 0,
      // === 分组管理模块 ===
      groupPageData: {
        limit: 20,
        page: 1,
        total: 0,
      },
      groupSearchParams: {main_name: '', child_name: ''},
      groupTableData: [],
      groupExpandedKeys: [],
      groupExpandedParentId: null,
      groupChildrenData: [],
      groupChildrenLoading: false,
      groupChildrenPageData: {page: 1, limit: 50, total: 0},
      groupParentRequestId: 0,
      groupChildrenRequestId: 0,
    }
  },
  created() {
    this.getUserInfo()
    if (this.$route.query.tab ) {
      this.activeTab =this.$route.query.tab
      if(this.activeTab === 'list'){
        this.cloudSearchParams.source_product_id = this.$route.query.source_product_id || ''
        this.getCloudDataList()
      }
    } else {
      this.getDataList()
    }
    this.loadGroupList()
    //策略缓存
    this.strategyCache = localStorage.getItem('strategyCache')?JSON.parse(localStorage.getItem('strategyCache')):{ex_time:0,value:{}}
    if(this.strategyCache.ex_time< new Date().getTime()){
      localStorage.removeItem('strategyCache')
      this.strategyCache ={ex_time:0,value:{}}
    }
  },
  computed: {
    cloudStatusTabs() {
        const stats = this.cloudStats || { total: 0, pending_count: 0, success_count: 0, fail_count: 0, duplicate_count: 0,offline_count:0 };
        return [
            { label: '全部商品', value: '', count: stats.total },
            { label: '待处理', value: 0, count: stats.pending_count },
            { label: '成功', value: 1, count: stats.success_count },
            { label: '失败', value: 2, count: stats.fail_count },
            { label: '重复跳过', value: 3, count: stats.duplicate_count },
            { label: '检测下架', value: 4, count: stats.offline_count },
        ]
    },
    distributeStatusTabs() {
        const stats = this.distributeStats || { total: 0, distributed_count: 0, pending_count: 0, fail_count: 0 };
        return [
            { label: '全部商品', value: '', count: stats.total },
            { label: '待铺货', value: 1, count: stats.pending_count },
            { label: '铺货中', value: 2, count: stats.distributed_count },
            { label: '铺货失败', value: 3, count: stats.fail_count },
            { label: '铺货成功', value: 4, count: stats.success_count},
        ]
    },
    // 按店铺类型分组
    cloudShopListByType() {
      const douyin = this.cloudShopList.filter(item => item.shop_type == 1)
      const wechat = this.cloudShopList.filter(item => item.shop_type == 7)
      return { douyin, wechat }
    },
    // 抖店全选状态
    cloudDouyinCheckAll: {
      get() {
        const douyinIds = this.cloudShopListByType.douyin.map(s => s.shop_id)
        if (douyinIds.length === 0) return false
        return douyinIds.every(id => this.cloudSelectedShopIds.includes(id))
      },
      set() {}
    },
    cloudDouyinIndeterminate() {
      const douyinIds = this.cloudShopListByType.douyin.map(s => s.shop_id)
      if (douyinIds.length === 0) return false
      const selected = douyinIds.filter(id => this.cloudSelectedShopIds.includes(id))
      return selected.length > 0 && selected.length < douyinIds.length
    },
    // 微信店铺全选状态
    cloudWechatCheckAll: {
      get() {
        const wechatIds = this.cloudShopListByType.wechat.map(s => s.shop_id)
        if (wechatIds.length === 0) return false
        return wechatIds.every(id => this.cloudSelectedShopIds.includes(id))
      },
      set() {}
    },
    cloudWechatIndeterminate() {
      const wechatIds = this.cloudShopListByType.wechat.map(s => s.shop_id)
      if (wechatIds.length === 0) return false
      const selected = wechatIds.filter(id => this.cloudSelectedShopIds.includes(id))
      return selected.length > 0 && selected.length < wechatIds.length
    },
    uploadHeaders(){
      let token = localStorage.getItem(config.tokenKey)
      return {
        'Authorization': `Bearer ${token}`
      }
    }
  },
  watch: {
    cloudShopList: {
      handler() {
        let checkedCount = this.cloudShopList.filter(item => item.is_selected == 1).length;
        this.cloudCheckAll = checkedCount === this.cloudShopList.length && this.cloudShopList.length > 0;
        this.cloudIsIndeterminate = checkedCount > 0 && checkedCount < this.cloudShopList.length;
        this.cloudTableKey = Math.random()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      getImportList: 'ucenter/getImportList',
      opImportCreate: 'ucenter/opImportCreate',
      opImportCreate1688: 'ucenter/opImportCreate1688',
      getDistributeShopSel: 'ucenter/getDistributeShopSel',
      createDistributeBatch: 'ucenter/createDistributeBatch',
      getCloudProductList: 'ucenter/getCloudProductList',
      getCloudProductDistributeRecords: 'ucenter/getCloudProductDistributeRecords',
      getCloudProductEditDetail: 'ucenter/getCloudProductEditDetail',
      getCloudProductFreightDetails: 'ucenter/getCloudProductFreightDetails',
      saveCloudProductEdit: 'ucenter/saveCloudProductEdit',
      createCloudProductDistribute: 'ucenter/createCloudProductDistribute',
      deleteCloudProducts: 'ucenter/deleteCloudProducts',
      getImageSearchList: 'ucenter/getImageSearchList',
      doReplaceCloudProducts: 'ucenter/doReplaceCloudProducts',
      doMarkCloudProduct: 'ucenter/doMarkCloudProduct',
      getProductMarkable: 'ucenter/getProductMarkable',
      getDistributeItems: 'ucenter/getDistributeItems',
      getDdShopList: 'ucenter/getDdShopList',
      opRecoverCloudProduct: 'ucenter/opRecoverCloudProduct',
      opSkuMarkNotFound: 'ucenter/opSkuMarkNotFound',
      opSkuCancelNotFound: 'ucenter/opSkuCancelNotFound',
      opProductMarkNotFound: 'ucenter/opProductMarkNotFound',
      opProductMarkNotFoundCancel: 'ucenter/opProductMarkNotFoundCancel',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      getCloudProductGroupParents: 'ucenter/getCloudProductGroupParents',
      getCloudProductGroupChildren: 'ucenter/getCloudProductGroupChildren',
      getDoudianCloudSyncTasks: 'ucenter/getDoudianCloudSyncTasks',
      createDoudianCloudSyncTask: 'ucenter/createDoudianCloudSyncTask',
      opCloudProductGroupCreate: 'ucenter/opCloudProductGroupCreate',
      opCloudProductGroupUpdate: 'ucenter/opCloudProductGroupUpdate',
      opCloudProductGroupDelete: 'ucenter/opCloudProductGroupDelete',
      opCloudProductBatchSetGroup: 'ucenter/opCloudProductBatchSetGroup',
      getReplaceLogList: 'ucenter/getReplaceLogList',
      getUserinfoData:"ucenter/getUserinfoData",
      opGetFindByProductid:"ucenter/opGetFindByProductid",
      fetchCategoryRecommend:"ucenter/fetchCategoryRecommend",
      getCloudProductGroupsNew: 'ucenter/getCloudProductGroupsNew'
    }),

    getUserInfo(){
      this.getUserinfoData({
        data: {}, success: (res) => {
          this.userinfo = res.data
          this.power_num = this.userinfo.power_num

          if(this.$route?.query?.tab === 'share'){
            this.$nextTick(()=>{
              this.$refs.shareGoods.initData()
            })
          }
        }
      })
    },
    // === Tab 切换 ===
    handleTabChange(tab) {
      this.child_groupList = []
      if (tab.name === 'list' && this.cloudTableData.length === 0) {
        this.getCloudDataList()
        this.getExcludeShopList()
      }else if(tab.name === 'list'&&this.cloudSearchParams.group_id){
        this.changeGroupId(this.cloudSearchParams.group_id)
      } else if (tab.name === 'distribute') {
        if (this.distributeTableData.length === 0) {
          this.getDistributeDataList()
        }
        if (this.filterShopList.length === 0) {
          this.getFilterShopList()
        }
      } else if (tab.name === 'group') {
        this.refreshGroupList()
      } else if(tab.name === 'keyword'){
        this.$nextTick(()=>{
          this.$refs.keywordRef.refresh()
        })
      } else if(tab.name === 'share'){
        this.$nextTick(()=>{
          this.$refs.shareGoods.initData()
        })
      } else if(tab.name === 'aiTitle'){
        this.$nextTick(()=>{
          this.$refs.AiTitleReplaceTask.initData()
        })
      }
    },

    // === 列表模块方法 ===
    getDataList() {
      this.loading = true
      let param = { page_size: this.page_data.limit, page: this.page_data.page }
      this.getImportList({
        data: param,
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list || []
            this.page_data.total = res.data.total
            this.importSize = res.data.limit || 100
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    handleRefresh() {
      this.page_data.page = 1
      this.getDataList()
    },
    formatPrice(price,index){
      let arr = price?String(price).split('.'):['0','00']
      return arr[index]
    },
    // 查看批次商品 - 跳转到云商品列表并筛选该批次
    handleView(row) {
      this.activeTab = 'list'
      // 重置所有筛选条件，防止之前的筛选（如状态、关键词）影响结果
      this.cloudSearchParams = {
        status: '',
        keyword: '',
        batch_no: row.batch_no,
        source_product_id: '',
        platform_product_id: '',
        source_web: '',
        distribution_free_postage: '',
        min_price: '',
        max_price: '',
        sku_status: '',
        ai_title_status: '',
        exclude_distributed: [],
        distribute_status: '',
        group_id: '',
        child_group_id: '',
        is_sku_miss: '',
        has_distribute_success: '',
        has_distribute_fail: '',
        has_distribute_ban: '',
        has_distribute_review_fail: ''
      }
      this.cloudPageData.page = 1
      // 延迟执行以确保 Tab 切换完成
      this.$nextTick(() => {
        this.getCloudDataList()
        this.getExcludeShopList()
        // this.loadGroupList()
      })
    },

    // === 导入商品 ===
    handleAdd() {
      this.zipFileName = ""
      this.importInfo = { products: [], source_method:'', source_web: 3, page: 0, group_id: '', child_group_id: '', startIndex: 0}
      this.batchNum=0
      this.upErr = false
      this.importShow = true
      this.$nextTick(() => {
        this.$refs.zipInput.value = "";
        this.$refs.importForm.resetFields()
      });
    },

    handleUpload() {
      if (this.$refs.zipInput) {
        this.$refs.zipInput.click()
      }
    },

    handleDoudianSyncOpen() {
      this.doudianSyncShow = true
    },

    loadDoudianSyncData() {
      this.loadDoudianShopList()
      // this.loadGroupList()
      this.getDoudianSyncTaskList()
    },

    getDefaultDoudianSyncDateRange() {
      return this.getDoudianRecentDayRange(30)
    },

    getDoudianRecentDayRange(days) {
      const end = new Date()
      const start = new Date(end.getTime() - days * 24 * 60 * 60 * 1000)
      return [start, end]
    },

    getDoudianRecentMonthRange(months) {
      const end = new Date()
      const start = new Date(end)
      start.setMonth(start.getMonth() - months)
      return [start, end]
    },

    getDoudianRangeByQuick(value) {
      if (value === '3m') return this.getDoudianRecentMonthRange(3)
      if (value === '6m') return this.getDoudianRecentMonthRange(6)
      return this.getDoudianRecentDayRange(30)
    },

    changeDoudianSyncQuickRange(value) {
      this.doudianSyncCreateForm.dateRange = this.getDoudianRangeByQuick(value)
    },

    clearDoudianSyncQuickRange() {
      this.doudianSyncCreateForm.quickRange = ''
    },

    changeDoudianSyncGroupId(groupId) {
      this.doudianSyncCreateForm.child_group_id = ''
      const target = this.groupList.find(item => item.id === groupId)
      this.doudianChildGroupList = target?.child_groups || []
    },

    openDoudianSyncCreateDialog() {
      this.doudianSyncCreateForm = {
        shop_id: '',
        dateRange: this.getDefaultDoudianSyncDateRange(),
        group_id: '',
        child_group_id: '',
        quickRange: '30d',
      }
      this.doudianChildGroupList = []
      this.doudianSyncCreateShow = true
    },

    searchDoudianSyncTasks() {
      this.doudianSyncPage.page = 1
      this.getDoudianSyncTaskList()
    },

    resetDoudianSyncFilters() {
      this.doudianSyncFilterForm = {
        shop_id: '',
        status: '',
        dateRange: [],
      }
      this.doudianSyncPage.page = 1
      this.getDoudianSyncTaskList()
    },

    buildDoudianSyncTaskListParams() {
      const params = {
        page: this.doudianSyncPage.page,
        page_size: this.doudianSyncPage.limit
      }
      if (this.doudianSyncFilterForm.shop_id) {
        params.shop_id = this.doudianSyncFilterForm.shop_id
      }
      if (this.doudianSyncFilterForm.status !== '' && this.doudianSyncFilterForm.status !== null && this.doudianSyncFilterForm.status !== undefined) {
        params.status = this.doudianSyncFilterForm.status
      }
      if (this.doudianSyncFilterForm.dateRange && this.doudianSyncFilterForm.dateRange.length === 2) {
        const [start, end] = this.doudianSyncFilterForm.dateRange
        const startTime = Math.floor(new Date(start).getTime() / 1000)
        const endTime = Math.floor(new Date(end).getTime() / 1000)
        if (startTime && endTime && startTime < endTime) {
          params.update_start_time = startTime
          params.update_end_time = endTime
        }
      }
      return params
    },

    isDoudianSyncRangeOverHalfYear(start, end) {
      const startDate = new Date(start)
      const endDate = new Date(end)
      const minStart = new Date(endDate)
      minStart.setMonth(minStart.getMonth() - 6)
      return startDate < minStart
    },

    loadDoudianShopList() {
      // 复用云商品铺货的店铺列表接口，保证同步入口和铺货入口看到的授权店铺一致。
      this.getDistributeShopSel({
        data: { status: 1 },
        success: (res) => {
          if (res.code === 200) {
            const list = res.data || []
            this.doudianShopList = Array.isArray(list)
              ? list.filter(item => Number(item.shop_type) === 1)
              : []
          } else {
            this.doudianShopList = []
            this.$message.error(res.message || res.msg || '获取抖店店铺失败')
          }
        }
      })
    },

    getDoudianSyncTaskList() {
      this.doudianSyncLoading = true
      this.getDoudianCloudSyncTasks({
        data: this.buildDoudianSyncTaskListParams(),
        success: (res) => {
          this.doudianSyncLoading = false
          if (res.code === 200) {
            this.doudianSyncTasks = res.data.list || []
            this.doudianSyncPage.total = res.data.total || 0
          } else {
            this.$message.error(res.message || res.msg)
          }
        }
      })
    },

    submitDoudianSyncTask() {
      if (!this.doudianSyncCreateForm.shop_id) {
        this.$message.warning('请选择抖店店铺')
        return
      }
      if (!this.doudianSyncCreateForm.dateRange || this.doudianSyncCreateForm.dateRange.length !== 2) {
        this.$message.warning('请选择更新时间范围')
        return
      }
      const [start, end] = this.doudianSyncCreateForm.dateRange
      const startTime = Math.floor(new Date(start).getTime() / 1000)
      const endTime = Math.floor(new Date(end).getTime() / 1000)
      if (!startTime || !endTime || startTime >= endTime) {
        this.$message.warning('更新时间范围不正确')
        return
      }
      if (this.isDoudianSyncRangeOverHalfYear(start, end)) {
        this.$message.warning('单次同步时间范围不能超过半年')
        return
      }
      if (this.doudianSyncCreateForm.group_id && !this.doudianSyncCreateForm.child_group_id) {
        this.$message.warning('请选择子分组')
        return
      }

      this.doudianSyncCreateLoading = true
      this.createDoudianCloudSyncTask({
        data: {
          shop_id: this.doudianSyncCreateForm.shop_id,
          update_start_time: startTime,
          update_end_time: endTime,
          child_group_id: this.doudianSyncCreateForm.child_group_id || null
        },
        success: (res) => {
          this.doudianSyncCreateLoading = false
          if (res.code === 200) {
            const createdCount = res.data && res.data.created_count !== undefined ? Number(res.data.created_count) : 1
            if (createdCount === 0) {
              this.$message.success('已存在相同同步任务，已为你返回任务列表')
            } else {
              this.$message.success(createdCount > 1 ? `已创建${createdCount}个同步子任务` : (res.message || res.msg || '同步任务已创建'))
            }
            this.doudianSyncCreateShow = false
            this.doudianSyncPage.page = 1
            this.getDoudianSyncTaskList()
          } else {
            this.$message.error(res.message || res.msg)
          }
        }
      })
    },

    doudianSyncStatusTag(status) {
      const map = {
        0: 'info',
        1: 'warning',
        2: 'warning',
        3: 'success',
        4: 'danger',
        5: 'info',
      }
      return map[status] || 'info'
    },

    async handleZipChange(e) {
      const [file] = e.target.files || [];
      if (!file) return;
      const isZip = /\.zip$/i.test(file.name);
      if (!isZip) {
        this.$message.error("请上传zip压缩包文件");
        this.resetZipInput();
        return;
      }
      this.imLoading = true;
      this.zipFileName = file.name || "";
      this.importInfo.products=[]
      this.importInfo.page=0
      this.importInfo.startIndex=0
      this.batchNum=0
      this.upErr=false
      try {
        const buffer = await this.readFileAsArrayBuffer(file);
        const zip = await JSZip.loadAsync(buffer);
        const readTxtTasks = [];
        const invalidZipFiles = [];
        const addInvalidZipFile = (relativePath) => {
          if (relativePath && !invalidZipFiles.includes(relativePath)) {
            invalidZipFiles.push(relativePath);
          }
        };
        zip.forEach((relativePath, fileEntry) => {
          // if (!fileEntry.dir && relativePath.toLowerCase().endsWith(".txt")) {
          if (!fileEntry.dir && ((relativePath.toLowerCase().endsWith(".txt")&&this.importInfo.source_method!=11)||(relativePath.toLowerCase().endsWith(".json")&&(this.importInfo.source_method===11 || this.importInfo.source_method===13)))) {
            readTxtTasks.push(
              // 1. 读取为二进制（必须用 uint8array 才能转码）
                fileEntry.async("uint8array").then(async (uint8Array) => {
                    try {
                        let content;
                        const isUTF8 = common.isUTF8(uint8Array);
                        if (isUTF8) {
                            content = new TextDecoder("utf-8").decode(uint8Array);
                        } else {
                            content = new TextDecoder("gbk").decode(uint8Array);
                        }
                        if (this.isValidJSON(content)) {
                            // 针对数据判断，如果导入包主图json key没有数据就返回null 并提示格式不对 不传入后台
                            let isValid = false;
                            const jsondata = JSON.parse(content)
                            switch (this.importInfo.source_method) {
                                case 1:
                                    // 存在 $product['FromItem']['ItemPicUrl'] 且不为空
                                    isValid = !!(jsondata.FromItem?.ItemPicUrl);
                                    break;
                                case 2:
                                    // 存在 $product['productPicUrl'] 且不为空
                                    isValid = !!(jsondata.productPicUrl || jsondata.itemImgs);
                                    break;
                                case 3:
                                    // 存在 $product['item_imgs'] 且不为空
                                    isValid = !!(jsondata.item_imgs);
                                    break;
                                case 4:
                                    // 存在 $product['goods']['hd_url'] 且不为空
                                    isValid = !!(jsondata.goods?.hd_url);
                                    break;
                                case 5:
                                    // 存在 $product['goods']['hd_url'] 且不为空
                                    isValid = !!(jsondata.goods?.hd_url);
                                    break;
                                case 6:
                                    // 存在 $product['result']['source'] 且不为空
                                    isValid = !!(jsondata.result?.source);
                                    break;
                                case 7:
                                    // 存在 $product['result']['source'] 且不为空
                                    isValid = !!(jsondata['主图']);
                                    break;
                                case 8:
                                    // 存在 $product['result']['source'] 且不为空
                                    isValid = !!(jsondata.item_id);
                                    break;
                                case 9:
                                    isValid = !!(jsondata.store?.initDataObj?.goods?.hdThumbUrl);
                                    break;
                                case 10:
                                    isValid = !!(jsondata.store?.initDataObj?.goods?.topGallery?.[0]?.url);
                                    break;
                                case 11:
                                    isValid = !!(jsondata?.main_images?.length);
                                    break;
                                case 12:
                                    isValid = !!(jsondata?.headImg?.length);
                                    break;
                                case 13:
                                    isValid = !!(
                                        jsondata.goods?.goods_id &&
                                        jsondata.goods?.goods_name &&
                                        (jsondata.goods?.hd_url || jsondata.goods?.image_url || jsondata.goods?.thumb_url) &&
                                        Array.isArray(jsondata.sku) &&
                                        jsondata.sku.length
                                    );
                                    break;
                                default:
                                    break;
                            }
                            if (!isValid) {
                                addInvalidZipFile(relativePath)
                                return null
                             }
                            if (this.importInfo.source_method === 4 || this.importInfo.source_method === 5) {
                                let data = {
                                    goods: {
                                        goods_id: jsondata.goods?.goods_id,
                                        goods_name: jsondata.goods?.goods_name,
                                        market_price: jsondata.goods?.market_price,
                                        hd_url: jsondata.goods?.hd_url,
                                        gallery: jsondata.goods?.gallery,
                                        decoration: jsondata.goods?.decoration,
                                        goods_property: jsondata.goods?.goods_property,
                                        preview_share_link: jsondata.goods?.preview_share_link,
                                    },
                                    sku: jsondata.sku?.map(item => ({
                                        sku_id: item.sku_id,
                                        sku_price: item.sku_price,
                                        group_price: item.group_price,
                                        normal_price: item.normal_price,
                                        thumb_url: item.thumb_url ,
                                        price_display: item.price_display,
                                        quantity: item.quantity,
                                        specs: item.specs
                                    })),

                                }
                                if (this.importInfo.source_method === 4) {
                                    data.ui =  {
                                        carousel_section: jsondata.ui?.carousel_section
                                    }
                                }
                                if (this.importInfo.source_method === 5) {
                                    data.price = jsondata.price
                                }
                                return data
                            }
                            else if (this.importInfo.source_method === 6) {
                                const dataInfo = jsondata.result?.data;
                                if (
                                    !dataInfo?.item ||
                                    !dataInfo?.skuCore ||
                                    !dataInfo?.skuBase ||
                                    !dataInfo?.componentsVO?.priceVO?.price?.priceMoney ||
                                    !dataInfo?.plusViewVO?.industryParamVO?.basicParamList

                                ) {
                                    addInvalidZipFile(relativePath)
                                    return null; // 直接退出，不返回数据
                                }
                                let data = {}
                                // 所有字段都正常，才往下走
                                data.item = dataInfo.item;
                                data.skuCore = dataInfo.skuCore;
                                data.skuBase = dataInfo.skuBase;
                                data.videos = dataInfo?.item?.videos?.[0]?.url ?? null;
                                data.priceMoney = dataInfo.componentsVO.priceVO.price.priceMoney;
                                data.basicParamList = dataInfo.plusViewVO.industryParamVO.basicParamList;
                                return data;
                            }
                            else if (this.importInfo.source_method === 7) {//星云
                                return jsondata
                            }
                            else if (this.importInfo.source_method === 9) {//dd大王
                                const dataInfo = jsondata.store?.initDataObj?.goods;
                                if (
                                    !dataInfo?.goodsID ||
                                    !dataInfo?.hdThumbUrl ||
                                    !dataInfo?.goodsName ||
                                    !dataInfo?.ui?.new_price_section ||
                                    !dataInfo?.skus ||
                                    !dataInfo?.goodsProperty ||
                                    !dataInfo?.detailGallery ||
                                    !dataInfo?.viewImageData
                                ) {
                                    addInvalidZipFile(relativePath)
                                    return null; // 直接退出，不返回数据
                                }
                                let data = {}
                                // 所有字段都正常，才往下走
                                data.shareLink = dataInfo?.shareLink??'';
                                data.img = dataInfo.hdThumbUrl;
                                data.goodsID = dataInfo.goodsID;
                                data.goodsName = dataInfo.goodsName;
                                data.new_price_section = dataInfo.ui.new_price_section;
                                data.skus = dataInfo.skus;
                                data.goodsProperty = dataInfo.goodsProperty;
                                data.viewImageData = dataInfo.viewImageData;
                                data.detailGallery = dataInfo.detailGallery;
                                return data;
                            }
                            else if (this.importInfo.source_method === 10){ //兵哥哥
                              const dataInfo = jsondata.store?.initDataObj?.goods;
                              if (!dataInfo||!dataInfo.goodsID) {
                                addInvalidZipFile(relativePath)
                                return null; // 直接退出，不返回数据
                              }
                              return {
                                goodsID: String(dataInfo.goodsID),
                                goodsName: dataInfo.goodsName,
                                minGroupPrice: dataInfo.minGroupPrice,
                                viewImageData: dataInfo.viewImageData?.length ? dataInfo.viewImageData : dataInfo.topGallery,
                                detailGallery: dataInfo.detailGallery,
                                skus: dataInfo.skus,
                                goodsProperty: dataInfo.goodsProperty ?? [],
                                shareLink: dataInfo.shareLink ?? ''
                              };
                            }
                            else if (this.importInfo.source_method === 11){ //万象json
                              const dataInfo = jsondata;
                              if (!dataInfo||!dataInfo.goods_id) {
                                addInvalidZipFile(relativePath)
                                return null; // 直接退出，不返回数据
                              }
                              return {
                                goods_id: String(dataInfo.goods_id),
                                goods_title: dataInfo.goods_title,
                                main_images: dataInfo.main_images,
                                desc_images: dataInfo.desc_images,
                                specs: dataInfo.specs,
                                skus: dataInfo.skus,
                                min_price: dataInfo.min_price,
                                show_price: dataInfo.show_price,
                                product_format: dataInfo.product_format ?? [],
                                share_url: dataInfo.share_url ?? dataInfo.goods_url ?? ''
                              };
                            }
                            else if (this.importInfo.source_method === 12) {
                                const sourceId = String(jsondata.expressInfo?.productId || '');
                                const banners = Array.isArray(jsondata.headImg) ? jsondata.headImg.filter(Boolean) : [];
                                const details = Array.isArray(jsondata.detail?.detailImg) ? jsondata.detail.detailImg.filter(Boolean) : [];
                                const rawSkus = Array.isArray(jsondata.skuList?.skuInfo) ? jsondata.skuList.skuInfo : [];
                                if (!jsondata.title || banners.length < 1 || details.length < 1 || !rawSkus.length) {
                                    addInvalidZipFile(relativePath); return null;
                                }
                                const specBySku = {};
                                (Array.isArray(jsondata.productSaleAttrs) ? jsondata.productSaleAttrs : []).forEach(group => {
                                  (group.items || []).forEach(item => (item.skuIds || []).forEach(skuId => {
                                    const key = String(skuId);
                                    (specBySku[key] || (specBySku[key] = [])).push({ name: group.key || '规格', value: item.value || '默认', image: item.imgUrl || '' });
                                  }));
                                });
                                return {
                                    source_product_id: sourceId,
                                    title: jsondata.title,
                                    main_images: banners,
                                    desc_images: details,
                                    video_url: jsondata.headVideoInfo?.[0]?.videoUrl || '',
                                    price: Number(jsondata.skuList?.minPrice || 0),
                                    attributes: (jsondata.param || []).map(i => i.paramV2).filter(i => i?.attrName && i?.attrValueName).map(i => ({ name: i.attrName, value: i.attrValueName })),
                                    skus: rawSkus.map(s => ({ sku_id: String(s.skuId || ''), price: Number(s.price || 0), stock: Number(s.stock ?? s.stockNum ?? s.quantity ?? s.inventory ?? 999),
                                    specs: specBySku[String(s.skuId)] || [{ name: '规格', value: '默认', image: '' }] })) };
                                }
                            else if (this.importInfo.source_method === 13) {
                                const goods = jsondata.goods;
                                const skus = Array.isArray(jsondata.sku) ? jsondata.sku : [];
                                const gallery = (Array.isArray(goods?.gallery) ? goods.gallery : []).map((item, index) => ({ item, index })).sort((a, b) => {
                                    const aId = Number(a.item?.id), bId = Number(b.item?.id), aValid = String(a.item?.id ?? '').trim() !== '' && Number.isFinite(aId), bValid = String(b.item?.id ?? '').trim() !== '' && Number.isFinite(bId);
                                    return aValid && bValid ? aId - bId || a.index - b.index : aValid ? -1 : bValid ? 1 : a.index - b.index;
                                }).map(entry => entry.item);
                                const carousel = gallery.filter(item => String(item?.type) === '1' && typeof item?.url === 'string' && item.url.trim()).map(item => item.url).filter((url, index, list) => list.indexOf(url) === index).slice(0, 5);
                                if (carousel.length < 3) gallery.forEach(item => {
                                    if (String(item?.type) !== '13' || typeof item?.url !== 'string' || !item.url.trim() || carousel.includes(item.url) || carousel.length === 5) return;
                                    carousel.push(item.url);
                                });
                                if (carousel.length < 3) gallery.forEach(item => {
                                    const width = Number(item?.width), height = Number(item?.height);
                                    if (String(item?.type) !== '2' || !Number.isFinite(width) || !Number.isFinite(height) || width !== height || typeof item?.url !== 'string' || !item.url.trim() || carousel.includes(item.url) || carousel.length === 5) return;
                                    carousel.push(item.url);
                                });
                                const galleryDetails = gallery.filter(item => String(item?.type) === '2' && typeof item?.url === 'string' && item.url.trim());
                                const decorationDetails = (Array.isArray(goods?.decoration) ? goods.decoration : []).flatMap(section => (Array.isArray(section?.contents) ? section.contents : []).map(item => item?.img_url).filter(Boolean));
                                const details = decorationDetails.length ? decorationDetails : galleryDetails;
                                if (!goods?.goods_id || !goods?.goods_name || !(goods?.hd_url || goods?.image_url || goods?.thumb_url) || carousel.length < 3 || details.length < 1 || !skus.length || !skus.some(s => Number(s?.group_price || s?.normal_price || s?.price || 0) > 0)) {
                                    addInvalidZipFile(relativePath); return null;
                                }
                                return {
                                    goods: {
                                        goods_id: goods.goods_id,
                                        goods_name: goods.goods_name,
                                        image_url: goods.image_url,
                                        hd_url: goods.hd_url,
                                        thumb_url: goods.thumb_url,
                                        gallery: goods.gallery,
                                        decoration: goods.decoration,
                                        goods_property: goods.goods_property||[

                                        ],
                                        preview_share_link: goods.preview_share_link,
                                        share_link: goods.share_link
                                    },
                                    sku: skus.map(s=>({
                                        sku_id: s.sku_id,
                                        goods_id: s.goods_id,
                                        thumb_url: s.thumb_url,
                                        quantity: s.quantity,
                                        default_quantity: s.default_quantity,
                                        group_price: s.group_price,
                                        normal_price: s.normal_price,
                                        price: s.price,
                                        sku_price : s.sku_price,
                                        specs: s.specs
                                    })),
                                    price: jsondata.price,
                                    category: jsondata.category,
                                    source_url: jsondata.source_url
                                };
                            }
                            else {
                                return jsondata
                            }

                        } else {
                            addInvalidZipFile(relativePath)
                            return null;
                        }
                    } catch (parseErr) {
                        console.error("解析txt失败", relativePath, parseErr)
                        addInvalidZipFile(relativePath)
                        return null;
                    }

                })
            );
          }
        });
        const txts = await Promise.all(readTxtTasks);
        // console.log("txts", txts)
        this.importInfo.products = txts.filter(item => item !== null && item !== undefined);
        if (this.importInfo.source_method === 13) {
            const seen = new Set();
            this.importInfo.products = this.importInfo.products.filter(item => {
                const id = String(item.goods?.goods_id || '');
                if (!id || seen.has(id)) return false;
                seen.add(id);
                return true;
            });
        }
        if (invalidZipFiles.length > 0) {
            const showInvalidZipFiles = invalidZipFiles.slice(0, 10)
            const invalidZipFileMessage = [
                `有${invalidZipFiles.length}个文件数据存在格式不对，请检查商品解析方式：`,
                ...showInvalidZipFiles.map(item => `【${this.escapeHtml(item)}】`)
            ]
            if (invalidZipFiles.length > 10) {
                invalidZipFileMessage.push("……")
            }
            this.$message.error({
                dangerouslyUseHTMLString: true,
                message: invalidZipFileMessage.join("<br/>"),
                duration: 8000
            })
        }
        if(this.importInfo.products.length == 0){
            this.$message.error({
                message: "导入数据无效，请检查商品解析方式",
                duration: 5000
            })
        }
        this.batchNum = Math.ceil(this.importInfo.products.length / this.importSize)
        this.$refs.importForm.validateField('products')
      } catch (err) {
        console.error("读取zip失败", err);
        this.$message.error("解压或读取文件失败，请重试");
      } finally {
        this.imLoading = false;
        this.resetZipInput();
      }
    },

    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (evt) => resolve(evt.target.result);
        reader.onerror = (err) => reject(err);
        reader.readAsArrayBuffer(file);
      });
    },

    resetZipInput() {
      if (this.$refs.zipInput) {
        this.$refs.zipInput.value = "";
      }
    },
    escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (char) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[char]));
    },
    changeSourceWeb(){
        this.importInfo.products = ''
        this.importInfo.source_method = ''
    },
    changeSourceMethod() {
        this.importInfo.products = ''
    },

    handleImport() {
      if (this.importInfo.group_id && !this.importInfo.child_group_id) {
        this.$message.warning('请选择子分组')
        return
      }
      this.upLoading = true
      this.$refs.importForm.validate(valid => {
        if (valid) {
            if (this.importInfo.source_web===2) {
              this.importGoods1688()
            }else{
              this.importInfo.startIndex = 0
              this.importInfo.page = 0
              this.upErr = false
              this.importCreate()
            }
        } else {
            this.$message.error({
                message: "请检查导入数据是否正常",
                duration: 5000
            })
        }
        this.upLoading = false
      })

    },

    importGoods1688(){
      const links = this.importInfo.produceLinks.split(/\r\n|\r|\n|,|，/g).map(item => item.trim()).filter(item => (item !== '' && item !== '-'))
      let goosIds= links.map(item => {
        let url =item.substring(0, item.indexOf('?') > -1 ? item.indexOf('?') : item.length)
        if(url.indexOf('html') > -1){
          let arr  =url.split('/')
          let ids = arr[arr.length-1].split('.')
          return ids[0]
        }
        return ''
      })
      goosIds = goosIds.filter(item => item !== '')
      this.$confirm(`是否确认导入${goosIds.length}个商品？`,'提示').then(()=>{

        let params = {
          productIds: goosIds.join(','),
          child_group_id: this.importInfo.child_group_id || null,
        }
        this.opImportCreate1688({
          data: params,
            success: (res) => {
                if (res.code == 200) {
                    this.$message.success(`导入任务创建成功`)
                } else {
                    this.$message.error(res.message)
                }
                this.importShow = false
                this.upLoading = false
                this.getDataList()
          }
        })
      })
    },
    async importCreate() {
        try {
            const totalList = this.importInfo.products;
            // 无数据 或 已经全部传完
            if (!totalList || totalList.length === 0 || this.importInfo.startIndex >= totalList.length) {
                this.upLoading = false;
                this.$message.success('全部导入完成');
                this.importShow = false;
                this.getDataList();
                return;
            }
            if (this.importInfo.page == 1 || this.upErr) {
                this.upLoading = true
            }
            const startIndex = this.importInfo.startIndex;
            let endIndex = startIndex;
            const MAX_SIZE = 1024 * 1024 * 1.3; // 1M

            // 自动截取到 1M 或者100条数据
            for (let i = startIndex; i < totalList.length; i++) {
                const testBatch = totalList.slice(startIndex, i + 1);
                const size = new Blob([JSON.stringify(testBatch)]).size;
                if (size > MAX_SIZE || (i-101) === startIndex) break;
                    endIndex = i + 1;
            }

            // 本次要上传的数据
            const batchProducts = totalList.slice(startIndex, endIndex);
            // const currentPage = this.importInfo.page + 1;
            let nextPage = this.importInfo.page + 1
            // const products = this.importInfo.products.slice(this.importSize * currentPage, this.importSize * nextPage)
            const params = {
                products: batchProducts,
                source_web: this.importInfo.source_web,
                source_method: this.importInfo.source_method,
                file_name: this.zipFileName.split('.')[0] + '_' + nextPage
            }
            if (this.importInfo.child_group_id) {
                params.child_group_id = this.importInfo.child_group_id
            }
            this.opImportCreate({
            data: params,
            success: (res) => {
                if (res.code == 200) {
                    this.upErr = false
                    //直接记录下一次开始位置
                    this.importInfo.startIndex = endIndex;
                    this.importInfo.page += 1;
                    this.upErr = false;
                    // 继续上传下一批
                    this.importCreate();
                //   if (this.importSize * nextPage < this.importInfo.products.length) {
                //     this.importInfo.page++
                //     this.importCreate()
                //   } else {
                //     this.$message.success(`已成功导入${nextPage}个批次`)
                //     this.importShow = false
                //     this.upLoading = false
                //     this.getDataList()
                //   }
                } else {
                this.upLoading = false
                this.upErr = this.importInfo.page > 0 ? true : false
                this.$message.error(res.message)
                }
            }
            })
        } catch (e) {
            this.$message.error(e);
            this.upLoading = false
        }
    },

    setMd5(list) {
      return new Promise((resolve) => {
        list.forEach(async (item) => {
          const ItemPicUrl = item?.FromItem?.ItemPicUrl
          if (ItemPicUrl) {
            const response = await fetch(ItemPicUrl);
            const arrayBuffer = await response.arrayBuffer();
            item.FromItem.ItemPicMd5 = md5(arrayBuffer)
          }
        })
        resolve(list)
      });
    },

    isValidJSON(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },

    async getImageAsBase64(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP错误: ${response.status}`);
        }
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error('获取图片失败:', error);
        throw error;
      }
    },

    // 删除批次铺货相关方法

    // === 云商品列表模块方法 ===
    getCloudDataList() {
      this.cloudLoading = true
      const params = this.buildCloudListParams(this.cloudPageData.page, this.cloudPageData.limit, this.cloudSearchParams)
      this.getCloudProductList({
        data: params,
        success: (res) => {
          this.cloudLoading = false
          if (res.code == 200) {
            this.cloudTableData = res.data.list || []
            this.cloudPageData.total = res.data.total || 0

            // 优先使用后端返回的统计数据（仅在第一页且无状态筛选时）
            if (res.data.stats && this.cloudSearchParams.status === '' && this.cloudPageData.page === 1) {
                this.cloudStats = res.data.stats
              console.log('this.cloudStats:',this.cloudStats)
                // 确保分页总数与统计总数一致（防止后端返回的 total 字段不准确）
                if (res.data.stats.total !== undefined) {
                    this.cloudPageData.total = res.data.stats.total
                }
            }
            // 如果后端没返回 stats，且当前没有搜索关键词/批次号，则根据列表总数更新当前 Tab 的统计
            else if (this.cloudPageData.page === 1 && !this.hasCloudSearchFilter()) {
                const currentTotal = res.data.total || 0
                const status = this.cloudSearchParams.status

                // 仅当状态不为空（即不是全部商品 Tab）时更新分项
                if (status !== '') {
                    if (status === 0) this.cloudStats.pending_count = currentTotal
                    else if (status === 1) this.cloudStats.success_count = currentTotal
                    else if (status === 2) this.cloudStats.fail_count = currentTotal
                    else if (status === 3) this.cloudStats.duplicate_count = currentTotal
                    else if (status === 4) this.cloudStats.offline_count = currentTotal

                    // 尝试同步更新总数 (累加所有分项)
                    this.cloudStats.total =
                        (this.cloudStats.pending_count || 0) +
                        (this.cloudStats.success_count || 0) +
                        (this.cloudStats.fail_count || 0) +
                        (this.cloudStats.duplicate_count || 0)+
                        (this.cloudStats.offline_count || 0)
                } else {
                    // 如果是在“全部商品” Tab，直接更新 total
                    this.cloudStats.total = currentTotal
                }
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    buildCloudListParams(page, pageSize, searchParams = {}) {
      const params = {
        page,
        page_size: pageSize,
        ...searchParams,
      }
      if (params.status === '') delete params.status
      if (params.keyword === '') delete params.keyword
      if (params.batch_no === '') delete params.batch_no
      if (params.source_product_id === '') delete params.source_product_id
      if (params.platform_product_id === '') delete params.platform_product_id
      if (params.sku_status === '') delete params.sku_status
      if (params.sku_mark_status === '') delete params.sku_mark_status
      if (params.distribution_free_postage === '') delete params.distribution_free_postage
      if (params.freight_province_code === '') delete params.freight_province_code
      if (params.min_price === '') delete params.min_price
      if (params.max_price === '') delete params.max_price
      if (params.appraisal_status === '') delete params.appraisal_status
      if (params.distribute_status === '') delete params.distribute_status
      if (params.exclude_distributed && params.exclude_distributed.length > 0) {
        params.exclude_distributed = Array.isArray(params.exclude_distributed)
          ? params.exclude_distributed.join(',')
          : params.exclude_distributed
      } else {
        delete params.exclude_distributed
      }
      if (params.group_id === '') delete params.group_id
      if (params.is_sku_miss === '') delete params.is_sku_miss
      if (params.has_distribute_success === '') delete params.has_distribute_success
      if (params.has_distribute_fail === '') delete params.has_distribute_fail
      if (params.has_distribute_ban === '') delete params.has_distribute_ban
      if (params.has_distribute_review_fail === '') delete params.has_distribute_review_fail
      return params
    },

    provinceName(code) {
      return areaData.province_list[code] || ''
    },

    handleViewFreight(row) {
      this.freightDetailVisible = true
      this.freightDetailLoading = true
      this.freightDetails = []
      this.getCloudProductFreightDetails({
        id: row.id,
        data: { shared: 0 },
        success: (res) => {
          this.freightDetailLoading = false
          if (res.code === 200) {
            this.freightDetails = res.data.freights || []
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    hasCloudSearchFilter() {
      return !!(
        this.cloudSearchParams.keyword ||
        this.cloudSearchParams.batch_no ||
        this.cloudSearchParams.source_product_id ||
        this.cloudSearchParams.platform_product_id
      )
    },

    handleCloudSearch() {
      this.cloudPageData.page = 1
      this.getCloudDataList()
    },
    handleGroupFilterChange() {
      this.$set(this.cloudSearchParams, 'child_group_id', '');
      this.handleFilterChange()
    },
    // 筛选变化时重置状态为全部商品
    handleFilterChange() {
      const minPrice = String(this.cloudSearchParams.min_price || '').trim()
      const maxPrice = String(this.cloudSearchParams.max_price || '').trim()
      if (minPrice !== '' && (!Number.isFinite(Number(minPrice)) || Number(minPrice) < 0)) {
        this.$message.warning('最低价格必须是大于等于0的数字')
        return
      }
      if (maxPrice !== '' && (!Number.isFinite(Number(maxPrice)) || Number(maxPrice) < 0)) {
        this.$message.warning('最高价格必须是大于等于0的数字')
        return
      }
      if (minPrice !== '' && maxPrice !== '' && Number(minPrice) > Number(maxPrice)) {
        this.$message.warning('最低价格不能大于最高价格')
        return
      }
      this.changeGroupId(this.cloudSearchParams.group_id)
      this.cloudSearchParams.status = ''
      this.handleCloudSearch()
    },

    // 排除已铺货筛选变化
    handleExcludeFilterChange(val) {
      // 如果选择了"排除全部"，清除其他店铺选项
      if (val.includes('all') && val.length > 1) {
        this.cloudSearchParams.exclude_distributed = ['all']
      }
      // 如果清空了排除已铺货，也清空铺货状态筛选
      if (!val || val.length === 0) {
        this.cloudSearchParams.distribute_status = ''
      }
      this.cloudSearchParams.status = ''
      this.handleCloudSearch()
    },

    handleCloudStatusTabClick(status) {
        if (this.cloudSearchParams.status === status) return;
        this.cloudSearchParams.status = status;
        this.handleCloudSearch();
    },

    handleCloudRefresh() {
      this.cloudPageData.page = 1
      this.getCloudDataList()
    },

    // 重置所有搜索条件
    handleCloudReset() {
      this.cloudSearchParams = { status: '', keyword: '', batch_no: '', source_product_id: '', platform_product_id: '', source_web: '', distribution_free_postage: '', freight_province_code: '', min_price: '', max_price: '', sku_status: '', ai_title_status: '', exclude_distributed: [], distribute_status: '', group_id: '', child_group_id: '', is_sku_miss: '', sku_mark_status: '', has_distribute_success: '', has_distribute_fail: '', has_distribute_ban: '', has_distribute_review_fail: '' }
      this.cloudPageData.page = 1
      this.getCloudDataList()
    },
    handleViewProductMarks(row) {
      this.productMarkViewShow = true
      this.productMarkViewLoading = true
      this.productMarkViewItems = []
      this.getProductMarkable({
        data: { id: row.id },
        success: (res) => {
          this.productMarkViewLoading = false
          if (res.code === 200) {
            this.productMarkViewItems = Array.isArray(res.data) ? res.data : []
          } else {
            this.$message.error(res.message || '获取标记货源失败')
          }
        }
      })
    },
    getProductMarkLink(item) {
      return item.offer_id ? `https://detail.1688.com/offer/${item.offer_id}.html` : ''
    },
    handleViewProductMarkLink(item) {
      const url = this.getProductMarkLink(item)
      if (url) window.open(url, '_blank', 'noopener,noreferrer')
    },
    handleCloudEdit(row) {
      if (row.status !== 1) {
        this.$message.warning('只能编辑导入成功的商品')
        return
      }
      this.cloudEditShow = true
      this.cloudEditMode = 'single'
      this.cloudEditCurrent = row
      this.cloudEditSourceList = [row]
      this.cloudEditGroupId = ''
      this.cloudEditChildGroupId = '',
      this.cloudEditChildGroupList = [],
      this.cloudEditAppliedGroupId = ''
      this.cloudEditSkuStatus = ''
      this.cloudEditAppliedSkuStatus = ''
      this.cloudEditAppraisalStatus = ''
      this.cloudEditAppliedAppraisalStatus = ''
      this.cloudEditUseRemoteList = false
      this.cloudEditPageData = { page: 1, limit: 10, total: 0 }
      this.cloudEditAppliedPageData = { page: 1, limit: 10 }
      this.cloudEditRemoteSearchParams = {}
      this.cloudEditRemoteParams = {}
      this.cloudEditList = [row]
      this.cloudEditDirty = false
      this.loadCloudEditDetail(row)
    },

    handleCloudBatchEdit() {
      if (this.cloudSelectedList.length === 0) {
        // this.loadGroupList()
        this.cloudEditShow = true
        this.cloudEditMode = 'batch'
        this.cloudEditUseRemoteList = true
        this.cloudEditSourceList = []
        this.cloudEditList = []
        this.cloudEditCurrent = null
        this.cloudEditDirty = false
        this.cloudEditGroupId = this.cloudSearchParams.group_id || ''
        this.cloudEditAppliedGroupId = this.cloudEditGroupId
        this.cloudEditChildGroupId = this.cloudSearchParams.child_group_id || ''
        this.cloudEditChildGroupList = this.child_groupList || [],
        this.cloudEditSkuStatus = this.cloudSearchParams.sku_status || ''
        this.cloudEditAppliedSkuStatus = this.cloudEditSkuStatus
        this.cloudEditAppraisalStatus = this.cloudSearchParams.appraisal_status || ''
        this.cloudEditAppliedAppraisalStatus = this.cloudEditAppraisalStatus
        this.cloudEditPageData = { page: this.cloudPageData.page || 1, limit: this.cloudPageData.limit || 10, total: 0 }
        this.cloudEditAppliedPageData = { page: this.cloudEditPageData.page, limit: this.cloudEditPageData.limit }
        this.cloudEditRemoteSearchParams = {
          ...this.cloudSearchParams,
          status: 1,
          group_id: this.cloudEditGroupId,
          child_group_id: this.cloudEditChildGroupId,
          sku_status: this.cloudEditSkuStatus,
          appraisal_status: this.cloudEditAppraisalStatus,
        }
        this.cloudEditRemoteParams = this.buildCloudListParams(this.cloudEditPageData.page, this.cloudEditPageData.limit, this.cloudEditRemoteSearchParams)
        this.loadCloudEditRemoteList(true)
        return
      }
      const sourceList = this.cloudSelectedList
      const successProducts = sourceList.filter(item => item.status === 1)
      if (successProducts.length === 0) {
        this.$message.warning('当前没有可编辑的成功商品')
        return
      }
      if (successProducts.length < sourceList.length) {
        this.$message.warning(`已过滤非成功状态商品，将编辑 ${successProducts.length} 个商品`)
      }
      // this.loadGroupList()
      this.cloudEditShow = true
      this.cloudEditMode = 'batch'
      this.cloudEditUseRemoteList = false
      this.cloudEditSourceList = successProducts
      this.cloudEditGroupId = ''
      this.cloudEditAppliedGroupId = ''
      this.cloudEditSkuStatus = ''
      this.cloudEditAppliedSkuStatus = ''
      this.cloudEditAppraisalStatus = ''
      this.cloudEditAppliedAppraisalStatus = ''
      this.cloudEditPageData = { page: 1, limit: 10, total: successProducts.length }
      this.cloudEditAppliedPageData = { page: 1, limit: 10 }
      this.cloudEditRemoteSearchParams = {}
      this.cloudEditRemoteParams = {}
      this.cloudEditList = successProducts
      this.cloudEditCurrent = successProducts[0]
      this.cloudEditDirty = false
      this.loadCloudEditDetail(successProducts[0])
    },

    getCloudEditFilteredList(
      groupId = this.cloudEditGroupId,
      skuStatus = this.cloudEditSkuStatus,
      appraisalStatus = this.cloudEditAppraisalStatus
    ) {
      const hasGroupFilter = !(groupId === '' || groupId === null || typeof groupId === 'undefined')
      const targetGroupId = Number(groupId)
      return this.cloudEditSourceList.filter(item => {
        const itemGroupId = Number(item.group_id || 0)
        if (hasGroupFilter) {
          if (targetGroupId === -1) {
            if (itemGroupId) return false
          } else if (itemGroupId !== targetGroupId) {
            return false
          }
        }
        if (skuStatus !== '' && skuStatus !== null && typeof skuStatus !== 'undefined') {
          if (Number(item.sku_status) !== Number(skuStatus)) return false
        }
        if (appraisalStatus !== '' && appraisalStatus !== null && typeof appraisalStatus !== 'undefined') {
          if (Number(item.appraisal_status) !== Number(appraisalStatus)) return false
        }
        return true
      })
    },

    loadCloudEditRemoteList(autoSelectFirst = false) {
      if (!this.cloudEditUseRemoteList) return
      this.cloudEditListLoading = true
      const params = this.buildCloudListParams(
        this.cloudEditPageData.page,
        this.cloudEditPageData.limit,
        this.cloudEditRemoteSearchParams
      )
      this.cloudEditRemoteParams = params
      this.getCloudProductList({
        data: params,
        success: (res) => {
          this.cloudEditListLoading = false
          if (res.code === 200) {
            const list = res.data.list || []
            const total = res.data.total || 0
            if (list.length === 0 && total > 0 && this.cloudEditPageData.page > 1) {
              this.cloudEditPageData.page = 1
              this.cloudEditAppliedPageData.page = 1
              this.loadCloudEditRemoteList(autoSelectFirst)
              return
            }
            this.cloudEditList = list
            this.cloudEditSourceList = list
            this.cloudEditPageData.total = total
            this.cloudEditAppliedPageData = {
              page: this.cloudEditPageData.page,
              limit: this.cloudEditPageData.limit,
            }
            const currentInList = this.cloudEditCurrent && list.some(item => item.id === this.cloudEditCurrent.id)
            if (autoSelectFirst || !currentInList) {
              const nextProduct = list[0] || null
              this.cloudEditCurrent = nextProduct
              this.cloudEditDirty = false
              if (nextProduct) {
                this.loadCloudEditDetail(nextProduct)
              } else {
                this.cloudEditForm = { id: '', product_id: '', title: '', price: '', main_images: [], detail_images: [], skuSpecs: [], skus: [], skuValueImages: {} }
              }
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    restoreCloudEditAppliedPagination() {
      this.$nextTick(() => {
        this.cloudEditPageData.page = this.cloudEditAppliedPageData.page
        this.cloudEditPageData.limit = this.cloudEditAppliedPageData.limit
      })
    },

    handleCloudEditRemotePageChange() {
      const loadPage = () => {
        this.cloudEditDirty = false
        this.loadCloudEditRemoteList(true)
      }
      if (this.cloudEditDirty) {
        this.$confirm('当前商品有未保存修改，确认切换分页吗？', '提示', {
          confirmButtonText: '确认切换',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(loadPage).catch(this.restoreCloudEditAppliedPagination)
      } else {
        loadPage()
      }
    },

    handleCloudEditRemoteSizeChange(val) {
      this.cloudEditPageData.limit = val
      this.cloudEditPageData.page = 1
      this.handleCloudEditRemotePageChange()
    },

    handleCloudEditRemoteCurrentChange(val) {
      this.cloudEditPageData.page = val
      this.handleCloudEditRemotePageChange()
    },

    resetCloudEditRemotePagination() {
      this.cloudEditPageData.page = 1
      this.cloudEditAppliedPageData.page = 1
    },

    restoreCloudEditAppliedFilters() {
      this.$nextTick(() => {
        this.cloudEditGroupId = this.cloudEditAppliedGroupId
        this.cloudEditSkuStatus = this.cloudEditAppliedSkuStatus
        this.cloudEditAppraisalStatus = this.cloudEditAppliedAppraisalStatus
      })
    },
    handleCloudEditFilterGroupChange() {
        this.cloudEditChildGroupId = ''
        this.handleCloudEditFilterChange()
    },
    handleCloudEditFilterChange() {
        this.cloudEditChildGroupList = this.groupList.find(i => i.id === this.cloudEditGroupId)?.child_groups || []
      if (this.cloudEditUseRemoteList) {
        const applyRemoteFilters = () => {
          this.cloudEditAppliedGroupId = this.cloudEditGroupId
          this.cloudEditAppliedSkuStatus = this.cloudEditSkuStatus
          this.cloudEditAppliedAppraisalStatus = this.cloudEditAppraisalStatus
          this.resetCloudEditRemotePagination()
          this.cloudEditRemoteSearchParams = {
            ...this.cloudEditRemoteSearchParams,
            group_id: this.cloudEditGroupId,
            child_group_id: this.cloudEditChildGroupId,
            sku_status: this.cloudEditSkuStatus,
            appraisal_status: this.cloudEditAppraisalStatus,
          }
          this.cloudEditDirty = false
          this.loadCloudEditRemoteList(true)
        }
        if (this.cloudEditDirty) {
          this.$confirm('当前商品有未保存修改，确认切换筛选结果吗？', '提示', {
            confirmButtonText: '确认切换',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(applyRemoteFilters).catch(this.restoreCloudEditAppliedFilters)
        } else {
          applyRemoteFilters()
        }
        return
      }
      const filteredList = this.getCloudEditFilteredList()
      const currentInFiltered = this.cloudEditCurrent && filteredList.some(item => item.id === this.cloudEditCurrent.id)
      const switchFilteredList = () => {
        this.cloudEditAppliedGroupId = this.cloudEditGroupId
        this.cloudEditAppliedSkuStatus = this.cloudEditSkuStatus
        this.cloudEditAppliedAppraisalStatus = this.cloudEditAppraisalStatus
        this.cloudEditList = filteredList
        if (currentInFiltered) return
        const nextProduct = filteredList[0] || null
        this.cloudEditCurrent = nextProduct
        this.cloudEditDirty = false
        if (nextProduct) {
          this.loadCloudEditDetail(nextProduct)
        } else {
          this.cloudEditForm = { id: '', product_id: '', title: '', price: '', main_images: [], detail_images: [], skuSpecs: [], skus: [], skuValueImages: {} }
        }
      }
      if (!currentInFiltered && this.cloudEditDirty) {
        this.$confirm('当前商品有未保存修改，确认切换筛选结果吗？', '提示', {
          confirmButtonText: '确认切换',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(switchFilteredList).catch(this.restoreCloudEditAppliedFilters)
      } else {
        switchFilteredList()
      }
    },

    handleCloudEditSelect(item) {
      if (this.cloudEditCurrent && this.cloudEditCurrent.id === item.id) return
      const switchProduct = () => {
        this.cloudEditCurrent = item
        this.loadCloudEditDetail(item)
      }
      if (this.cloudEditDirty) {
        this.$confirm('当前商品有未保存修改，确认切换商品吗？', '提示', {
          confirmButtonText: '确认切换',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(switchProduct).catch(() => {})
      } else {
        switchProduct()
      }
    },

    loadCloudEditDetail(row) {
      if (!row || !row.id) return
      this.cloudEditLoading = true
      this.getCloudProductEditDetail({
        id: row.id,
        success: (res) => {
          this.cloudEditLoading = false
          if (res.code === 200) {
            const data = res.data || {}
            const skus = Array.isArray(data.skus) ? data.skus.map(item => ({
              id: item.id,
              attributes: this.normalizeSkuAttributes(item.attributes),
              price: Number(item.price || 0),
              stock: Number(item.stock || 0),
              image_url: item.image_url || '',
              enabled: item.enabled !== false && Number(item.status || 1) === 1,
            })) : []
            this.cloudEditForm = {
              id: data.id,
              product_id: data.product_id,
              title: data.title || '',
              price: data.price || '',
              main_images: Array.isArray(data.main_images) ? data.main_images : [],
              detail_images: Array.isArray(data.detail_images) ? data.detail_images : [],
              skuSpecs: this.buildSkuSpecsFromSkus(skus),
              skus,
              skuValueImages: this.buildSkuValueImagesFromSkus(skus),
            }
            this.cloudEditDirty = false
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    markCloudEditDirty() {
      this.cloudEditDirty = true
    },

    openImageSourceDialog(target, skuIndex = -1) {
      const titleMap = {
        main: '添加商品图片',
        detail: '添加详情图片',
        skuValue: '选择规格图片',
      }
      const existingUrlsMap = {
        main: this.cloudEditForm.main_images,
        detail: this.cloudEditForm.detail_images,
      }
      this.imageSourceDialog = {
        visible: true,
        target,
        skuIndex,
        title: titleMap[target] || '添加图片',
        multiple: target !== 'skuValue',
        existingUrls: existingUrlsMap[target] || [],
      }
    },

    handleImageSourceSelect(urls) {
      if (!Array.isArray(urls) || urls.length === 0) return
      if (this.imageSourceDialog.target === 'skuValue') {
        this.setSkuValueImage(this.imageSourceDialog.skuIndex, urls[0])
        return
      }

      const key = this.imageSourceDialog.target === 'detail' ? 'detail_images' : 'main_images'
      const currentUrls = this.cloudEditForm[key] || []
      const currentSet = new Set(currentUrls)
      const pendingSet = new Set()
      const duplicateUrls = []
      const nextUrls = []
      urls.forEach(url => {
        if (currentSet.has(url) || pendingSet.has(url)) {
          duplicateUrls.push(url)
          return
        }
        pendingSet.add(url)
        nextUrls.push(url)
      })
      if (duplicateUrls.length) {
        this.$message.warning('不能上传重复的图片')
      }
      if (!nextUrls.length) return
      this.cloudEditForm[key].push(...nextUrls)
      this.markCloudEditDirty()
    },

    hasDuplicateImageUrls(urls) {
      const seen = new Set()
      return (urls || []).some(url => {
        if (seen.has(url)) return true
        seen.add(url)
        return false
      })
    },

    setSkuValueImage(value, url) {
      if (!value) return
      this.$set(this.cloudEditForm.skuValueImages, value, url || '')
      this.syncSkuImagesFromFirstSpec()
      this.markCloudEditDirty()
    },

    clearSkuValueImage(value) {
      if (!value) return
      this.$delete(this.cloudEditForm.skuValueImages, value)
      this.syncSkuImagesFromFirstSpec()
      this.markCloudEditDirty()
    },

    normalizeSkuAttributes(attributes) {
      if (typeof attributes === 'string') {
        try {
          attributes = JSON.parse(attributes)
        } catch (e) {
          attributes = []
        }
      }
      if (attributes && typeof attributes === 'object' && !Array.isArray(attributes)) {
        attributes = Array.isArray(attributes.specs) ? attributes.specs : []
      }
      if (!Array.isArray(attributes)) return []
      const specs = attributes.specs && Array.isArray(attributes.specs) ? attributes.specs : attributes
      return specs.map(item => {
        if (Array.isArray(item)) {
          return [String(item[0] || '').trim(), String(item[1] || '').trim()]
        }
        return [
          String(item.name || item.attributeName || '').trim(),
          String(item.value || item.attributeValue || '').trim(),
        ]
      }).filter(item => item[0] && item[1])
    },

    formatSkuAttributes(attributes) {
      const specs = this.normalizeSkuAttributes(attributes)
      return specs.length ? specs.map(item => `${item[0]}:${item[1]}`).join(', ') : '默认规格'
    },

    buildSkuSpecsFromSkus(skus) {
      const specMap = []
      skus.forEach(sku => {
        this.normalizeSkuAttributes(sku.attributes).forEach(attr => {
          let spec = specMap.find(item => item.name === attr[0])
          if (!spec) {
            spec = { name: attr[0], values: [], inputVisible: false, inputValue: '' }
            specMap.push(spec)
          }
          if (!spec.values.includes(attr[1])) {
            spec.values.push(attr[1])
          }
        })
      })
      if (specMap.length === 0) {
        return [{ name: '默认规格', values: ['标准'], inputVisible: false, inputValue: '' }]
      }
      return specMap
    },

    buildSkuValueImagesFromSkus(skus) {
      const valueImages = {}
      skus.forEach(sku => {
        const attrs = this.normalizeSkuAttributes(sku.attributes)
        const firstValue = attrs[0] && attrs[0][1]
        if (firstValue && sku.image_url && !valueImages[firstValue]) {
          valueImages[firstValue] = sku.image_url
        }
      })
      return valueImages
    },

    syncSkuImagesFromFirstSpec() {
      const valueImages = this.cloudEditForm.skuValueImages || {}
      this.cloudEditForm.skus.forEach(sku => {
        const attrs = this.normalizeSkuAttributes(sku.attributes)
        const firstValue = attrs[0] && attrs[0][1]
        this.$set(sku, 'image_url', firstValue ? (valueImages[firstValue] || '') : '')
      })
    },

    getSkuAttributesKey(attributes) {
      return JSON.stringify(this.normalizeSkuAttributes(attributes))
    },

    countEnabledSkusBySpecs(skuSpecs) {
      const specValueMap = {}
      ;(skuSpecs || []).forEach(spec => {
        const name = (spec.name || '').trim()
        const values = (spec.values || []).map(value => String(value).trim()).filter(Boolean)
        if (name && values.length) {
          specValueMap[name] = new Set(values)
        }
      })
      return this.cloudEditForm.skus.filter(sku => {
        const attrs = this.normalizeSkuAttributes(sku.attributes)
        return attrs.length && attrs.every(attr => specValueMap[attr[0]] && specValueMap[attr[0]].has(attr[1]))
      }).length
    },

    syncSkuEnabledFromSpecs() {
      const specValueMap = {}
      ;(this.cloudEditForm.skuSpecs || []).forEach(spec => {
        const name = (spec.name || '').trim()
        const values = (spec.values || []).map(value => String(value).trim()).filter(Boolean)
        if (name && values.length) {
          specValueMap[name] = new Set(values)
        }
      })
      this.cloudEditForm.skus.forEach(sku => {
        const attrs = this.normalizeSkuAttributes(sku.attributes)
        const enabled = attrs.length && attrs.every(attr => specValueMap[attr[0]] && specValueMap[attr[0]].has(attr[1]))
        this.$set(sku, 'enabled', enabled)
      })
    },

    addSkuSpec() {
      this.cloudEditForm.skuSpecs.push({
        name: '',
        values: [],
        inputVisible: false,
        inputValue: '',
      })
      this.handleSkuSpecChange()
    },

    removeSkuSpec(index) {
      if (index === 0) {
        this.cloudEditForm.skuValueImages = {}
      }
      this.cloudEditForm.skuSpecs.splice(index, 1)
      this.handleSkuSpecChange()
    },

    showSkuSpecValueInput(index) {
      this.$set(this.cloudEditForm.skuSpecs[index], 'inputVisible', true)
      this.$nextTick(() => {
        const input = this.$refs['skuSpecInput' + index]
        if (input && input[0]) input[0].focus()
      })
    },

    confirmSkuSpecValue(index) {
      const spec = this.cloudEditForm.skuSpecs[index]
      if (!spec) return
      const value = (spec.inputValue || '').trim()
      if (value && !spec.values.includes(value)) {
        spec.values.push(value)
        if (index === 0 && !this.cloudEditForm.skuValueImages[value]) {
          this.$set(this.cloudEditForm.skuValueImages, value, '')
        }
      }
      spec.inputVisible = false
      spec.inputValue = ''
      this.handleSkuSpecChange()
    },

    removeSkuSpecValue(specIndex, valueIndex) {
      const spec = this.cloudEditForm.skuSpecs[specIndex]
      if (!spec) return
      const value = spec.values[valueIndex]
      const nextSpecs = this.cloudEditForm.skuSpecs.map((item, index) => ({
        ...item,
        values: index === specIndex ? item.values.filter((_, idx) => idx !== valueIndex) : [...item.values],
      }))
      if (this.countEnabledSkusBySpecs(nextSpecs) === 0) {
        this.$message.warning('请至少保留一个SKU规格值')
        return
      }
      spec.values.splice(valueIndex, 1)
      if (specIndex === 0 && value) {
        this.$delete(this.cloudEditForm.skuValueImages, value)
      }
      this.syncSkuEnabledFromSpecs()
      this.syncSkuImagesFromFirstSpec()
      this.markCloudEditDirty()
    },

    handleSkuSpecChange() {
      this.syncSkuEnabledFromSpecs()
      this.markCloudEditDirty()
    },

    rebuildSkusFromSpecs() {
      const validSpecs = this.cloudEditForm.skuSpecs
        .map(spec => ({
          name: (spec.name || '').trim(),
          values: (spec.values || []).map(value => String(value).trim()).filter(Boolean),
        }))
        .filter(spec => spec.name && spec.values.length > 0)

      if (validSpecs.length === 0) {
        this.cloudEditForm.skus = []
        this.cloudEditForm.skuValueImages = {}
        return
      }

      const firstSpecValues = validSpecs[0].values
      Object.keys(this.cloudEditForm.skuValueImages || {}).forEach(value => {
        if (!firstSpecValues.includes(value)) {
          this.$delete(this.cloudEditForm.skuValueImages, value)
        }
      })

      const oldSkuMap = {}
      this.cloudEditForm.skus.forEach(sku => {
        oldSkuMap[this.getSkuAttributesKey(sku.attributes)] = sku
      })

      const combinations = validSpecs.reduce((result, spec) => {
        const values = spec.values.map(value => [spec.name, value])
        if (result.length === 0) {
          return values.map(value => [value])
        }
        const next = []
        result.forEach(items => {
          values.forEach(value => next.push([...items, value]))
        })
        return next
      }, [])

      this.cloudEditForm.skus = combinations.map(attrs => {
        const attributesKey = this.getSkuAttributesKey(attrs)
        const oldSku = oldSkuMap[attributesKey]
        const firstValue = attrs[0] && attrs[0][1]
        return {
          id: oldSku ? oldSku.id : '',
          attributes: attrs,
          price: oldSku ? oldSku.price : null,
          stock: oldSku ? oldSku.stock : 999,
          image_url: firstValue ? (this.cloudEditForm.skuValueImages[firstValue] || '') : '',
        }
      })
    },

    removeCloudEditImage(type, index) {
      const key = type === 'detail' ? 'detail_images' : 'main_images'
      this.cloudEditForm[key].splice(index, 1)
      this.markCloudEditDirty()
    },

    moveCloudEditImage(type, index, step) {
      const key = type === 'detail' ? 'detail_images' : 'main_images'
      const targetIndex = index + step
      const list = this.cloudEditForm[key]
      if (targetIndex < 0 || targetIndex >= list.length) return
      const current = list.splice(index, 1)[0]
      list.splice(targetIndex, 0, current)
      this.markCloudEditDirty()
    },

    submitCloudEdit() {
      if (!this.cloudEditForm.title || !this.cloudEditForm.title.trim()) {
        this.$message.warning('请填写商品标题')
        return
      }
      if (this.cloudEditForm.main_images.length < 3) {
        this.$message.warning('请至少保留三张商品图片')
        return
      }
      if (this.hasDuplicateImageUrls(this.cloudEditForm.main_images)) {
        this.$message.warning('商品图片不能重复')
        return
      }
      if (this.cloudEditForm.detail_images.length < 2) {
        this.$message.warning('请至少保留两张详情图片')
        return
      }
      if (this.hasDuplicateImageUrls(this.cloudEditForm.detail_images)) {
        this.$message.warning('详情图片不能重复')
        return
      }
      const enabledSkus = this.cloudEditForm.skus.filter(sku => sku.enabled)
      if (!enabledSkus.length) {
        this.$message.warning('请至少保留一个SKU')
        return
      }
      const invalidSkuIndex = enabledSkus.findIndex(sku => {
        const priceText = String(sku.price === null || typeof sku.price === 'undefined' ? '' : sku.price).trim()
        return !/^\d+(\.\d{1,2})?$/.test(priceText) || Number(priceText) <= 0
      })
      if (invalidSkuIndex !== -1) {
        this.$message.warning(`请填写第 ${invalidSkuIndex + 1} 个SKU价格，价格必须大于0且最多两位小数`)
        return
      }
      this.syncSkuImagesFromFirstSpec()
      this.cloudEditSaving = true
      this.saveCloudProductEdit({
        id: this.cloudEditForm.id,
        data: {
          title: this.cloudEditForm.title,
          main_images: this.cloudEditForm.main_images,
          detail_images: this.cloudEditForm.detail_images,
          skus: this.cloudEditForm.skus.map(sku => ({
            id: sku.id,
            price: sku.price,
            stock: sku.stock,
            image_url: sku.image_url || '',
            enabled: sku.enabled !== false,
          })),
        },
        success: (res) => {
          this.cloudEditSaving = false
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.cloudEditDirty = false
            const row = res.data || {}
            const updateLocalRow = (item) => {
              if (item && item.id === row.id) {
                item.title = row.title
                item.main_image = row.main_image
                item.price = row.price
                item.updated_at_text = this.formatDateTime(new Date())
              }
            }
            this.cloudTableData.forEach(updateLocalRow)
            this.cloudEditList.forEach(updateLocalRow)
            if (this.cloudEditMode === 'single') {
              this.cloudEditShow = false
            } else {
              this.loadCloudEditDetail({ id: this.cloudEditForm.id })
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    handleCloudEditClose() {
      this.cloudEditDirty = false
      this.cloudEditCurrent = null
      this.cloudEditMode = 'single'
      this.cloudEditForm = { id: '', product_id: '', title: '', price: '', main_images: [], detail_images: [], skuSpecs: [], skus: [], skuValueImages: {} }
      this.cloudEditList = []
      this.cloudEditSourceList = []
      this.cloudEditGroupId = ''
      this.cloudEditAppliedGroupId = ''
      this.cloudEditSkuStatus = ''
      this.cloudEditAppliedSkuStatus = ''
      this.cloudEditAppraisalStatus = ''
      this.cloudEditAppliedAppraisalStatus = ''
      this.cloudEditUseRemoteList = false
      this.cloudEditListLoading = false
      this.cloudEditRemoteSearchParams = {}
      this.cloudEditRemoteParams = {}
      this.cloudEditPageData = { page: 1, limit: 10, total: 0 }
      this.cloudEditAppliedPageData = { page: 1, limit: 10 }
      this.showError = false;
    },

    // === 校验商品标题 ===
    // 1. 实时输入校验逻辑
    handleRealtimeValidate(value) {
      this.cloudEditDirty = true

      // 规则 A：不能出现连续空格、换行符(\n)、反斜杠(\)、tab符
      const spaceAndSpecialReg = /\s{2,}|[\\\n\t]/;
      if (spaceAndSpecialReg.test(value)) {
        this.triggerError('商品标题不能出现连续空格、换行符(\\n\)、反斜杠(\\\)、tab符(\\t\)或tab符号，请重新填写');
        return;
      }

      // 规则 B：不能出现Emoji
      const emojiReg = /\p{Extended_Pictographic}/u;
      if (emojiReg.test(value)) {
        this.triggerError('商品标题中不能包含 Emoji 表情，请重新填写');
        return;
      }

      // 规则 C：头部不能出现空格（实时输入时，尾部空格先不校验，因为用户可能正在输入中间的空格，留到失焦校验）
      if (value.startsWith(' ')) {
        this.triggerError('商品标题的头部不能出现空格，请重新填写');
        return;
      }

      // 如果以上实时规则都通过，隐藏错误提示
      this.showError = false;
    },

    // 2. 失去焦点时的最终校验（兜底尾部空格）
    handleBlurValidate() {
      const value = this.cloudEditForm.title;
      if (value.endsWith(' ')) {
        this.triggerError('商品标题的尾部不能出现空格，请重新填写');
      }
    },

    // 触发错误显示
    triggerError(msg) {
      this.errorMessage = msg;
      this.showError = true;
    },

    // === 获取类目推荐列表 ===
    getCategoryRecommend(timeout=0){
      this.crLoading = true
      this.fetchCategoryRecommend({
        data: {
          name:this.cloudEditForm.title,
          images:this.cloudEditForm.main_images
        },
        success: (res) => {
          setTimeout(()=>{
            this.crLoading = false
            if(res.code==200){
              const keys =['second','third','fourth']
              this.cateRecommendList =res.data.categoryDetails.map(item=>{
                let obj ={
                  id:item.category_detail.first_cid,
                  name:item.category_detail.first_cname,
                  qualification_status:item.qualification_status
                }
                keys.forEach(key=>{
                  if(item.category_detail[key+'_cid']){
                    obj.id = item.category_detail[key+'_cid']
                    obj.name +='>'+item.category_detail[key+'_cname']
                  }
                })
                return obj
              })
            }else{
              this.$message.error(res.message || '获取类目推荐失败')
            }
          },timeout)
        }
      })
    },

    // 获取分组列表（筛选用，不需要数量）
    loadGroupList() {
      // if (this.groupList.length > 0) return
      // this.groupLoading = true
      this.getCloudProductGroups({
        data: { },
        success: (res) => {
          // this.groupLoading = false
          if (res.code === 200) {
            this.groupList = res.data || []
          }
        }
      })
    },

    // 刷新分组列表
    refreshGroupList() {
      this.groupPageData.page = 1
      this.groupSearchParams = {main_name: '', child_name: ''}
      this.resetGroupChildren()
      this.getGroupDataList()
    },
    handleGroupSearch() {
      this.groupPageData.page = 1
      this.resetGroupChildren()
      this.getGroupDataList()
    },
    getGroupDataList() {
      this.resetGroupChildren()
      this.groupLoading = true
      const requestId = ++this.groupParentRequestId
      const params = {page: this.groupPageData.page, page_size: this.groupPageData.limit, ...this.groupSearchParams}
      this.getCloudProductGroupParents({
        data: params,
        success: (res) => {
          if (requestId !== this.groupParentRequestId) {
            return
          }
          this.groupLoading = false
          if (res.code === 200) {
            this.groupTableData = res?.data?.list ?? []
            this.groupPageData.total = res?.data?.total ?? 0
          } else {
            this.groupTableData = []
            this.groupPageData.total = 0
            this.$message.error(res.message || '获取主分组失败')
          }
        }
      })
    },

    resetGroupChildren() {
      ++this.groupChildrenRequestId
      this.groupExpandedKeys = []
      this.groupExpandedParentId = null
      this.groupChildrenData = []
      this.groupChildrenLoading = false
      this.groupChildrenPageData = {page: 1, limit: 50, total: 0}
    },

    handleGroupParentExpand(row, expandedRows) {
      const expanded = expandedRows.some(item => item.id === row.id)
      if (!expanded) {
        if (this.groupExpandedParentId === row.id) {
          this.resetGroupChildren()
        }
        return
      }

      this.groupExpandedKeys = [row.id]
      this.groupExpandedParentId = row.id
      this.groupChildrenData = []
      this.groupChildrenPageData = {page: 1, limit: 50, total: 0}
      this.loadGroupChildren(row.id, true)
    },

    loadGroupChildren(parentId, reset = false) {
      if (parentId !== this.groupExpandedParentId) {
        return
      }
      if (reset) {
        this.groupChildrenData = []
        this.groupChildrenPageData.page = 1
      }

      this.groupChildrenLoading = true
      const requestId = ++this.groupChildrenRequestId
      const params = {
        page: this.groupChildrenPageData.page,
        page_size: this.groupChildrenPageData.limit,
        name: this.groupSearchParams.child_name,
      }
      this.getCloudProductGroupChildren({
        parentId,
        data: params,
        success: (res) => {
          if (requestId !== this.groupChildrenRequestId || parentId !== this.groupExpandedParentId) {
            return
          }
          this.groupChildrenLoading = false
          if (res.code === 200) {
            const list = res?.data?.list ?? []
            this.groupChildrenData = reset ? list : [...this.groupChildrenData, ...list]
            this.groupChildrenPageData.total = res?.data?.total ?? 0
            this.groupChildrenPageData.page = res?.data?.page ?? this.groupChildrenPageData.page
          } else {
            this.$message.error(res.message || '获取子分组失败')
          }
        }
      })
    },

    loadMoreGroupChildren(parentId) {
      if (this.groupChildrenLoading || parentId !== this.groupExpandedParentId || this.groupChildrenData.length >= this.groupChildrenPageData.total) {
        return
      }
      ++this.groupChildrenPageData.page
      this.loadGroupChildren(parentId)
    },

    // 添加分组
    handleAddGroup() {
      this.groupForm = { name: '', child_name: '', grade: 1, parent_id: '', sort: 0 }
      this.groupFormEdit = false
      this.groupFormShow = true
    },

    handleAddChildGroup(parent) {
      this.groupForm = {name: '', child_name: '', grade: 2, parent_id: parent.id, sort: 0}
      this.groupFormEdit = false
      this.groupFormShow = true
    },

    // 编辑分组
    handleEditGroup(row) {
      this.groupForm = { id: row.id, name: row.name, sort: row.sort || 0, grade: row.parent_id === 0 ? 1 : 2, parent_id: row.parent_id }
      this.groupFormEdit = true
      this.groupFormShow = true
    },

    // 提交分组表单
    submitGroupForm() {
      if (!this.groupForm.name || !this.groupForm.name.trim()) {
        this.$message.warning('请输入分组名称')
        return
      }

      if (this.groupForm.grade === 2 && !this.groupForm.parent_id) {
        this.$message.warning('请输入选择主分组')
        return
      }
      if (!this.groupFormEdit && this.groupForm.grade === 1 && (!this.groupForm.child_name || !this.groupForm.child_name.trim())) {
        this.$message.warning('请输入首个子分组名称')
        return
      }

      this.groupFormLoading = true
      let data = { name: this.groupForm.name, sort: this.groupForm.sort }
      if (this.groupForm.grade === 2) {
        data.parent_id = this.groupForm.parent_id
      } else if (!this.groupFormEdit) {
        data.child_name = this.groupForm.child_name
      }
      if (this.groupFormEdit) {
        this.opCloudProductGroupUpdate({
          id: this.groupForm.id,
          data,
          success: (res) => {
            this.groupFormLoading = false
            if (res.code === 200) {
              this.$message.success('修改成功')
              this.groupFormShow = false
              this.refreshGroupList()
              this.loadGroupList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      } else {
        this.opCloudProductGroupCreate({
          data,
          success: (res) => {
            this.groupFormLoading = false
            if (res.code === 200) {
              this.$message.success('添加成功')
              this.groupFormShow = false
              this.refreshGroupList()
              this.loadGroupList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }
    },

    // 删除分组
    handleDeleteGroup(row) {
      this.$confirm(`确定要删除分组「${row.name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opCloudProductGroupDelete({
          id: row.id,
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.refreshGroupList()
              this.loadGroupList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },

    // 批量加入分组
    handleBatchSetGroup() {
      if (this.cloudSelectedList.length === 0) {
        this.$message.warning('请先选择商品')
        return
      }
      this.batchGroupId = null
      this.batchChildGroupId = null
      this.set_child_groupList = []
      this.batchGroupShow = true
      // this.loadGroupList()
    },

    // 提交批量加入分组
    submitBatchSetGroup() {
      if (this.batchGroupId === null || this.batchGroupId === '') {
        this.$message.warning('请选择分组')
        return
      }
      this.batchGroupLoading = true
      const product_ids = this.cloudSelectedList.map(item => item.id)
      const isRemoveGroup = this.batchGroupId === 0
      const isRemoveChildGroup = !this.batchChildGroupId || this.batchChildGroupId === 0
      if (!isRemoveGroup && isRemoveChildGroup) {
        this.$message.warning('请选择子分组')
        this.batchGroupLoading = false
        return
      }
      this.opCloudProductBatchSetGroup({
        data: { product_ids, child_group_id: isRemoveChildGroup ? null : this.batchChildGroupId },
        success: (res) => {
          this.batchGroupLoading = false
          if (res.code === 200) {
            this.$message.success(isRemoveGroup ? '已去除分组' : '加入分组成功')
            this.batchGroupShow = false
            this.cloudSelectedList = []
            this.getCloudDataList()
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // 获取排除已铺货店铺列表
    getExcludeShopList() {
      if (this.excludeShopList.length > 0) return
      this.getDistributeShopSel({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.excludeShopList = res.data || []
          }
        }
      })
    },

    // 查看替换日志
    handleViewReplaceLogs(row) {
      this.currentReplaceLogItemId = row.id
      this.replaceLogPageData.page = 1
      this.replaceLogShow = true
      this.getReplaceLogData()
    },
    // 查看云商品铺货日志
    handleViewDistributeRecords(row) {
      this.distributeRecordProductTitle = row.title || ''
      this.distributeRecordSourceProductId = row.source_product_id || ''
      this.distributeRecordShow = true
      this.distributeRecordLoading = true
      this.distributeRecordList = []
      this.getCloudProductDistributeRecords({
        id: row.id,
        success: (res) => {
          this.distributeRecordLoading = false
          if (res.code === 200 || res.code === 0) {
            this.distributeRecordList = Array.isArray(res.data) ? res.data : []
          } else {
            this.$message.error(res.message || res.msg || '获取铺货日志失败')
          }
        },
        error: () => {
          this.distributeRecordLoading = false
          this.$message.error('获取铺货日志失败')
        },
      })
    },
    getDistributeRecordDialogTitle() {
      const productTitle = this.distributeRecordProductTitle || '-'
      const sourceProductId = this.distributeRecordSourceProductId || '-'
      return `${productTitle}（来源ID：${sourceProductId}）`
    },
    getDistributeStatusTag(status) {
      if (Number(status) === 4) return 'success'
      if (Number(status) === 5) return 'danger'
      return 'warning'
    },
    getPlatformStatusTag(status) {
      if (Number(status) === 2) return 'danger'
      if (Number(status) === 4) return 'success'
      return 'info'
    },
    isDistributeRecordFlagEnabled(status) {
      return Number(status) === 1
    },
    isDistributeRecordError(record) {
      return Number(record.distribute_status) === 5 || Number(record.platform_status) === 2
    },
    // 查看替换日志
    handleViewReplaceTitleLogs(row) {
      if(!row.product_id) {
        this.$message.error('商品ID异常')
        return
      }
      this.replaceTitleLogLoading = true
      this.getFindByProductid(row.product_id);
    },
    getFindByProductid(product_id){
        this.replaceTitleLogShow = true
        this.opGetFindByProductid({
            data: product_id,
            success: (res) => {
                this.replaceTitleLogLoading = false
                if (res.code === 200) {
                    this.replaceTitleLogList = res.data || []
                } else {
                    this.$message.error(res.message)
                }
        }
      })
    },
    // 获取替换日志数据
    getReplaceLogData() {
      this.replaceLogLoading = true
      this.getReplaceLogList({
        data: {
          import_item_id: this.currentReplaceLogItemId,
          page: this.replaceLogPageData.page,
          page_size: this.replaceLogPageData.limit
        },
        success: (res) => {
          this.replaceLogLoading = false
          if (res.code === 200) {
            this.replaceLogList = res.data.list || []
            this.replaceLogPageData.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // 打开替换日志链接
    openReplaceLogUrl(url) {
      window.open(url, '_blank')
    },

    handleCloudSelectionChange(selection) {
      this.cloudSelectedList = selection
    },

    // 只有成功状态的商品可以选择铺货
    checkCloudSelectable(row) {
      return row.status === 1
    },

    // 云商品铺货
    handleCloudDistribute() {
      // 按钮已经被禁用，但保留检查防止意外情况
      if (this.cloudSelectedList.length === 0) {
        this.$message.warning('请先选择要铺货的商品')
        return
      }

      // 检查是否有成功状态的商品
      const successProducts = this.cloudSelectedList.filter(item => item.status === 1)
      if (successProducts.length === 0) {
        this.$message.warning('请选择成功状态的商品进行铺货')
        return
      }

      if (successProducts.length < this.cloudSelectedList.length) {
        this.$message.warning(`已过滤非成功状态的商品，将对 ${successProducts.length} 个商品进行铺货`)
        // 更新选中列表为只包含成功的商品
        this.cloudSelectedList = successProducts
      }

      this.cloudDistributeShow = true
      this.cloudShopLoading = true
      this.cloudSelectedShopIds = [] // 重置选中店铺
      this.cloudShopTab = 'douyin' // 重置为默认抖店Tab
      // 获取店铺列表，铺货需要status=1的店铺
      this.getDistributeShopSel({
        data: { status: 1 },
        success: (res) => {
          if (res.code === 200) {
            this.cloudShopList = (res.data || []).map(item => ({ ...item, is_selected: 0 }))
          } else {
            this.$message.error(res.message)
          }
          this.cloudShopLoading = false
        }
      })
    },

    // 抖店分组全选
    handleDouyinCheckAllChange(checked) {
      const douyinIds = this.cloudShopListByType.douyin.map(s => s.shop_id)
      if (checked) {
        // 添加所有抖店ID
        const newIds = [...this.cloudSelectedShopIds]
        douyinIds.forEach(id => {
          if (!newIds.includes(id)) newIds.push(id)
        })
        this.cloudSelectedShopIds = newIds
      } else {
        // 移除所有抖店ID
        this.cloudSelectedShopIds = this.cloudSelectedShopIds.filter(id => !douyinIds.includes(id))
      }
    },

    // 微信店铺分组全选
    handleWechatCheckAllChange(checked) {
      const wechatIds = this.cloudShopListByType.wechat.map(s => s.shop_id)
      if (checked) {
        const newIds = [...this.cloudSelectedShopIds]
        wechatIds.forEach(id => {
          if (!newIds.includes(id)) newIds.push(id)
        })
        this.cloudSelectedShopIds = newIds
      } else {
        this.cloudSelectedShopIds = this.cloudSelectedShopIds.filter(id => !wechatIds.includes(id))
      }
    },

    // 店铺选择变化
    handleShopSelectionChange(val) {
      this.cloudSelectedShopIds = val
    },

    cloudCheckAllChange(e) {
      this.cloudIsIndeterminate = false;
      this.cloudCheckAll = e
      this.cloudShopList.forEach(item => {
        item.is_selected = e ? 1 : 0
      })
    },

    submitCloudDistribute() {
      if (!this.cloudSelectedShopIds.length) {
        this.$message.error("请选择要铺货的店铺")
        return
      }
      const product_ids = this.cloudSelectedList.map(item => item.id)
      this.cloudDistributeLoading = true
      this.createCloudProductDistribute({
        data: {
          product_ids: product_ids,
          shop_ids: this.cloudSelectedShopIds
        },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.message)
            this.cloudDistributeShow = false
            this.cloudSelectedList = []
            this.cloudSelectedShopIds = []
            this.getCloudDataList() // 刷新列表
          } else {
            this.$message.error(res.message)
          }
          this.cloudDistributeLoading = false
        }
      })
    },

    // 批量删除云商品
    handleCloudBatchDelete() {
      if (this.cloudSelectedList.length === 0) return
      this.$confirm(`确定要删除选中的 ${this.cloudSelectedList.length} 个商品吗？此操作不可恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const product_ids = this.cloudSelectedList.map(item => item.id)
        this.doDeleteCloudProducts(product_ids)
      }).catch(() => {})
    },

    // 单个删除云商品
    handleCloudDelete(row) {
      this.$confirm('确定要删除该商品吗？此操作不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteCloudProducts([row.id])
      }).catch(() => {})
    },

    // 执行删除操作
    doDeleteCloudProducts(product_ids) {
      this.cloudLoading = true
      this.deleteCloudProducts({
        data: {
          ids: product_ids
        },
        success: (res) => {
          this.cloudLoading = false
          if (res.code === 200) {
            const { success_count, fail_count, fail_reasons } = res.data || {}

            // 刷新列表（无论是否全部成功，都要刷新，因为可能部分成功）
            this.getCloudDataList()

            // 如果有失败的
            if (fail_count > 0) {
                const h = this.$createElement;
                const messageParts = [];

                messageParts.push(h('p', null, `成功删除 ${success_count} 个，失败 ${fail_count} 个。`));
                if (fail_reasons && fail_reasons.length > 0) {
                    messageParts.push(h('p', { style: 'margin-top: 10px; font-weight: bold;' }, '失败原因：'));
                    fail_reasons.forEach(reason => {
                        messageParts.push(h('p', { style: 'color: #F56C6C; font-size: 12px; margin-top: 4px;' }, reason));
                    });
                }

                this.$msgbox({
                    title: '删除结果',
                    message: h('div', null, messageParts),
                    type: 'warning',
                    confirmButtonText: '确定'
                });
            } else {
                this.$message.success('删除成功')
            }

            // 清理选中状态 (只保留未删除的，或者简单起见全部清空让用户重新选)
            // 既然刷新了列表，简单的做法是清空选中，因为ID可能变了或者不在当前页了
            this.cloudSelectedList = []

          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    //批量恢复检测下架的数据
    handleCloudBatchRecover(){
      if (this.cloudSelectedList.length === 0) return
      this.$confirm(`确认恢复因检测出现标题关键词异常的数据？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const product_ids = this.cloudSelectedList.map(item => item.id).join(',')
       this.doRecoverCloudProduct(product_ids)
      }).catch(() => {})
    },

    //单个恢复检测下架的数据
    handleCloudRecover(row){
      this.$confirm('确认恢复该条因检测出现标题关键词异常的数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doRecoverCloudProduct(String(row.id))
      })
    },

    //执行恢复操作
    doRecoverCloudProduct(product_ids){
      this.cloudLoading = true
      this.opRecoverCloudProduct({
        data: {
          ids: product_ids
        },
        success: (res) => {
          this.cloudLoading = false
          if (res.code === 200) {
            // 清理选中状态 (只保留未删除的，或者简单起见全部清空让用户重新选)
            this.cloudSelectedList = []
            this.$message.success('数据恢复成功')
          } else {
            this.$message.error(res.message)
          }
          // 刷新列表（无论是否全部成功，都要刷新，因为可能部分成功）
          this.getCloudDataList()
        }
      })
    },

    // === 以图搜款逻辑 ===
    // 单个搜款
    handleCloudImageSearch(row) {
      // 只允许导入成功的商品进行SKU替换
      if (row.status !== 1) {
        this.$message.warning('只能对导入成功的商品进行SKU替换')
        return
      }
      this.imageSearchCache = {} // 清空缓存
      this.selectedReplaceMap = {} // 清空选中状态
      this.imageSearchList = [row]
      this.imageSearchShow = true
      this.skuPageData={ limit: 20, page: 1,total: 0,}
      this.handleSelectSearchProduct(row)
    },

    // 批量搜款
    handleCloudBatchImageSearch() {
      /*if (this.cloudSelectedList.length === 0) return
      // 过滤出导入成功的商品
      const successProducts = this.cloudSelectedList.filter(item => item.status === 1)
      if (successProducts.length === 0) {
        this.$message.warning('请选择导入成功的商品进行SKU替换')
        return
      }
      if (successProducts.length < this.cloudSelectedList.length) {
        this.$message.warning(`已过滤非成功状态的商品，将对 ${successProducts.length} 个商品进行SKU替换`)
      }
      this.imageSearchCache = {} // 清空缓存
      this.selectedReplaceMap = {} // 清空选中状态
      this.imageSearchList = successProducts
      this.imageSearchShow = true
      if (this.imageSearchList.length > 0) {
        this.handleSelectSearchProduct(this.imageSearchList[0])
      }*/
      this.aiReplace = false
      this.replace_title = 'SKU替换'
      this.imageSearchShow = true
      this.sku_child_groupList = []
      this.skuGroupId=this.cloudSearchParams.group_id||''
      this.skuIsSkuMiss = this.cloudSearchParams.is_sku_miss||''
      this.sku_child_groupList = []
      if(this.skuGroupId) {
          this.sku_child_groupList =  this.groupList.find(i => i.id === this.skuGroupId)?.child_groups || []
      }
      this.skuChildGroupId=this.cloudSearchParams.child_group_id||''
      this.getSkuReplaceList(true)
    },
    handleAICloudBatchImageSearch() {
      this.aiMarkMode = false
      if (this.power_num < 10) {
        this.$alert('算力不足，请充值算力再使用');
        return
      }
      this.$confirm('使用AI-SKU替换需要配合插件使用，请勿自行替换，避免损失算力?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.replace_title = 'AI-SKU替换',
          this.aiReplace = true
          this.imageSearchShow = true
          this.skuGroupId = this.cloudSearchParams.group_id||''
          this.sku_child_groupList = []
          if(this.skuGroupId) {
            this.sku_child_groupList =  this.groupList.find(i => i.id === this.skuGroupId)?.child_groups || []
          }
          this.skuChildGroupId=this.cloudSearchParams.child_group_id||''
          this.getSkuReplaceList(true)
        }).catch(() => {
        });


    },
    handleAICloudBatchProductMark() {
      if (this.power_num < 10) {
        this.$alert('算力不足，请充值算力再使用')
        return
      }
      this.$confirm('使用AI货源商品标记需要配合插件使用，请勿自行标记，避免损失算力', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.replace_title = 'AI-商品货源标记'
        this.aiReplace = false
        this.aiMarkMode = true
        this.skuMarkStatusValue = ''
        this.imageSearchShow = true
        this.skuGroupId = this.cloudSearchParams.group_id || ''
        this.sku_child_groupList = this.skuGroupId
          ? this.groupList.find(i => i.id === this.skuGroupId)?.child_groups || []
          : []
        this.skuChildGroupId = this.cloudSearchParams.child_group_id || ''
        this.getSkuReplaceList(true)
      }).catch(() => {})
    },
    getSkuReplaceList(isClick){
      this.imageSearchList=[]
      this.skuLoading = true
      const params = {
        page: this.skuPageData.page,
        page_size: this.skuPageData.limit,
        status:1,
        sku_status:this.skuStatusValue,
        sku_mark_status: this.aiMarkMode ? this.skuMarkStatusValue : '',
        group_id:this.skuGroupId,
        child_group_id: this.skuChildGroupId,
        appraisal_status: this.appraisalStatusValue,
        is_sku_miss:this.skuIsSkuMiss
      }
      if(params.sku_status=='') delete params.sku_status
      if(params.sku_mark_status=='') delete params.sku_mark_status
      this.getCloudProductList({
        data: params,
        success: (res) => {
          this.skuLoading = false
          if (res.code == 200) {
            this.imageSearchList = res.data.list || []
            this.skuPageData.total = res.data.total || 0
            if(!this.imageSearchList.length) return
            let index=0
            if(this.batchLinkVisible&&this.currentSearchProductIndex>=0){
              index =this.currentSearchProductIndex
            }
            if(isClick&&!this.batchLinkVisible){
              this.handleSelectSearchProduct(this.imageSearchList[index])
            }
            if(this.batchLinkVisible){
              this.handleSelectLinkProduct(this.imageSearchList[index],index)
            }
            } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleSizeChangeSku(val) {
      this.skuPageData.limit = val
      this.skuPageData.page=1
      this.getSkuReplaceList(true)

    },
    handleCurrentChangeSku(val) {
      this.skuPageData.page=val
      if(this.batchLinkVisible){
        this.currentSearchProductIndex=-1
      }
      this.getSkuReplaceList()
    },
    searchSkuGroupReplaceList(val){
      this.skuChildGroupId = ''
      this.sku_child_groupList =  this.groupList.find(i => i.id === val)?.child_groups || []
      this.searchSkuReplaceList()
    },
    searchSkuReplaceList(){
      this.skuPageData.page=1
      this.getSkuReplaceList(true)
    },
    // sku标记找不到
    handleMarkNotFound(item,index){
      // this.$confirm(`确认将此商品标记为未找到？`, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
        this.opSkuMarkNotFound({
          data: {
            ids : [item.id],
            aiReplace : this.aiReplace
          },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('标记成功')
              this.updateSkuReplaceList(index,3)
            } else {
              this.$message.error(res.message)
            }
            this.power_num = res.data.power_num||0
            if (this.aiReplace && this.power_num < 5) {
              this.imageSearchShow = false
              this.$alert('算力不足，请充值算力再使用');
              return
            }
          }
        })
      // }).catch(() => {})
    },
    // sku取消标记找不到
    handleCancelNotFound(item,index){
      // this.$confirm(`确认将此商品标记为未找到？`, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
        this.opSkuCancelNotFound({
          data: {
            ids : [item.id]
          },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('操作成功')
              this.updateSkuReplaceList(index,1)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      // }).catch(() => {})
    },
    handleProductMarkNotFound(item,index) {
      this.opProductMarkNotFound({
        data: { ids: [item.id], operation_no: `product-mark-not-found:${item.id}` },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success('标记成功')
            this.$set(this.imageSearchList[index], 'sku_mark_status', 3)
            this.power_num = res.data && res.data.power_num !== undefined ? res.data.power_num : this.power_num
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleProductMarkNotFoundCancel(item,index) {
      this.opProductMarkNotFoundCancel({
        data: { ids: [item.id] },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.$set(this.imageSearchList[index], 'sku_mark_status', 1)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    updateSkuReplaceList(index,status){
      this.imageSearchList[index].sku_status = status
      if(index<this.imageSearchList.length-1){
        //this.handleSelectSearchProduct(this.imageSearchList[index+1])
        const imageSearchListindex = index
        const nextProduct = this.imageSearchList.find((item,index) => (!this.replacedProductIds.includes(item.id) && index > imageSearchListindex && item.sku_status == 1))
        if(nextProduct){
          if (!this.aiReplace){
            this.handleSelectSearchProduct(nextProduct)
          }
        }else{
          index=(this.imageSearchList.length-1)
        }

      }
      if(index==this.imageSearchList.length-1&&this.skuPageData.page<Math.ceil(this.skuPageData.total/this.skuPageData.limit)){
        this.skuPageData.page++
        this.getSkuReplaceList(true)
      }
    },

    // 选中待搜商品，触发搜索
    handleSelectSearchProduct(item) {
      // this.priceSort=''
      console.log('搜索：',this.currentSearchProduct && this.currentSearchProduct.id === item.id)
      if (this.currentSearchProduct && this.currentSearchProduct.id === item.id) return
      this.imageSearchResult = []
      this.imageSearchResultCopy = []
      this.currentSearchProduct = item
      // 检查缓存（考虑过滤条件）
      const cacheKey = this.getCacheKey(item.id)
      if (this.imageSearchCache[cacheKey]) {
        const cached = this.imageSearchCache[cacheKey]
        this.imageSearchResult = cached.results
        this.imageSearchResultCopy = [... this.imageSearchResult]
        this.changePriceSort()
        this.currentProductDetail = cached.productDetail
        this.$nextTick(()=>{
          const container = this.$refs.searchResultGrid;
          container.scrollTop = 0;
        })
        return
      }
      this.imageSearchResult = []
      this.imageSearchResultCopy =[]
      this.currentProductDetail = null
      this.doImageSearch(item.id)
    },

    //价格排序
    changePriceSort(){
      if(this.priceSort=='price_asc'){
        this.imageSearchResult.sort((a,b)=>{
          return a.price-b.price
        })
      }else if(this.priceSort=='price_desc'){
        this.imageSearchResult.sort((a,b)=>{
          return b.price-a.price
        })
      }else{
        this.imageSearchResult = [...this.imageSearchResultCopy]
      }
    },
    // 调用搜款接口
    doImageSearch(id) {
      if (this.aiReplace && this.power_num < 10) {
        this.imageSearchShow = false
        this.$alert('算力不足，请充值算力再使用');
        return
      }
      this.imageSearchLoading = true
      const requestData = {
        id: id // 接口传单个ID
      }
      // 添加过滤条件
      if (this.searchFilters.length > 0) {
        requestData.filter = this.searchFilters.join(',')
      }
      //防抖
      if (this.isDebounce) return
      this.isDebounce = true
      setTimeout(() => {
        this.isDebounce = false
      }, 300) // 300ms 内只能点一次
      this.getImageSearchList({
        data: requestData,
        success: (res) => {
          this.imageSearchLoading = false
          if (res.code === 200) {
            // 搜索结果在 data.search_results 字段中
            let results = []
            if (res.data && res.data.search_results) {
                results = res.data.search_results
            }
            this.imageSearchResult = results
            this.imageSearchResultCopy = [...this.imageSearchResult]
            this.changePriceSort()
            // 提取当前商品的详细信息（包含SKU）
            let productDetail = null
            if (res.data && res.data.current_product) {
              productDetail = res.data.current_product
              this.currentProductDetail = productDetail
            } else {
              this.currentProductDetail = null
            }

            // 缓存结果和SKU信息（使用包含过滤条件的缓存键）
            // 只有搜索结果非空才缓存，空结果下次切换会重新调用接口
            if (results.length > 0) {
              const cacheKey = this.getCacheKey(id)
              this.$set(this.imageSearchCache, cacheKey, {
                results: results,
                productDetail: productDetail
              })
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // 选择搜索结果，弹出确认框并提交
    handleUseResult(result) {
        if (!this.currentSearchProduct) return
        const productId = this.currentSearchProduct.id

        // 弹出确认框
        const h = this.$createElement
        this.$msgbox({
            title: this.aiMarkMode ? '确认标记商品' : '确认替换SKU',
            message: h('div', { style: 'line-height: 1.8;' }, [
                h('p', null, [
                    h('span', { style: 'color: #606266;' }, '原商品: '),
                    h('span', { style: 'color: #303133; font-weight: bold;' }, this.currentSearchProduct.title.substring(0, 30) + (this.currentSearchProduct.title.length > 30 ? '...' : ''))
                ]),
                h('p', { style: 'margin-top: 8px;' }, [
                    h('span', { style: 'color: #606266;' }, this.aiMarkMode ?'标记为: ': '替换为: '),
                    h('span', { style: 'color: #E6A23C; font-weight: bold;' }, result.title.substring(0, 30) + (result.title.length > 30 ? '...' : ''))
                ]),
                h('p', { style: 'margin-top: 8px;' }, [
                    h('span', { style: 'color: #606266;' }, '价格: '),
                    h('span', { style: 'color: #F56C6C;' }, '¥' + result.price)
                ])
            ]),
            showCancelButton: true,
            confirmButtonText: this.aiMarkMode ? '确认标记' : '确认替换',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            // 用户确认，提交替换
            if (this.aiMarkMode) {
              this.doSingleProductMark(productId, result)
              return
            }
            this.doSingleReplace(productId, result.offer_id)
        }).catch(() => {
            // 用户取消
        })
    },

    // 执行单个商品替换
    doSingleReplace(productId, offerId) {
        this.replaceLoading = true

        this.doReplaceCloudProducts({
            data: {
                id: parseInt(productId),
                new_product_id: offerId,
                aiReplace : this.aiReplace
            },
            success: (res) => {
                this.replaceLoading = false
                if (res.code === 200) {
                    // 标记该商品已提交
                    if (!this.replacedProductIds.includes(productId)) {
                        this.replacedProductIds.push(productId)
                    }
                    // 记录替换成了哪个1688商品
                    this.$set(this.replacedTargetMap, productId, offerId)
                    // 清除选中状态
                    this.$delete(this.selectedReplaceMap, productId)

                    // 更新商品信息
                    const item = this.imageSearchList.find(p => p.id === productId)
                    if (item) {
                        // 更新时间
                        item.updated_at_text = this.formatDateTime(new Date())
                        // 更新价格
                        if (res.data && res.data.min_price !== undefined) {
                            item.price = res.data.min_price
                        }
                        //更新已替换字段
                        item.sku_status = 2
                    }

                    // 更新SKU信息和缓存
                    if (res.data && res.data.skus) {
                        const newSkus = res.data.skus
                        // 更新缓存中的SKU信息（无论当前是否选中该商品）
                        const cacheKey = this.getCacheKey(productId)
                        if (this.imageSearchCache[cacheKey]) {
                            const newProductDetail = {
                                ...(this.imageSearchCache[cacheKey].productDetail || {}),
                                skus: newSkus
                            }
                            this.imageSearchCache[cacheKey].productDetail = newProductDetail

                            // 如果当前选中的就是这个商品，同步更新显示
                            if (this.currentSearchProduct && this.currentSearchProduct.id === productId) {
                                this.currentProductDetail = newProductDetail
                            }
                        } else {
                            // 缓存不存在时，直接更新当前显示
                            if (this.currentSearchProduct && this.currentSearchProduct.id === productId) {
                                this.currentProductDetail = {
                                    ...(this.currentProductDetail || {}),
                                    skus: newSkus
                                }
                            }
                        }
                    }

                    // 废弃 自动跳转到下一个未提交的商品
                    //const nextProduct = this.imageSearchList.find(item => !this.replacedProductIds.includes(item.id))
                    // fix修改成自动跳转当前商品的下个商品
                    const imageSearchListindex = this.imageSearchList.findIndex(item => item.id === productId);
                    const nextProduct = this.imageSearchList.find((item,index) => (!this.replacedProductIds.includes(item.id) && index > imageSearchListindex && item.sku_status == 1))
                    if (nextProduct) {
                      if (!this.aiReplace){
                        // 显示loading提示
                        const loadingInstance = this.$loading({
                            target: '.image-search-container-new',
                            text: '已处理成功，正在跳转下一个商品...',
                            background: 'rgba(255, 255, 255, 0.8)'
                        })
                        // 延迟跳转，让用户看到提示
                        setTimeout(() => {
                            this.handleSelectSearchProduct(nextProduct)
                            loadingInstance.close()
                        }, 800)
                      }
                    } else {
                        this.$message.success('替换提交成功，所有商品已处理完成')
                    }
                } else {
                  this.$message.error(res.message || '替换失败')
                  //替换异常的情况 如果是AI替换，先走找不到关联商品，避免直接停止了AI替换程序
                  if(this.aiReplace) {
                    // 调用找不到关联商品
                    const index = this.imageSearchList.findIndex(p => p.id === productId)
                    const item = this.imageSearchList[index]
                    this.handleMarkNotFound(item, index)
                    return
                  }
                }

                this.power_num = res.data.power_num||0
                if (this.aiReplace && this.power_num < 10) {
                  this.imageSearchShow = false
                  this.$alert('算力不足，请充值算力再使用');
                  return
                }
            }
        })
    },
    doSingleProductMark(productId, result) {
      this.replaceLoading = true
      this.doMarkCloudProduct({
        data: {
          id: parseInt(productId),
          new_product_id: result.offer_id,
          aiMark: this.aiMarkMode
        },
        success: (res) => {
          this.replaceLoading = false
          if (res.code === 200) {
            if (!this.replacedProductIds.includes(productId)) {
              this.replacedProductIds.push(productId)
            }
            const item = this.imageSearchList.find(p => p.id === productId)
            if (item) {
              item.updated_at_text = this.formatDateTime(new Date())
              this.$set(item, 'sku_mark_status', 2)
            }
            this.power_num = res.data && res.data.power_num !== undefined ? res.data.power_num : this.power_num
            this.$message.success('标记商品成功')
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // 跳转到下一个未替换的商品
    goToNextUnreplacedProduct() {
        const nextProduct = this.imageSearchList.find(item => !this.replacedProductIds.includes(item.id))
        if (nextProduct) {
           if (!this.aiReplace){
              this.handleSelectSearchProduct(nextProduct)
           }
        }
    },

    // 获取已提交替换的数量
    getReplacedCount() {
        return this.replacedProductIds.length
    },

    // 格式化日期时间
    formatDateTime(date) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 查看商品详情（去除referer防止跟踪）
    handleViewProduct(result) {
        let url = ''
        if (result.detail_url) {
            url = result.detail_url
        } else if (result.offer_id) {
            url = `https://detail.1688.com/offer/${result.offer_id}.html`
        }
        if (url) {
            // 使用 noopener noreferrer 去除 referer
            const a = document.createElement('a')
            a.href = url
            a.target = '_blank'
            a.rel = 'noopener noreferrer'
            a.click()
        }
    },

    // 取消以图搜款
    handleCancelImageSearch() {
      // 如果有已替换的商品，刷新列表
      const hasReplaced = this.replacedProductIds.length > 0

      this.imageSearchShow = false
      this.imageSearchCache = {}
      this.selectedReplaceMap = {}
      this.currentSearchProduct = null
      this.currentProductDetail = null
      this.imageSearchResult = []
      this.searchFilters = []
      this.filterVisible = false
      // 清空二级select相关状态
      this.selectedCategory = ''
      this.selectedOption = ''
      this.strategyType = ''
      this.pendingFilters = []
      this.replacedProductIds = [] // 清空已替换列表
      this.replacedTargetMap = {} // 清空替换目标记录
      this.aiReplace = false
      this.aiMarkMode = false
      // 刷新云商品列表
      if (hasReplaced) {
        this.getCloudDataList()
      }
    },

    // 生成缓存键（包含过滤条件）
    getCacheKey(productId) {
      const filterKey = this.searchFilters.length > 0 ? this.searchFilters.sort().join(',') : 'none'
      return `${productId}-${filterKey}`
    },

    // 分类选择变化
    handleCategoryChange() {
      // 清空当前选中的具体选项
      this.selectedOption = ''
    },

    // 具体选项变化
    handleOptionChange() {
      // 可以在这里添加一些逻辑，但不执行搜索
    },

    // 添加过滤条件到待确认列表
    handleAddFilter() {
      if (!this.selectedCategory || !this.selectedOption) return

      // 检查是否已存在
      const exists = this.pendingFilters.some(filter => filter.value === this.selectedOption) ||
                     this.searchFilters.includes(this.selectedOption)

      if (exists) {
        this.$message.warning('该过滤条件已存在')
        return
      }

      // 获取标签文本
      const categoryGroup = this.filterOptions.find(group => group.key === this.selectedCategory)
      const option = categoryGroup.options.find(opt => opt.value === this.selectedOption)

      // 添加到待确认列表
      this.pendingFilters.push({
        label: option.label,
        value: option.value
      })

      // 清空选择
      this.selectedCategory = ''
      this.selectedOption = ''
    },

    // 移除待确认的过滤条件
    handleRemovePendingFilter(index) {
      this.pendingFilters.splice(index, 1)
    },

    // 移除已应用的过滤条件
    handleRemoveAppliedFilter(filterValue) {
      const index = this.searchFilters.indexOf(filterValue)
      if (index > -1) {
        this.searchFilters.splice(index, 1)
      }

      // 重新搜索
      if (this.currentSearchProduct) {
        this.imageSearchResult = []
        this.doImageSearch(this.currentSearchProduct.id)
      }
    },

    // 全部清空
    handleClearAllFilters() {
      this.searchFilters = []
      this.pendingFilters = []
      this.selectedCategory = ''
      this.selectedOption = ''
      this.strategyType = ''

      // 重新搜索
      if (this.currentSearchProduct) {
        this.imageSearchResult = []
        this.doImageSearch(this.currentSearchProduct.id)
      }
    },

    // 应用过滤条件
    handleApplyFilters() {
      if (this.pendingFilters.length === 0){
        this.handleClearAllFilters()
        return
      }

     /* // 将待确认的条件添加到搜索条件中
      this.pendingFilters.forEach(filter => {
        this.searchFilters.push(filter.value)
      })

      // 清空待确认列表
      this.pendingFilters = []*/
      this.searchFilters = this.pendingFilters.map(filter => filter.value)
      if(this.strategyType){
        this.strategyCache.value[this.strategyType] = [...this.pendingFilters]
         this.strategyCache.ex_time =new Date().getTime()+24*60*60*1000
        localStorage.setItem('strategyCache', JSON.stringify(this.strategyCache))
      }
      // 执行搜索
      if (this.currentSearchProduct) {
        this.imageSearchResult = []
        this.doImageSearch(this.currentSearchProduct.id)
      }
    },

    // 获取当前分类的选项
    getCurrentCategoryOptions() {
      if (!this.selectedCategory) return []
      const categoryGroup = this.filterOptions.find(group => group.key === this.selectedCategory)
      return categoryGroup ? categoryGroup.options : []
    },

    // 获取已选择过滤条件的标签
    getSelectedFilterLabels() {
      const labels = []
      this.filterOptions.forEach(group => {
        group.options.forEach(option => {
          if (this.searchFilters.includes(option.value)) {
            labels.push({
              label: option.label,
              value: option.value
            })
          }
        })
      })
      return labels
    },

    changeFilter(val) {
      let index = this.pendingFilters.findIndex(i => i.value == val.value)
      if (index == -1) {
        this.pendingFilters.push(val)
      } else {
        this.pendingFilters.splice(index, 1)
      }
    },

    //切换策略
    changeStrategy(type){
      this.pendingFilters=[]
      this.strategyType =this.strategyType=== type?'':type
      if(!this.strategyType){
        this.handleApplyFilters()
        return
      }
      if(this.strategyCache.value?.[this.strategyType]?.length){
        this.pendingFilters = this.strategyCache.value[this.strategyType]
        this.handleApplyFilters()
        return
      }
      this.pendingFilters=[
          {label: "48小时发货",value: "shipIn48Hours" },
          {label: "支持一件代发", value: "isOnePsale"},
          {label: "支持抖音密文打单",value: "dyCiphertext"}
      ]
      if(type==1){
       this.pendingFilters.push( {label: "一件代发包邮",value: "isOnePsaleFreePost"})
      }
      this.handleApplyFilters()
    },

    // 确认批量替换
    handleConfirmReplace() {
      const items = []
      for (const productId in this.selectedReplaceMap) {
        const selected = this.selectedReplaceMap[productId]
        items.push({
          id: parseInt(productId),
          new_product_id: selected.offer_id
        })
      }
      if (items.length === 0) {
        this.$message.warning('请先选择要替换的商品')
        return
      }
      this.replaceLoading = true
      this.doReplaceCloudProducts({
        data: { items },
        success: (res) => {
          this.replaceLoading = false
          if (res.code === 200) {
            this.$message.success(`成功替换 ${items.length} 个商品`)
            this.imageSearchShow = false
            this.imageSearchCache = {}
            this.selectedReplaceMap = {}
            this.getCloudDataList() // 刷新列表
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // 获取已选替换数量
    getSelectedReplaceCount() {
      return Object.keys(this.selectedReplaceMap).length
    },

    // === 铺货列表模块方法 ===
    getDistributeDataList() {
      this.distributeLoading = true
      const params = {
        page: this.distributePageData.page,
        page_size: this.distributePageData.limit,
        status: this.distributeSearchParams.status,
        shop_id: this.distributeSearchParams.shop_id,
        shop_type: this.distributeSearchParams.shop_type,
        keyword: this.distributeSearchParams.keyword,
      }

      if (this.distributeSearchParams.dateRange && this.distributeSearchParams.dateRange.length === 2) {
        params.start_date = this.distributeSearchParams.dateRange[0]
        params.end_date = this.distributeSearchParams.dateRange[1]
      }

      // 移除空字符串参数
      if (params.status === '') delete params.status
      if (params.shop_id === '') delete params.shop_id
      if (params.keyword === '') delete params.keyword
      if (params.shop_type === '') delete params.shop_type

      this.getDistributeItems({
        data: params,
        success: (res) => {
          this.distributeLoading = false
          if (res.code == 200) {
            this.distributeTableData = res.data.list || []
            this.distributePageData.total = res.data.total || 0
            if (this.distributePageData.page === 1 && this.distributeSearchParams.status === '' && res.data.stats) {
                this.distributeStats = res.data.stats
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    handleDistributeSearch() {
      this.distributePageData.page = 1
      this.getDistributeDataList()
    },

    handleDistributeReset() {
      this.distributeSearchParams = {
        status: '',
        shop_id: '',
        keyword: '',
        dateRange: [],
      }
      this.distributePageData.page = 1
      this.getDistributeDataList()
    },

    handleStatusTabClick(status) {
        if (this.distributeSearchParams.status === status) return;
        this.distributeSearchParams.status = status;
        this.handleDistributeSearch();
    },

    // 获取店铺列表用于筛选
    getFilterShopList() {
      this.getDdShopList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
             // 兼容不同接口返回结构，商品中心接口返回在 res.data.list.list
             const list = res.data.list ? (res.data.list.list || []) : (res.data || [])
             this.filterShopList = list
          }
        }
      })
    },

    //来源商品ID查看
    handleViewGoods(row){
      const route = this.$router.resolve({
        path: '/uc_goods',
        query: {
          cloud_source_product_id: row.source_product_id,
          shop_id: row.shop_id,
          shop_type:row.shop_type
        }
      });
      window.open(route.href, '_blank');
    },

    // === 表格样式控制（避免导入列表行高被全局样式拉伸） ===
    importCellStyle() {
      return {
        padding: '10px 0',
      }
    },

    importHeaderCellStyle() {
      return {
        background: '#eef1f6',
        color: '#606266',
        padding: '10px 0',
      }
    },
    handleSortChange({ column, prop, order }) {
        // 关键：order 为 null 时，清空排序参数
        if (!order) {
            this.cloudSearchParams.sortField = '';
            this.cloudSearchParams.sortOrder = '';
        } else {
            this.cloudSearchParams.sortField = prop;
            this.cloudSearchParams.sortOrder = order === 'ascending' ? 'asc' : 'desc';
        }
        this.getCloudDataList()
    },

    // === 指定替换 ===
    handleLinkReplace(row){
      this.linkReplaceVisible = true
      this.linkReplaceForm = {
        title:row.title,
        productId: row.id,
        replaceable:row.replaceable,
        produceLink: ''
      }
      this.$nextTick(()=>{
        this.$refs.linkReplaceFormRef.clearValidate()
      })
    },
    submitLinkReplace() {
      this.$refs.linkReplaceFormRef.validate().then(valid => {
        if (!valid) return false
        this.$confirm('确认将商品SKU替换成您提供的商品SKU吗？','提示',{
            type: 'warning',
          }).then(async () => {
          const flag = await this.doReplaceCloudProductsFun(this.linkReplaceForm.productId,this.linkReplaceForm.produceLink)
          if( flag){
            this.linkReplaceVisible = false
            this.getCloudDataList()
          }
          }).catch(() => {

          })
      })
    },
    doReplaceCloudProductsFun(productId,link) {
      return new Promise((resolve) => {
        const new_link = link.substring(0,link.indexOf('.html'))
        const arr = new_link.split('/')
        const goodsId = arr[arr.length - 1]
        this.lrLoading=true
        this.doReplaceCloudProducts({
          data: {
            id: parseInt(productId),
            new_product_id: goodsId,
            aiReplace :false
          },
          success: (res) => {
            if(res.code === 200){
              this.$message.success(res.message)
              resolve(true)
            }else{
              this.$message.error(res.message)
              resolve(false)
            }
            this.lrLoading=false
          }
        })
      })
    },
    // === 批量替换指定链接SKU ===
    handleCloudBatchLinkReplace(){
      this.batchLinkVisible=true
      this.skuGroupId = this.cloudSearchParams.group_id||''
      this.skuChildGroupId = this.cloudSearchParams.child_group_id||''
      this.sku_child_groupList=[]
      this.sku_child_groupList = []
      if(this.skuGroupId) {
      this.sku_child_groupList =  this.groupList.find(i => i.id === this.skuGroupId)?.child_groups || []
      }
      this.skuChildGroupId=this.cloudSearchParams.child_group_id||''
      this.replacedProductIds=[]
      this.getSkuReplaceList(true)
    },
    handleSelectLinkProduct(item,index){
      this.currentSearchProductIndex = index
      this.alternativeLinks = item.replaceable
      this.replaceLink = ''
      this.handleSelectSearchProduct(item)

    },
    async submitBatchLinkReplace() {
      if(!this.replaceLink){
        this.$message.error('请输入1688商品链接')
        return
      }
      const flag = await this.doReplaceCloudProductsFun(this.currentSearchProduct.id,this.replaceLink)
      if( flag){
        this.getSkuReplaceList(false)
      }
    },
    changeSetGroupId(val) {
        this.batchChildGroupId = null
        const target = this.groupList.find(i => i.id === val)
        this.set_child_groupList = target?.child_groups || []
    },
    changeGroupId(val) {
        this.$set(this.importInfo, 'child_group_id', '');
        const target = this.groupList.find(i => i.id === val)
        this.child_groupList = target?.child_groups || []
    },
    formatGroupName(row) {
        let group_name = row.group_name
        const target = this.groupList.find(i => i.id === row.group_id)?.child_groups?.find(i => i.id === row.child_group_id)
        const child_group_name = target?.name
        if(child_group_name) {
            group_name += '|'+child_group_name
        }
        return group_name;
    },

  }
}
</script>


<style scoped>

.center {
  display: flex;
  flex: 1;
}

.rc_main {
  padding: 36px 40px 46px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box; /* 确保 padding 不会撑大容器宽度，防止溢出 */
}

.table-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.rc_table {
  width: 100%;
  margin-top: 10px;
  table-layout: fixed;
  min-width: 900px;
}

/* 表格单元格内容过长时，超出部分省略，避免撑破容器 */
.rc_table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.op_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.import-op-box {
  gap: 12px;
}

.op-left-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.doudian-sync-entry {
  flex-shrink: 0;
}

.filter-box {
  margin-top: 10px;
}

.cloud-filter-box .search-row {
  margin-bottom: 10px;
}

.cloud-filter-box .action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.price-range-separator {
  margin: 0 6px;
  color: #909399;
}


/* 商品信息样式 */
.goods-box {
  display: flex;
  align-items: flex-start;
  width: 100%;
  /*max-width: 280px;*/ /* 限制最大宽度 */
  flex: 1;
}

.goods-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-right: 8px;
  border-radius: 4px;
  flex-shrink: 0; /* 防止图片被压缩 */
}

.goods-info {
  flex: 1;
  font-size: 12px;
  line-height: 1.5;
  min-width: 0; /* 允许内容收缩 */
  overflow: hidden;
}

.goods-info > div:not(.goods-title) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 2px;
}

.goods-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal; /* 标题允许换行 */
  margin-bottom: 4px;
}

.time-column {
  font-size: 12px;
  line-height: 1.6;
  color: #606266;
}

.time-column > div {
  white-space: nowrap;
}


/* 状态容器样式 */
.status-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  width: 100%;
 /* max-width: 180px;*/
  overflow: hidden;
  box-sizing: border-box;
}
.status-tag {
  margin-bottom: 2px;
}

/* 状态下方错误信息样式 */
.error-message-under-status {
  color: #f56c6c;
  font-size: 10px;
  line-height: 1.2;
  margin-top: 2px;
  word-break: break-all;
  text-align: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help;
  //max-width: 160px;
  max-width: calc(100% - 20px);
  width: 100%;
  padding: 0 4px;
  box-sizing: border-box;
  position: relative;
}

/* 统计栏样式 */
.status-tabs-container {
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
}

.status-tab-item {
  padding: 0 20px;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  display: list-item;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  position: relative;
  cursor: pointer;
  transition: all 0.3s;
}

.status-tab-item:hover {
  color: #f56c6c;
}

.status-tab-item.active {
  color: #f56c6c;
  border-bottom: 2px solid #f56c6c;
}

.status-count {
    margin-left: 4px;
    font-size: 12px;
}

/*过滤条件*/
.filter-item {
  display: flex;
  align-items: flex-start;
}

.filter-item ~ .filter-item {
  margin-top: 8px;
}

.filter-label {
  width: fit-content;
}

.filter-value {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.filter-tag {
  border: 1px solid #999999;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 12px;
  cursor: pointer;
}

.filter-tag.active {

  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}

/* 铺货弹窗店铺Tab样式 */
.shop-distribute-container {
  min-height: 300px;
  margin-top: -25px;
}

.shop-distribute-container >>> .el-tabs__header {
  margin-bottom: 10px;
}

.shop-tab-header {
  padding: 10px 0;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 10px;
}

.shop-tab-content {
  max-height: 300px;
  overflow-y: auto;
}

.shop-item {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.shop-item:last-child {
  border-bottom: none;
}

.shop-name {
  font-size: 14px;
  color: #303133;
}

.selected-count {
  margin-right: 20px;
  color: #606266;
  font-size: 14px;
}

/* 分组名称单元格 */
.group-name-cell {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

/* 替换日志链接样式 */
.replace-log-link {
  color: #409EFF;
  text-decoration: none;
  word-break: break-all;
  display: inline-block;
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.replace-log-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.replace-log-tip {
  color: #909399;
  font-size: 12px;
  margin-bottom: 10px;
}

.distribute-record-list {
  min-height: 180px;
  max-height: 65vh;
  overflow-y: auto;
}

.distribute-record-item {
  padding: 14px 16px;
  border: 1px solid #e4e7ed;
  border-left: 3px solid #e6a23c;
  border-radius: 4px;
  margin-bottom: 12px;
}

.distribute-record-item.is-error {
  border-left-color: #f56c6c;
  background: #fef0f0;
}

.distribute-record-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
  color: #303133;
  font-weight: 500;
}

.distribute-record-tags {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.distribute-record-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 20px;
  color: #303133;
  font-size: 13px;
}

.distribute-record-grid > div {
  min-width: 0;
  overflow-wrap: anywhere;
}

.distribute-record-grid span {
  display: inline-block;
  margin-right: 6px;
  color: #909399;
}

.distribute-record-error {
  margin-top: 12px;
  padding: 8px 10px;
  color: #f56c6c;
  background: #fdf6ec;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.mini-btn{
  padding: 0 5px;
  line-height: 18px;
}

/* 策略tab样式 */
.strategy-tabs{
  display: flex;
  align-items: center;
  gap: 10px;

  .strategy-item{
    border: 1px solid #999999;
    border-radius: 4px;
    padding: 4px;
    font-size: 12px;
    cursor: pointer;
    &.active{
      color: #67c23a;
      border: 1px solid #67c23a;
    }
  }
}
</style>

<style>
/* 图片搜索样式 - 非 scoped 以确保在 dialog 中生效 */


.sku-box{
  height: 80vh;
  display: flex;
  flex-direction: column;
}
/* SKU替换对话框样式重置 - 只影响包含image-search-container-new的对话框 */
.el-dialog__body:has(.image-search-container-new) {
  padding-top: 5px !important; /* 减少顶部间距 */
  padding-bottom: 10px !important; /* 减少底部间距 */
}
.image-search-container {
  display: flex;
  height: 600px;
  min-height: 0;
  border: 1px solid #e4e7ed;
}

/* 新的三区域布局 */
.image-search-container-new {
  display: flex;
  /*height: 800px; *//* 增加高度以提供更多空间 */
  /*max-height: calc(80vh - 280px);*/
  min-height: 0;
  border: 1px solid #e4e7ed;
 /* margin-top: -10px;*/ /* 向上移动减少与标题间距 */
}

.search-right-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.product-detail-panel {
  flex-shrink: 0;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  background: #fff;
  /*max-height: 150px;*/ /* 进一步减少高度 */
  overflow: hidden;
}

.sku-info-section {
  padding: 0; /* 移除内边距 */
  border: none; /* 移除边框 */
}

.sku-list {
  max-height: none; /* 让容器自适应，由panel的max-height控制 */
  overflow-y: visible;
}

.sub-header {
  font-weight: normal;
  color: #909399;
  font-size: 12px;
  margin-left: 10px;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
}

.search-left-panel {
  width: 400px;
  border-right: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
}

.search-right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.panel-header {
  padding: 10px 15px;
  font-weight: 500;
  border-bottom: 1px solid #e4e7ed;
  background: #fff;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-list {
  flex: 1;
  overflow-y: auto;
}

.product-item {
  display: flex;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
  transition: background 0.2s;
}

.product-item:hover {
  background: #ecf5ff;
}

.product-item.active {
  background: #ecf5ff;
  border-left: 3px solid #409eff;
}

.product-item .thumb {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 10px;
}

.product-item .info {
  flex: 1;
  overflow: hidden;
}

.product-item .title {
  font-size: 12px;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-item .price {
  color: #f56c6c;
  font-size: 12px;
  font-weight: 500;
}

.product-item .update-time {
  color: #909399;
  font-size: 10px;
  margin-top: 2px;
}

.product-item.selected {
  background: #f0f9eb;
  border-left: 3px solid #67c23a;
}

.product-item.replaced {
  background: #f5f5f5;
  opacity: 0.7;
  border-left: 3px solid #67c23a;
}

.notFond-tag {
  color: #999999;
  font-size: 10px;
  margin-top: 2px;
}

.selected-tag {
  color: #E6A23C;
  font-size: 10px;
  margin-top: 2px;
}

.replaced-tag {
  color: #67c23a;
  font-size: 10px;
  margin-top: 2px;
  font-weight: bold;
}

.replaced-count {
  color: #67c23a;
  font-size: 12px;
  font-weight: normal;
}

.result-count {
  color: #909399;
  font-size: 12px;
  margin-left: 8px;
}

.panel-pagination{
  padding: 10px 0px;
}
.panel-pagination .el-pagination__jump{
  margin-left: 12px;
}
.panel-pagination .el-pagination .btn-prev{
  padding-right: 8px;
}
.panel-pagination .el-pagination .btn-next {
  padding-left: 8px;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.selected-info {
  color: #909399;
  font-size: 13px;
  margin-right: 20px;
}

.sub-header {
  font-weight: normal;
  color: #909399;
  font-size: 12px;
  margin-left: 10px;
}

.current-title {
  color: #409eff;
  max-width: 200px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.search-result-grid {
  /*flex: 1;*/
  min-height: 0;
  overflow-y: auto;
  padding: 10px; /* 减少内边距 */
  display: grid;
  /*grid-template-columns: repeat(4, 1fr);*/
  grid-template-columns:repeat(auto-fill, minmax(160px, 1fr));
  grid-gap: 10px; /* 减少间距以容纳更多内容 */
}

.result-item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: visible;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  background: #fff;
  cursor: default;
  box-sizing: border-box;
}

.result-item:hover {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.result-item.is-selected {
  border: 2px solid #67c23a;
  box-shadow: 0 0 8px rgba(103, 194, 58, 0.3);
}

.result-item.is-selected .action-btn:first-child {
  background: #67c23a;
  color: #fff;
}

.result-item.is-selected .action-btn:first-child:hover {
  background: #85ce61;
}

.result-item.is-replaced {
  border: 2px solid #409eff;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
}

.replaced-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #409eff;
  color: #fff;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 3px;
  z-index: 1;
}

.action-btn.replace-btn {
  color: #409eff;
  font-weight: 500;
}

.action-btn.replace-btn:hover {
  background: #ecf5ff;
}

.action-btn.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background: #f5f7fa;
}

.action-btn.is-disabled:hover {
  background: #f5f7fa;
}

.result-item .img-wrapper {
  width: 100%;
  aspect-ratio: 1 / 1;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
  background-color: #f5f7fa;
  flex-shrink: 0;
}

.result-item .result-img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.result-item .result-info {
  padding: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.result-title {
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  height: 36px; /* 2 lines */
  overflow: hidden;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.result-price-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 6px;
}

.result-price-row .price {
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}

.result-price-row .consign-price {
  color: #909399;
  font-size: 12px;
  margin-left: 6px;
}

.result-tags {
  margin-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
}

.mini-tag {
  background-color: #f4f4f5;
  color: #909399;
  font-size: 10px;
  padding: 0 4px;
  border-radius: 2px;
  margin-right: 4px;
  margin-bottom: 4px;
  line-height: 16px;
  display: inline-block;
}

.result-action {
  border-top: 1px solid #ebeef5;
  background: #fff;
  display: flex;
  flex-shrink: 0;
}

.action-btn {
  flex: 1;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 13px;
  color: #606266;
  transition: all 0.3s;
  cursor: pointer;
}

.action-btn:hover {
  color: #409eff;
  background: #f5f7fa;
}

.action-btn.view-btn {
  border-left: 1px solid #ebeef5;
}

.empty-result {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  min-height: 300px;
}

.empty-result i {
  font-size: 40px;
  margin-bottom: 10px;
}

/*批量链接替换-AI替换备选链接*/
.search-result-link{
  min-height: 0;
  overflow-y: auto;
}
.search-result-link .replace-box{
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: #fff;
  gap: 6px;
  padding: 10px 10px 20px;
}
.search-result-link .replace-box .label{
  width: 90px;
}
.search-result-link .link-item{
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 10px;
}

/* 商品详情面板样式 */
.product-detail-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px 15px;
}

.search-result-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  background: #fff;
}

.search-left-panel {
}


.sku-list {
  max-height: 200px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
}

.sku-item {
  width: calc(50% - 20px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f8f9fa;
}

.sku-item:last-child {
  /*border-bottom: none;*/
}

.sku-item:nth-child(2n+0) {
  margin-left: 40px;
}

.sku-spec {
  flex: 1;
  font-size: 13px;
  color: #333;
  margin-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sku-details {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.sku-price {
  color: #f56c6c;
  font-weight: 500;
  font-size: 12px;
}

.sku-stock {
  color: #67c23a;
  font-size: 12px;
}

.sku-code {
  color: #909399;
  font-size: 11px;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no-sku-info {
  color: #909399;
  font-size: 13px;
  text-align: center;
  padding: 20px 0;
}

/* 过滤器样式 */

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
}

.filter-count {
  color: #f56c6c;
  font-weight: 500;
  margin-left: 2px;
}

.filter-panel {
  border: 1px solid #ebeef5;
 /* background: #fafbfc;*/
  padding: 8px; /* 减少内边距 */
  margin-bottom: 8px;
  margin-top: -10px;
}

/* 二级选择器 */
.cascade-selects {
 /* display: flex;*/
  gap: 8px;
  /*margin-bottom: 8px;*/ /* 减少下边距 */
  align-items: center;
  flex-wrap: wrap;
}

.category-select,
.option-select {
  min-width: 140px;
}

.category-select .el-input__inner,
.option-select .el-input__inner {
  font-size: 12px;
}

/* 待确认过滤条件 */
.pending-filters {
  margin-bottom: 6px; /* 减少间距 */
}

.pending-title {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}

.pending-tags .el-tag {
  margin: 0 4px 4px 0;
}

/* 已应用过滤条件 */
.applied-filters {
  margin-bottom: 6px; /* 减少间距 */
}

.applied-title {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}

.applied-tags .el-tag {
  margin: 0 4px 4px 0;
}

/* 操作按钮 */
.filter-actions {
  text-align: right;
  padding-top: 6px; /* 减少顶部间距 */
 /* border-top: 1px solid #ebeef5;*/
  display: flex;
/*  justify-content: flex-end;*/
  gap: 6px; /* 减少按钮间距 */
  margin-top: 8px;
}


/* 商品标题校验-黑色气泡样式 */
.popover-content {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 13px;
}
.warning-icon {
  color: #ff9900;
  margin-right: 6px;
  font-size: 16px;
}

.custom-error-popover.el-popover {
  background: #1a1a1a !important;
  border: none !important;
  padding: 8px 12px !important;
}
.custom-error-popover.el-popover[x-placement^="top"] .popper__arrow::after {
  border-top-color: #1a1a1a !important;
}
.custom-error-popover.el-popover[x-placement^="top"] .popper__arrow {
  border-top-color: transparent !important;
}

</style>

<style scoped>

.center {
  display: flex;
  flex: 1;
}

.ucenter_main {
  min-height: 500px;
}

/* 只作用于本页导入列表，强制收紧 el-table 行高，防止被全局样式二次拉伸 */
.wrap .right_con .rc_table.el-table .el-table__cell {
  padding: 10px 0 !important;
  vertical-align: middle !important;
}

.wrap .right_con .rc_table.el-table th.el-table__cell {
  padding: 10px 0 !important;
}

.wrap .right_con .rc_table.el-table th.el-table__cell > .cell {
  padding: 0 14px !important;
}

/* 再次限定每行最大高度，防止“像跑马灯一样”不断拉伸 */
.wrap .right_con .rc_table.el-table .el-table__row {
  height: 56px !important;
  max-height: 56px !important;
  overflow: hidden;
}

.wrap .right_con .rc_table.el-table .el-table__row .cell {
  line-height: 1.4;
}

/* 覆盖订单详情页对 .el-table 的全局行高设置，避免导入列表行距过大，仅作用于本页表格 */
.rc_table.el-table .el-table__cell {
  padding: 12px 0;
  vertical-align: middle;
}

.rc_table.el-table th.el-table__cell {
  padding: 12px 0;
}

.rc_table.el-table th.el-table__cell > .cell {
  padding: 0 14px;
}

/* 强制锁定导入列表各层容器宽度为 100%，防止 Element Table 计算宽度时一点点变大 */
.wrap .right_con .rc_table.el-table {
  width: 100% !important;
  max-width: 100% !important;
}

.wrap .right_con .rc_table.el-table .el-table__header-wrapper,
.wrap .right_con .rc_table.el-table .el-table__body-wrapper,
.wrap .right_con .rc_table.el-table .el-table__footer-wrapper {
  width: 100% !important;
}

.wrap .right_con .rc_table.el-table table {
  width: 100% !important;
  table-layout: fixed;
}

/* 特别控制状态列，防止内容撑开表格 */
.wrap .right_con .rc_table.el-table .el-table__body-wrapper .el-table__row .el-table__cell:nth-child(5) {
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
  overflow: hidden !important;
}

.wrap .right_con .rc_table.el-table .el-table__header-wrapper .el-table__header .el-table__cell:nth-child(5) {
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
}

/* 导入表格专用样式 */
.import_table.el-table {
  table-layout: fixed !important;
  width: 100% !important;
}

.import_table.el-table .el-table__cell {
  overflow: hidden;
  padding: 8px 0 !important;
}

.import_table.el-table .cell {
  overflow: hidden;
  padding: 0 8px;
}

/* 文本省略样式 */
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

/* 数量信息样式 */
.quantity-info {
  font-size: 12px;
  line-height: 1.2;
  width: 100%;
  overflow: hidden;
}

.quantity-info > div {
  margin: 1px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 严格控制导入表格各列宽度 */
.import_table.el-table table,
.import_table.el-table .el-table__header-wrapper table,
.import_table.el-table .el-table__body-wrapper table {
  width: auto !important; /* 允许表格根据列宽自动决定宽度，避免强制100%导致的溢出或压缩 */
  table-layout: fixed !important;
}

/* 确保导入表格容器不超出 */
.import_table.el-table {
  width: 100% !important;
  max-width: 100%;
}

/* 强制表格内容自动换行，显示完整 */
.log-title-group {
  width: 100%;
  padding: 5px 0;
}
.log-title-item {
  width: 100%;
  text-align: left;
  line-height: 1.5;
  padding: 2px 0;
  /* 核心：自动换行 + 显示全部 */
  white-space: normal !important;
  word-break: break-all !important;
  overflow: visible !important;
}

.cloud-edit-container {
  display: flex;
  height: 72vh;
  min-height: 560px;
  gap: 12px;
  overflow: hidden;
}

.cloud-edit-container.single-mode {
  display: block;
}

.cloud-edit-container.single-mode .cloud-edit-right {
  height: 100%;
}

.cloud-edit-left {
  width: 550px;
  min-width: 430px;
  border-right: 1px solid #ebeef5;
  padding-right: 12px;
  display: flex;
  flex-direction: column;
}

.cloud-edit-left .panel-header {
  padding: 0;
  border-bottom: 0;
}

.cloud-edit-left .panel-count {
  font-size: 12px;
  color: #909399;
  font-weight: 400;
}

.cloud-edit-filter {
  box-sizing: border-box;
  width: 100%;
  padding: 0 0 8px;
  margin-bottom: 8px;
  background: #fff;
  gap: 6px;
  justify-content: flex-start;
  overflow: visible;
  flex-wrap: wrap;
}

.cloud-edit-filter > span {
  flex-shrink: 0;
  margin-right: 0;
}

.cloud-edit-count {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 8px;
}

.cloud-edit-right {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 0 8px 0 4px;
}

.edit-product-list {
  flex: 1;
  overflow-y: auto;
}

.cloud-edit-pagination {
  flex-shrink: 0;
  padding: 10px 0 0;
  text-align: center;
}

.cloud-edit-pagination .el-pagination {
  white-space: normal;
}

.cloud-edit-pagination .el-pagination .btn-prev {
  padding-right: 8px;
}

.cloud-edit-pagination .el-pagination .btn-next {
  padding-left: 8px;
}

.edit-product-item {
  display: flex;
  gap: 10px;
  padding: 8px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: pointer;
  background: #fff;
}

.edit-product-item.active {
  border-color: #409eff;
  background: #ecf5ff;
}

.edit-product-thumb {
  width: 58px;
  height: 58px;
  border-radius: 4px;
  flex-shrink: 0;
}

.edit-product-info {
  flex: 1;
  min-width: 0;
}

.edit-product-title {
  font-size: 13px;
  color: #303133;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
}

.edit-product-meta {
  font-size: 12px;
  color: #909399;
  line-height: 18px;
}

.edit-image-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.edit-image-limit {
  font-size: 11px;
  color: #f56c6c;
}

.edit-image-limit.invalid {
  color: #f56c6c;
}

.edit-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.edit-image-item {
  width: 96px;
  height: 96px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.edit-image-item .el-image {
  width: 100%;
  height: 100%;
  cursor: zoom-in;
}

.edit-image-toolbar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 26px;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #fff;
}

.edit-image-toolbar i {
  cursor: pointer;
  font-size: 14px;
}

.edit-sku-table .el-input-number {
  width: 100%;
}

.sku-spec-editor {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;
  background: #fafafa;
}

.sku-spec-editor.readonly {
  background: #fff;
}

.sku-spec-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.sku-spec-name {
  width: 180px;
  flex-shrink: 0;
  font-size: 12px;
  color: #303133;
  line-height: 24px;
  font-weight: 500;
}

.sku-spec-values {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.sku-spec-value-input {
  width: 110px;
}

.sku-value-image-editor {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;
}

.sku-value-image-title {
  font-size: 13px;
  color: #303133;
  margin-bottom: 10px;
}

.sku-value-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.sku-value-image-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.sku-value-name {
  max-width: 90px;
  font-size: 12px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sku-value-thumb {
  width: 42px;
  height: 42px;
  border-radius: 4px;
  flex-shrink: 0;
  cursor: zoom-in;
}

.sku-image-empty {
  color: #909399;
  font-size: 12px;
}

.sku-disabled-text {
  color: #c0c4cc;
  text-decoration: line-through;
}

.add-sku-btn {
  margin-top: 10px;
}

.doudian-sync-panel {
  min-height: 360px;
}

.doudian-sync-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 12px 4px;
  margin-bottom: 12px;
  background: #f8fafc;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.doudian-sync-actions {
  margin-left: auto;
  margin-right: 0;
}

.doudian-sync-create-form {
  padding-right: 16px;
}

.doudian-sync-table {
  margin-top: 8px;
}

.sync-sub-text {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.group-child-panel {
  padding: 8px 20px 12px 44px;
  background: #fafbfd;
}

.group-child-empty,
.group-child-more {
  padding-top: 10px;
  text-align: center;
  color: #909399;
  font-size: 12px;
}

.group-shared-tag {
  margin-left: 6px;
}

</style>
